import { api } from './emptyApi'

export const addTagTypes = [
  'DER Alarms',
  'Distributed Energy Resources',
  'DER Destinations',
  'Connected Devices',
  'Cellular Status',
  'Connectivity',
  'DER Curtailments',
  'Device Health',
  'SIM Cards',
  'SynopLink VPN State',
  'DER Catalog',
  'DER Commands',
  'Meters',
  'notes',
  'Energy Systems',
  'EMS Placement',
  'DataSync',
  'Synop Link',
  'Network Scans',
  'Link Controls'
] as const
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getDerAlarmEvents: build.query<GetDerAlarmEventsResponse, GetDerAlarmEventsArgs>({
        query: (queryArg) => ({
          url: `/api/v1/der-alarms`,
          params: {
            from: queryArg['from'],
            to: queryArg.to,
            derAssetTypes: queryArg.derAssetTypes,
            nodeIds: queryArg.nodeIds,
            siteIds: queryArg.siteIds,
            orgIds: queryArg.orgIds,
            orgDepth: queryArg.orgDepth,
            entityId: queryArg.entityId,
            page: queryArg.page,
            count: queryArg.count,
            order: queryArg.order
          }
        }),
        providesTags: ['DER Alarms']
      }),
      createBattery: build.mutation<CreateBatteryResponse, CreateBatteryArgs>({
        query: (queryArg) => ({ url: `/api/v1/batteries`, method: 'POST', body: queryArg.createBatteryRequest }),
        invalidatesTags: ['Distributed Energy Resources']
      }),
      getBatteries: build.query<GetBatteriesResponse, GetBatteriesArgs>({
        query: (queryArg) => ({
          url: `/api/v1/batteries`,
          params: {
            nodeId: queryArg.nodeId,
            siteId: queryArg.siteId,
            includeLocalManaged: queryArg.includeLocalManaged
          }
        }),
        providesTags: ['Distributed Energy Resources']
      }),
      updateBattery: build.mutation<UpdateBatteryResponse, UpdateBatteryArgs>({
        query: (queryArg) => ({
          url: `/api/v1/batteries`,
          method: 'PATCH',
          body: queryArg.updateBatteryRequest,
          params: {
            dryRun: queryArg.dryRun
          }
        }),
        invalidatesTags: ['Distributed Energy Resources']
      }),
      getBattery: build.query<GetBatteryResponse, GetBatteryArgs>({
        query: (queryArg) => ({ url: `/api/v1/batteries/${queryArg.batteryId}` }),
        providesTags: ['Distributed Energy Resources']
      }),
      deleteBattery: build.mutation<DeleteBatteryResponse, DeleteBatteryArgs>({
        query: (queryArg) => ({ url: `/api/v1/batteries/${queryArg.batteryId}`, method: 'DELETE' }),
        invalidatesTags: ['Distributed Energy Resources']
      }),
      getBatterySnapshot: build.query<GetBatterySnapshotResponse, GetBatterySnapshotArgs>({
        query: (queryArg) => ({ url: `/api/v1/batteries/${queryArg.batteryId}/snapshot` }),
        providesTags: ['Distributed Energy Resources']
      }),
      getBatteryTransactions: build.query<GetBatteryTransactionsResponse, GetBatteryTransactionsArgs>({
        query: (queryArg) => ({
          url: `/api/v1/batteries/${queryArg.batteryId}/transactions`,
          params: {
            from: queryArg['from'],
            to: queryArg.to,
            page: queryArg.page,
            count: queryArg.count,
            sortBy: queryArg.sortBy
          }
        }),
        providesTags: ['Distributed Energy Resources']
      }),
      getBatteryUptime: build.query<GetBatteryUptimeResponse, GetBatteryUptimeArgs>({
        query: (queryArg) => ({
          url: `/api/v1/batteries/${queryArg.batteryId}/uptime`,
          params: {
            from: queryArg['from'],
            to: queryArg.to
          }
        }),
        providesTags: ['Distributed Energy Resources']
      }),
      getDers: build.query<GetDersResponse, GetDersArgs>({
        query: (queryArg) => ({
          url: `/api/v1/ders`,
          params: {
            type: queryArg['type'],
            nodeIds: queryArg.nodeIds,
            siteIds: queryArg.siteIds,
            orgIds: queryArg.orgIds,
            orgDepth: queryArg.orgDepth,
            page: queryArg.page,
            count: queryArg.count
          }
        }),
        providesTags: ['Distributed Energy Resources']
      }),
      getDerCapabilitySet: build.query<GetDerCapabilitySetResponse, GetDerCapabilitySetArgs>({
        query: (queryArg) => ({ url: `/api/v1/ders/${queryArg.derId}/capability-set` }),
        providesTags: ['Distributed Energy Resources']
      }),
      getDerSnapshot: build.query<GetDerSnapshotResponse, GetDerSnapshotArgs>({
        query: (queryArg) => ({ url: `/api/v1/ders/${queryArg.derId}/snapshot` }),
        providesTags: ['Distributed Energy Resources']
      }),
      getDerSamples: build.query<GetDerSamplesResponse, GetDerSamplesArgs>({
        query: (queryArg) => ({
          url: `/api/v1/ders/${queryArg.derId}/timespan/samples`,
          params: {
            from: queryArg['from'],
            to: queryArg.to,
            fields: queryArg.fields,
            resolution: queryArg.resolution,
            page: queryArg.page,
            count: queryArg.count,
            order: queryArg.order
          }
        }),
        providesTags: ['Distributed Energy Resources']
      }),
      getDerAggregates: build.query<GetDerAggregatesResponse, GetDerAggregatesArgs>({
        query: (queryArg) => ({
          url: `/api/v1/ders/${queryArg.derId}/timespan/aggregates`,
          params: {
            from: queryArg['from'],
            to: queryArg.to,
            fields: queryArg.fields
          }
        }),
        providesTags: ['Distributed Energy Resources']
      }),
      getDerDestination: build.query<GetDerDestinationResponse, GetDerDestinationArgs>({
        query: (queryArg) => ({ url: `/api/v1/ders/${queryArg.derId}/destination` }),
        providesTags: ['DER Destinations']
      }),
      setDerDestination: build.mutation<SetDerDestinationResponse, SetDerDestinationArgs>({
        query: (queryArg) => ({
          url: `/api/v1/ders/${queryArg.derId}/destination`,
          method: 'PUT',
          body: queryArg.updateDerDestinationRequest
        }),
        invalidatesTags: ['DER Destinations']
      }),
      listDestinations: build.query<ListDestinationsResponse, ListDestinationsArgs>({
        query: (queryArg) => ({
          url: `/api/v1/destinations`,
          params: {
            siteIds: queryArg.siteIds,
            page: queryArg.page,
            count: queryArg.count
          }
        }),
        providesTags: ['DER Destinations']
      }),
      assignDers: build.mutation<AssignDersResponse, AssignDersArgs>({
        query: (queryArg) => ({
          url: `/api/v1/destinations/${queryArg.destinationId}/assign-ders`,
          method: 'POST',
          body: queryArg.assignDersRequest
        }),
        invalidatesTags: ['DER Destinations']
      }),
      getDerSnapshots: build.query<GetDerSnapshotsResponse, GetDerSnapshotsArgs>({
        query: (queryArg) => ({
          url: `/api/v1/der-snapshots`,
          params: {
            nodeIds: queryArg.nodeIds,
            siteIds: queryArg.siteIds,
            orgIds: queryArg.orgIds,
            orgDepth: queryArg.orgDepth,
            page: queryArg.page,
            count: queryArg.count
          }
        }),
        providesTags: ['Distributed Energy Resources']
      }),
      listDeviceModels: build.query<ListDeviceModelsResponse, ListDeviceModelsArgs>({
        query: (queryArg) => ({
          url: `/api/v1/device-models`,
          params: {
            deviceType: queryArg.deviceType,
            page: queryArg.page,
            count: queryArg.count
          }
        }),
        providesTags: ['Connected Devices']
      }),
      createGenerator: build.mutation<CreateGeneratorResponse, CreateGeneratorArgs>({
        query: (queryArg) => ({ url: `/api/v1/generators`, method: 'POST', body: queryArg.createGeneratorRequest }),
        invalidatesTags: ['Distributed Energy Resources']
      }),
      getGenerators: build.query<GetGeneratorsResponse, GetGeneratorsArgs>({
        query: (queryArg) => ({
          url: `/api/v1/generators`,
          params: {
            nodeIds: queryArg.nodeIds,
            siteIds: queryArg.siteIds,
            orgIds: queryArg.orgIds,
            orgDepth: queryArg.orgDepth,
            includeLocalManaged: queryArg.includeLocalManaged,
            page: queryArg.page,
            count: queryArg.count
          }
        }),
        providesTags: ['Distributed Energy Resources']
      }),
      updateGenerator: build.mutation<UpdateGeneratorResponse, UpdateGeneratorArgs>({
        query: (queryArg) => ({ url: `/api/v1/generators`, method: 'PATCH', body: queryArg.updateGeneratorRequest }),
        invalidatesTags: ['Distributed Energy Resources']
      }),
      getGenerator: build.query<GetGeneratorResponse, GetGeneratorArgs>({
        query: (queryArg) => ({ url: `/api/v1/generators/${queryArg.generatorId}` }),
        providesTags: ['Distributed Energy Resources']
      }),
      deleteGenerator: build.mutation<DeleteGeneratorResponse, DeleteGeneratorArgs>({
        query: (queryArg) => ({ url: `/api/v1/generators/${queryArg.generatorId}`, method: 'DELETE' }),
        invalidatesTags: ['Distributed Energy Resources']
      }),
      createInverter: build.mutation<CreateInverterResponse, CreateInverterArgs>({
        query: (queryArg) => ({ url: `/api/v1/inverters`, method: 'POST', body: queryArg.createInverterRequest }),
        invalidatesTags: ['Distributed Energy Resources']
      }),
      getInverters: build.query<GetInvertersResponse, GetInvertersArgs>({
        query: (queryArg) => ({
          url: `/api/v1/inverters`,
          params: {
            nodeIds: queryArg.nodeIds,
            siteIds: queryArg.siteIds,
            orgIds: queryArg.orgIds,
            orgDepth: queryArg.orgDepth,
            page: queryArg.page,
            count: queryArg.count
          }
        }),
        providesTags: ['Distributed Energy Resources']
      }),
      updateInverter: build.mutation<UpdateInverterResponse, UpdateInverterArgs>({
        query: (queryArg) => ({ url: `/api/v1/inverters`, method: 'PATCH', body: queryArg.updateInverterRequest }),
        invalidatesTags: ['Distributed Energy Resources']
      }),
      getInverter: build.query<GetInverterResponse, GetInverterArgs>({
        query: (queryArg) => ({ url: `/api/v1/inverters/${queryArg.inverterId}` }),
        providesTags: ['Distributed Energy Resources']
      }),
      deleteInverter: build.mutation<DeleteInverterResponse, DeleteInverterArgs>({
        query: (queryArg) => ({ url: `/api/v1/inverters/${queryArg.inverterId}`, method: 'DELETE' }),
        invalidatesTags: ['Distributed Energy Resources']
      }),
      createFuelTank: build.mutation<CreateFuelTankResponse, CreateFuelTankArgs>({
        query: (queryArg) => ({ url: `/api/v1/fuel-tanks`, method: 'POST', body: queryArg.createFuelTankRequest }),
        invalidatesTags: ['Distributed Energy Resources']
      }),
      getFuelTanks: build.query<GetFuelTanksResponse, GetFuelTanksArgs>({
        query: (queryArg) => ({
          url: `/api/v1/fuel-tanks`,
          params: {
            nodeIds: queryArg.nodeIds,
            siteIds: queryArg.siteIds,
            orgIds: queryArg.orgIds,
            orgDepth: queryArg.orgDepth,
            includeLocalManaged: queryArg.includeLocalManaged,
            page: queryArg.page,
            count: queryArg.count
          }
        }),
        providesTags: ['Distributed Energy Resources']
      }),
      updateFuelTank: build.mutation<UpdateFuelTankResponse, UpdateFuelTankArgs>({
        query: (queryArg) => ({ url: `/api/v1/fuel-tanks`, method: 'PATCH', body: queryArg.updateFuelTankRequest }),
        invalidatesTags: ['Distributed Energy Resources']
      }),
      getFuelTank: build.query<GetFuelTankResponse, GetFuelTankArgs>({
        query: (queryArg) => ({ url: `/api/v1/fuel-tanks/${queryArg.fuelTankId}` }),
        providesTags: ['Distributed Energy Resources']
      }),
      deleteFuelTank: build.mutation<DeleteFuelTankResponse, DeleteFuelTankArgs>({
        query: (queryArg) => ({ url: `/api/v1/fuel-tanks/${queryArg.fuelTankId}`, method: 'DELETE' }),
        invalidatesTags: ['Distributed Energy Resources']
      }),
      createFuelTankReadings: build.mutation<CreateFuelTankReadingsResponse, CreateFuelTankReadingsArgs>({
        query: (queryArg) => ({
          url: `/api/v1/fuel-tanks/${queryArg.fuelTankId}/readings`,
          method: 'POST',
          body: queryArg.fuelLevelReadingBatch
        }),
        invalidatesTags: ['Distributed Energy Resources']
      }),
      getFuelTankSnapshot: build.query<GetFuelTankSnapshotResponse, GetFuelTankSnapshotArgs>({
        query: (queryArg) => ({ url: `/api/v1/fuel-tanks/${queryArg.fuelTankId}/snapshot` }),
        providesTags: ['Distributed Energy Resources']
      }),
      getFuelTankSamples: build.query<GetFuelTankSamplesResponse, GetFuelTankSamplesArgs>({
        query: (queryArg) => ({
          url: `/api/v1/fuel-tanks/${queryArg.fuelTankId}/timespan/samples`,
          params: {
            from: queryArg['from'],
            to: queryArg.to,
            resolution: queryArg.resolution,
            page: queryArg.page,
            count: queryArg.count,
            order: queryArg.order
          }
        }),
        providesTags: ['Distributed Energy Resources']
      }),
      getFuelTankAggregates: build.query<GetFuelTankAggregatesResponse, GetFuelTankAggregatesArgs>({
        query: (queryArg) => ({
          url: `/api/v1/fuel-tanks/${queryArg.fuelTankId}/timespan/aggregates`,
          params: {
            from: queryArg['from'],
            to: queryArg.to
          }
        }),
        providesTags: ['Distributed Energy Resources']
      }),
      createGridConnection: build.mutation<CreateGridConnectionResponse, CreateGridConnectionArgs>({
        query: (queryArg) => ({
          url: `/api/v1/grid-connections`,
          method: 'POST',
          body: queryArg.createGridConnectionRequest
        }),
        invalidatesTags: ['Distributed Energy Resources']
      }),
      getGridConnections: build.query<GetGridConnectionsResponse, GetGridConnectionsArgs>({
        query: (queryArg) => ({
          url: `/api/v1/grid-connections`,
          params: {
            nodeIds: queryArg.nodeIds,
            siteIds: queryArg.siteIds,
            orgIds: queryArg.orgIds,
            orgDepth: queryArg.orgDepth,
            includeLocalManaged: queryArg.includeLocalManaged,
            page: queryArg.page,
            count: queryArg.count
          }
        }),
        providesTags: ['Distributed Energy Resources']
      }),
      updateGridConnection: build.mutation<UpdateGridConnectionResponse, UpdateGridConnectionArgs>({
        query: (queryArg) => ({
          url: `/api/v1/grid-connections`,
          method: 'PATCH',
          body: queryArg.updateGridConnectionRequest
        }),
        invalidatesTags: ['Distributed Energy Resources']
      }),
      getGridConnection: build.query<GetGridConnectionResponse, GetGridConnectionArgs>({
        query: (queryArg) => ({ url: `/api/v1/grid-connections/${queryArg.gridConnectionId}` }),
        providesTags: ['Distributed Energy Resources']
      }),
      deleteGridConnection: build.mutation<DeleteGridConnectionResponse, DeleteGridConnectionArgs>({
        query: (queryArg) => ({ url: `/api/v1/grid-connections/${queryArg.gridConnectionId}`, method: 'DELETE' }),
        invalidatesTags: ['Distributed Energy Resources']
      }),
      createLoad: build.mutation<CreateLoadResponse, CreateLoadArgs>({
        query: (queryArg) => ({ url: `/api/v1/loads`, method: 'POST', body: queryArg.createLoadRequest }),
        invalidatesTags: ['Distributed Energy Resources']
      }),
      getLoads: build.query<GetLoadsResponse, GetLoadsArgs>({
        query: (queryArg) => ({
          url: `/api/v1/loads`,
          params: {
            nodeIds: queryArg.nodeIds,
            siteIds: queryArg.siteIds,
            orgIds: queryArg.orgIds,
            orgDepth: queryArg.orgDepth,
            includeLocalManaged: queryArg.includeLocalManaged,
            page: queryArg.page,
            count: queryArg.count
          }
        }),
        providesTags: ['Distributed Energy Resources']
      }),
      updateLoad: build.mutation<UpdateLoadResponse, UpdateLoadArgs>({
        query: (queryArg) => ({ url: `/api/v1/loads`, method: 'PATCH', body: queryArg.updateLoadRequest }),
        invalidatesTags: ['Distributed Energy Resources']
      }),
      getLoad: build.query<GetLoadResponse, GetLoadArgs>({
        query: (queryArg) => ({ url: `/api/v1/loads/${queryArg.loadId}` }),
        providesTags: ['Distributed Energy Resources']
      }),
      deleteLoad: build.mutation<DeleteLoadResponse, DeleteLoadArgs>({
        query: (queryArg) => ({ url: `/api/v1/loads/${queryArg.loadId}`, method: 'DELETE' }),
        invalidatesTags: ['Distributed Energy Resources']
      }),
      createPanel: build.mutation<CreatePanelResponse, CreatePanelArgs>({
        query: (queryArg) => ({ url: `/api/v1/electrical-panels`, method: 'POST', body: queryArg.createPanelRequest }),
        invalidatesTags: ['Distributed Energy Resources']
      }),
      getPanels: build.query<GetPanelsResponse, GetPanelsArgs>({
        query: (queryArg) => ({
          url: `/api/v1/electrical-panels`,
          params: {
            nodeIds: queryArg.nodeIds,
            siteIds: queryArg.siteIds,
            orgIds: queryArg.orgIds,
            orgDepth: queryArg.orgDepth,
            includeLocalManaged: queryArg.includeLocalManaged,
            page: queryArg.page,
            count: queryArg.count
          }
        }),
        providesTags: ['Distributed Energy Resources']
      }),
      updatePanel: build.mutation<UpdatePanelResponse, UpdatePanelArgs>({
        query: (queryArg) => ({ url: `/api/v1/electrical-panels`, method: 'PATCH', body: queryArg.updatePanelRequest }),
        invalidatesTags: ['Distributed Energy Resources']
      }),
      getPanel: build.query<GetPanelResponse, GetPanelArgs>({
        query: (queryArg) => ({ url: `/api/v1/electrical-panels/${queryArg.panelId}` }),
        providesTags: ['Distributed Energy Resources']
      }),
      deletePanel: build.mutation<DeletePanelResponse, DeletePanelArgs>({
        query: (queryArg) => ({ url: `/api/v1/electrical-panels/${queryArg.panelId}`, method: 'DELETE' }),
        invalidatesTags: ['Distributed Energy Resources']
      }),
      createSolarArray: build.mutation<CreateSolarArrayResponse, CreateSolarArrayArgs>({
        query: (queryArg) => ({ url: `/api/v1/solar-arrays`, method: 'POST', body: queryArg.createSolarArrayRequest }),
        invalidatesTags: ['Distributed Energy Resources']
      }),
      getSolarArrays: build.query<GetSolarArraysResponse, GetSolarArraysArgs>({
        query: (queryArg) => ({
          url: `/api/v1/solar-arrays`,
          params: {
            nodeIds: queryArg.nodeIds,
            siteIds: queryArg.siteIds,
            orgIds: queryArg.orgIds,
            orgDepth: queryArg.orgDepth,
            includeLocalManaged: queryArg.includeLocalManaged,
            page: queryArg.page,
            count: queryArg.count
          }
        }),
        providesTags: ['Distributed Energy Resources']
      }),
      updateSolarArray: build.mutation<UpdateSolarArrayResponse, UpdateSolarArrayArgs>({
        query: (queryArg) => ({ url: `/api/v1/solar-arrays`, method: 'PATCH', body: queryArg.updateSolarArrayRequest }),
        invalidatesTags: ['Distributed Energy Resources']
      }),
      getSolarArray: build.query<GetSolarArrayResponse, GetSolarArrayArgs>({
        query: (queryArg) => ({ url: `/api/v1/solar-arrays/${queryArg.solarArrayId}` }),
        providesTags: ['Distributed Energy Resources']
      }),
      deleteSolarArray: build.mutation<DeleteSolarArrayResponse, DeleteSolarArrayArgs>({
        query: (queryArg) => ({ url: `/api/v1/solar-arrays/${queryArg.solarArrayId}`, method: 'DELETE' }),
        invalidatesTags: ['Distributed Energy Resources']
      }),
      getLatestCellularStatus: build.query<GetLatestCellularStatusResponse, GetLatestCellularStatusArgs>({
        query: (queryArg) => ({
          url: `/api/v1/cellular-status/latest`,
          params: {
            orgId: queryArg.orgId,
            includeChildren: queryArg.includeChildren
          }
        }),
        providesTags: ['Cellular Status']
      }),
      getCellularStatus: build.query<GetCellularStatusResponse, GetCellularStatusArgs>({
        query: (queryArg) => ({ url: `/api/v1/cellular-status/${queryArg.synoplinkId}` }),
        providesTags: ['Cellular Status']
      }),
      getCellularStatusHistory: build.query<GetCellularStatusHistoryResponse, GetCellularStatusHistoryArgs>({
        query: (queryArg) => ({
          url: `/api/v1/cellular-status/${queryArg.synoplinkId}/history`,
          params: {
            from: queryArg['from'],
            to: queryArg.to
          }
        }),
        providesTags: ['Cellular Status']
      }),
      createConnectedDevice: build.mutation<CreateConnectedDeviceResponse, CreateConnectedDeviceArgs>({
        query: (queryArg) => ({
          url: `/api/v1/connected-devices`,
          method: 'POST',
          body: queryArg.createConnectedDeviceRequest
        }),
        invalidatesTags: ['Connected Devices']
      }),
      listConnectedDevices: build.query<ListConnectedDevicesResponse, ListConnectedDevicesArgs>({
        query: (queryArg) => ({
          url: `/api/v1/connected-devices`,
          params: {
            orgId: queryArg.orgId,
            siteId: queryArg.siteId,
            deviceType: queryArg.deviceType,
            energyEntityId: queryArg.energyEntityId,
            energyEntityType: queryArg.energyEntityType,
            orgDepth: queryArg.orgDepth,
            page: queryArg.page,
            count: queryArg.count
          }
        }),
        providesTags: ['Connected Devices']
      }),
      getConnectedDevice: build.query<GetConnectedDeviceResponse, GetConnectedDeviceArgs>({
        query: (queryArg) => ({ url: `/api/v1/connected-devices/${queryArg.deviceId}` }),
        providesTags: ['Connected Devices']
      }),
      updateConnectedDevice: build.mutation<UpdateConnectedDeviceResponse, UpdateConnectedDeviceArgs>({
        query: (queryArg) => ({
          url: `/api/v1/connected-devices/${queryArg.deviceId}`,
          method: 'PATCH',
          body: queryArg.updateConnectedDeviceRequest
        }),
        invalidatesTags: ['Connected Devices']
      }),
      deleteConnectedDevice: build.mutation<DeleteConnectedDeviceResponse, DeleteConnectedDeviceArgs>({
        query: (queryArg) => ({ url: `/api/v1/connected-devices/${queryArg.deviceId}`, method: 'DELETE' }),
        invalidatesTags: ['Connected Devices']
      }),
      getLatestConnectivity: build.query<GetLatestConnectivityResponse, GetLatestConnectivityArgs>({
        query: (queryArg) => ({
          url: `/api/v1/connectivity/latest`,
          params: {
            orgId: queryArg.orgId,
            includeChildren: queryArg.includeChildren
          }
        }),
        providesTags: ['Connectivity']
      }),
      getConnectivityIntervals: build.query<GetConnectivityIntervalsResponse, GetConnectivityIntervalsArgs>({
        query: (queryArg) => ({
          url: `/api/v1/connectivity/${queryArg.synoplinkId}/intervals`,
          params: {
            from: queryArg['from'],
            to: queryArg.to
          }
        }),
        providesTags: ['Connectivity']
      }),
      listCurtailments: build.query<ListCurtailmentsResponse, ListCurtailmentsArgs>({
        query: (queryArg) => ({
          url: `/api/v1/der-curtailments`,
          params: {
            derIds: queryArg.derIds,
            nodeIds: queryArg.nodeIds,
            siteIds: queryArg.siteIds,
            orgIds: queryArg.orgIds,
            orgDepth: queryArg.orgDepth,
            startsAfter: queryArg.startsAfter,
            startsBefore: queryArg.startsBefore,
            endsAfter: queryArg.endsAfter,
            endsBefore: queryArg.endsBefore,
            page: queryArg.page,
            count: queryArg.count
          }
        }),
        providesTags: ['DER Curtailments']
      }),
      getLatestDeviceHealth: build.query<GetLatestDeviceHealthResponse, GetLatestDeviceHealthArgs>({
        query: (queryArg) => ({
          url: `/api/v1/device-health/latest`,
          params: {
            orgId: queryArg.orgId,
            includeChildren: queryArg.includeChildren
          }
        }),
        providesTags: ['Device Health']
      }),
      getDeviceHealth: build.query<GetDeviceHealthResponse, GetDeviceHealthArgs>({
        query: (queryArg) => ({ url: `/api/v1/device-health/${queryArg.synoplinkId}` }),
        providesTags: ['Device Health']
      }),
      getDeviceHealthHistory: build.query<GetDeviceHealthHistoryResponse, GetDeviceHealthHistoryArgs>({
        query: (queryArg) => ({
          url: `/api/v1/device-health/${queryArg.synoplinkId}/history`,
          params: {
            from: queryArg['from'],
            to: queryArg.to,
            page: queryArg.page,
            count: queryArg.count
          }
        }),
        providesTags: ['Device Health']
      }),
      syncSimCards: build.mutation<SyncSimCardsResponse, SyncSimCardsArgs>({
        query: (queryArg) => ({ url: `/api/v1/sim-cards`, method: 'POST', body: queryArg.items }),
        invalidatesTags: ['SIM Cards']
      }),
      retireSimCard: build.mutation<RetireSimCardResponse, RetireSimCardArgs>({
        query: (queryArg) => ({ url: `/api/v1/sim-cards/${queryArg.simCardId}`, method: 'DELETE' }),
        invalidatesTags: ['SIM Cards']
      }),
      getVpnStateSnapshots: build.query<GetVpnStateSnapshotsResponse, GetVpnStateSnapshotsArgs>({
        query: (queryArg) => ({
          url: `/api/v1/synoplinks/${queryArg.synoplinkId}/vpn-state-snapshots`,
          params: {
            from: queryArg['from'],
            to: queryArg.to,
            page: queryArg.page,
            count: queryArg.count
          }
        }),
        providesTags: ['SynopLink VPN State']
      }),
      listMakes: build.query<ListMakesResponse, ListMakesArgs>({
        query: (queryArg) => ({
          url: `/api/v1/der-makes`,
          params: {
            nameContains: queryArg.nameContains,
            assetType: queryArg.assetType,
            page: queryArg.page,
            count: queryArg.count
          }
        }),
        providesTags: ['DER Catalog']
      }),
      createMake: build.mutation<CreateMakeResponse, CreateMakeArgs>({
        query: (queryArg) => ({ url: `/api/v1/der-makes`, method: 'POST', body: queryArg.createDerMakeRequest }),
        invalidatesTags: ['DER Catalog']
      }),
      getMake: build.query<GetMakeResponse, GetMakeArgs>({
        query: (queryArg) => ({ url: `/api/v1/der-makes/${queryArg.makeId}` }),
        providesTags: ['DER Catalog']
      }),
      updateMake: build.mutation<UpdateMakeResponse, UpdateMakeArgs>({
        query: (queryArg) => ({
          url: `/api/v1/der-makes/${queryArg.makeId}`,
          method: 'PATCH',
          body: queryArg.updateDerMakeRequest
        }),
        invalidatesTags: ['DER Catalog']
      }),
      deleteMake: build.mutation<DeleteMakeResponse, DeleteMakeArgs>({
        query: (queryArg) => ({
          url: `/api/v1/der-makes/${queryArg.makeId}`,
          method: 'DELETE',
          params: {
            force: queryArg.force
          }
        }),
        invalidatesTags: ['DER Catalog']
      }),
      bulkUpsertMakes: build.mutation<BulkUpsertMakesResponse, BulkUpsertMakesArgs>({
        query: (queryArg) => ({ url: `/api/v1/der-makes:bulk-upsert`, method: 'POST', body: queryArg.items }),
        invalidatesTags: ['DER Catalog']
      }),
      listModels: build.query<ListModelsResponse, ListModelsArgs>({
        query: (queryArg) => ({
          url: `/api/v1/der-models`,
          params: {
            assetType: queryArg.assetType,
            makeId: queryArg.makeId,
            nameContains: queryArg.nameContains,
            page: queryArg.page,
            count: queryArg.count
          }
        }),
        providesTags: ['DER Catalog']
      }),
      createModel: build.mutation<CreateModelResponse, CreateModelArgs>({
        query: (queryArg) => ({ url: `/api/v1/der-models`, method: 'POST', body: queryArg.createDerModelRequest }),
        invalidatesTags: ['DER Catalog']
      }),
      getModel: build.query<GetModelResponse, GetModelArgs>({
        query: (queryArg) => ({ url: `/api/v1/der-models/${queryArg.modelId}` }),
        providesTags: ['DER Catalog']
      }),
      updateModel: build.mutation<UpdateModelResponse, UpdateModelArgs>({
        query: (queryArg) => ({
          url: `/api/v1/der-models/${queryArg.modelId}`,
          method: 'PATCH',
          body: queryArg.updateDerModelRequest
        }),
        invalidatesTags: ['DER Catalog']
      }),
      deleteModel: build.mutation<DeleteModelResponse, DeleteModelArgs>({
        query: (queryArg) => ({
          url: `/api/v1/der-models/${queryArg.modelId}`,
          method: 'DELETE',
          params: {
            force: queryArg.force
          }
        }),
        invalidatesTags: ['DER Catalog']
      }),
      bulkUpsertModels: build.mutation<BulkUpsertModelsResponse, BulkUpsertModelsArgs>({
        query: (queryArg) => ({ url: `/api/v1/der-models:bulk-upsert`, method: 'POST', body: queryArg.items }),
        invalidatesTags: ['DER Catalog']
      }),
      listAllCapabilitySets: build.query<ListAllCapabilitySetsResponse, ListAllCapabilitySetsArgs>({
        query: (queryArg) => ({
          url: `/api/v1/der-capability-sets`,
          params: {
            assetType: queryArg.assetType,
            page: queryArg.page,
            count: queryArg.count
          }
        }),
        providesTags: ['DER Catalog']
      }),
      listCapabilitySets: build.query<ListCapabilitySetsResponse, ListCapabilitySetsArgs>({
        query: (queryArg) => ({
          url: `/api/v1/der-models/${queryArg.modelId}/capability-sets`,
          params: {
            publishedOnly: queryArg.publishedOnly,
            page: queryArg.page,
            count: queryArg.count
          }
        }),
        providesTags: ['DER Catalog']
      }),
      createCapabilitySet: build.mutation<CreateCapabilitySetResponse, CreateCapabilitySetArgs>({
        query: (queryArg) => ({
          url: `/api/v1/der-models/${queryArg.modelId}/capability-sets`,
          method: 'POST',
          body: queryArg.params
        }),
        invalidatesTags: ['DER Catalog']
      }),
      getCapabilitySet: build.query<GetCapabilitySetResponse, GetCapabilitySetArgs>({
        query: (queryArg) => ({ url: `/api/v1/der-capability-sets/${queryArg.capId}` }),
        providesTags: ['DER Catalog']
      }),
      updateCapabilitySet: build.mutation<UpdateCapabilitySetResponse, UpdateCapabilitySetArgs>({
        query: (queryArg) => ({
          url: `/api/v1/der-capability-sets/${queryArg.capId}`,
          method: 'PATCH',
          body: queryArg.updateDerCapabilitySetRequest
        }),
        invalidatesTags: ['DER Catalog']
      }),
      deleteCapabilitySet: build.mutation<DeleteCapabilitySetResponse, DeleteCapabilitySetArgs>({
        query: (queryArg) => ({ url: `/api/v1/der-capability-sets/${queryArg.capId}`, method: 'DELETE' }),
        invalidatesTags: ['DER Catalog']
      }),
      submitDerCommand: build.mutation<SubmitDerCommandResponse, SubmitDerCommandArgs>({
        query: (queryArg) => ({
          url: `/api/v1/ders/${queryArg.derId}/commands`,
          method: 'POST',
          body: queryArg.derCommandRequest
        }),
        invalidatesTags: ['DER Commands']
      }),
      readDerCommandCapabilities: build.query<ReadDerCommandCapabilitiesResponse, ReadDerCommandCapabilitiesArgs>({
        query: (queryArg) => ({ url: `/api/v1/ders/${queryArg.derId}/commands/capabilities` }),
        providesTags: ['DER Commands']
      }),
      readDerCommand: build.query<ReadDerCommandResponse, ReadDerCommandArgs>({
        query: (queryArg) => ({ url: `/api/v1/ders/${queryArg.derId}/commands/${queryArg.requestId}` }),
        providesTags: ['DER Commands']
      }),
      createCurtailmentOverride: build.mutation<CreateCurtailmentOverrideResponse, CreateCurtailmentOverrideArgs>({
        query: (queryArg) => ({
          url: `/api/v1/der-curtailment-overrides`,
          method: 'POST',
          body: queryArg.curtailmentOverrideRequest
        }),
        invalidatesTags: ['DER Curtailments']
      }),
      revokeCurtailmentOverride: build.mutation<RevokeCurtailmentOverrideResponse, RevokeCurtailmentOverrideArgs>({
        query: (queryArg) => ({ url: `/api/v1/der-curtailment-overrides/${queryArg.eventId}`, method: 'DELETE' }),
        invalidatesTags: ['DER Curtailments']
      }),
      getMeterSnapshot: build.query<GetMeterSnapshotResponse, GetMeterSnapshotArgs>({
        query: (queryArg) => ({ url: `/api/v1/meters/${queryArg.meterId}/snapshot` }),
        providesTags: ['Meters']
      }),
      getMeterSamples: build.query<GetMeterSamplesResponse, GetMeterSamplesArgs>({
        query: (queryArg) => ({
          url: `/api/v1/meters/${queryArg.meterId}/timespan/samples`,
          params: {
            from: queryArg['from'],
            to: queryArg.to,
            resolution: queryArg.resolution,
            page: queryArg.page,
            count: queryArg.count,
            order: queryArg.order
          }
        }),
        providesTags: ['Meters']
      }),
      createNote: build.mutation<CreateNoteResponse, CreateNoteArgs>({
        query: (queryArg) => ({ url: `/api/v1/notes`, method: 'POST', body: queryArg.createNoteRequest }),
        invalidatesTags: ['notes']
      }),
      getNotes: build.query<GetNotesResponse, GetNotesArgs>({
        query: (queryArg) => ({
          url: `/api/v1/notes`,
          params: {
            entityType: queryArg.entityType,
            entityId: queryArg.entityId,
            orgIds: queryArg.orgIds,
            orgDepth: queryArg.orgDepth,
            isPinned: queryArg.isPinned,
            page: queryArg.page,
            count: queryArg.count
          }
        }),
        providesTags: ['notes']
      }),
      getNote: build.query<GetNoteResponse, GetNoteArgs>({
        query: (queryArg) => ({ url: `/api/v1/notes/${queryArg.noteId}` }),
        providesTags: ['notes']
      }),
      updateNote: build.mutation<UpdateNoteResponse, UpdateNoteArgs>({
        query: (queryArg) => ({
          url: `/api/v1/notes/${queryArg.noteId}`,
          method: 'PATCH',
          body: queryArg.updateNoteRequest
        }),
        invalidatesTags: ['notes']
      }),
      deleteNote: build.mutation<DeleteNoteResponse, DeleteNoteArgs>({
        query: (queryArg) => ({ url: `/api/v1/notes/${queryArg.noteId}`, method: 'DELETE' }),
        invalidatesTags: ['notes']
      }),
      createEnergySystem: build.mutation<CreateEnergySystemResponse, CreateEnergySystemArgs>({
        query: (queryArg) => ({
          url: `/api/v1/energy-systems`,
          method: 'POST',
          body: queryArg.createEnergySystemRequest
        }),
        invalidatesTags: ['Energy Systems']
      }),
      listEnergySystems: build.query<ListEnergySystemsResponse, ListEnergySystemsArgs>({
        query: (queryArg) => ({
          url: `/api/v1/energy-systems`,
          params: {
            orgId: queryArg.orgId,
            siteId: queryArg.siteId,
            entityType: queryArg.entityType,
            entityId: queryArg.entityId,
            orgDepth: queryArg.orgDepth,
            page: queryArg.page,
            count: queryArg.count
          }
        }),
        providesTags: ['Energy Systems']
      }),
      getSitePowerFlowSummary: build.query<GetSitePowerFlowSummaryResponse, GetSitePowerFlowSummaryArgs>({
        query: (queryArg) => ({
          url: `/api/v1/energy-systems/power-flow-summary`,
          params: {
            siteId: queryArg.siteId,
            page: queryArg.page,
            count: queryArg.count
          }
        }),
        providesTags: ['Energy Systems']
      }),
      getSitePowerFlowHistory: build.query<GetSitePowerFlowHistoryResponse, GetSitePowerFlowHistoryArgs>({
        query: (queryArg) => ({
          url: `/api/v1/energy-systems/power-flow-history`,
          params: {
            from: queryArg['from'],
            to: queryArg.to,
            siteId: queryArg.siteId,
            resolution: queryArg.resolution
          }
        }),
        providesTags: ['Energy Systems']
      }),
      listUnplacedAssets: build.query<ListUnplacedAssetsResponse, ListUnplacedAssetsArgs>({
        query: (queryArg) => ({
          url: `/api/v1/energy-systems/unplaced-assets`,
          params: {
            siteId: queryArg.siteId,
            page: queryArg.page,
            count: queryArg.count
          }
        }),
        providesTags: ['Energy Systems']
      }),
      getEnergySystem: build.query<GetEnergySystemResponse, GetEnergySystemArgs>({
        query: (queryArg) => ({ url: `/api/v1/energy-systems/${queryArg.systemId}` }),
        providesTags: ['Energy Systems']
      }),
      updateEnergySystem: build.mutation<UpdateEnergySystemResponse, UpdateEnergySystemArgs>({
        query: (queryArg) => ({
          url: `/api/v1/energy-systems/${queryArg.systemId}`,
          method: 'PATCH',
          body: queryArg.updateEnergySystemRequest
        }),
        invalidatesTags: ['Energy Systems']
      }),
      deleteEnergySystem: build.mutation<DeleteEnergySystemResponse, DeleteEnergySystemArgs>({
        query: (queryArg) => ({ url: `/api/v1/energy-systems/${queryArg.systemId}`, method: 'DELETE' }),
        invalidatesTags: ['Energy Systems']
      }),
      addEnergySystemComponent: build.mutation<AddEnergySystemComponentResponse, AddEnergySystemComponentArgs>({
        query: (queryArg) => ({
          url: `/api/v1/energy-systems/${queryArg.systemId}/components`,
          method: 'POST',
          body: queryArg.createEnergySystemComponentRequest
        }),
        invalidatesTags: ['Energy Systems']
      }),
      replaceEnergySystemComponent: build.mutation<
        ReplaceEnergySystemComponentResponse,
        ReplaceEnergySystemComponentArgs
      >({
        query: (queryArg) => ({
          url: `/api/v1/energy-systems/${queryArg.systemId}/components/${queryArg.componentId}`,
          method: 'PATCH',
          body: queryArg.updateEnergySystemComponentRequest
        }),
        invalidatesTags: ['Energy Systems']
      }),
      deleteEnergySystemComponent: build.mutation<DeleteEnergySystemComponentResponse, DeleteEnergySystemComponentArgs>(
        {
          query: (queryArg) => ({
            url: `/api/v1/energy-systems/${queryArg.systemId}/components/${queryArg.componentId}`,
            method: 'DELETE'
          }),
          invalidatesTags: ['Energy Systems']
        }
      ),
      applyEnergySystemChanges: build.mutation<ApplyEnergySystemChangesResponse, ApplyEnergySystemChangesArgs>({
        query: (queryArg) => ({
          url: `/api/v1/energy-systems/${queryArg.systemId}/changes`,
          method: 'POST',
          body: queryArg.applyEnergySystemChangesRequest
        }),
        invalidatesTags: ['Energy Systems']
      }),
      addEnergySystemMeasurementPoint: build.mutation<
        AddEnergySystemMeasurementPointResponse,
        AddEnergySystemMeasurementPointArgs
      >({
        query: (queryArg) => ({
          url: `/api/v1/energy-systems/${queryArg.systemId}/measurement-points`,
          method: 'POST',
          body: queryArg.createEnergySystemMeasurementPointRequest
        }),
        invalidatesTags: ['Energy Systems']
      }),
      replaceEnergySystemMeasurementPoint: build.mutation<
        ReplaceEnergySystemMeasurementPointResponse,
        ReplaceEnergySystemMeasurementPointArgs
      >({
        query: (queryArg) => ({
          url: `/api/v1/energy-systems/${queryArg.systemId}/measurement-points/${queryArg.measurementPointId}`,
          method: 'PATCH',
          body: queryArg.updateEnergySystemMeasurementPointRequest
        }),
        invalidatesTags: ['Energy Systems']
      }),
      deleteEnergySystemMeasurementPoint: build.mutation<
        DeleteEnergySystemMeasurementPointResponse,
        DeleteEnergySystemMeasurementPointArgs
      >({
        query: (queryArg) => ({
          url: `/api/v1/energy-systems/${queryArg.systemId}/measurement-points/${queryArg.measurementPointId}`,
          method: 'DELETE'
        }),
        invalidatesTags: ['Energy Systems']
      }),
      getEnergySystemCoverage: build.query<GetEnergySystemCoverageResponse, GetEnergySystemCoverageArgs>({
        query: (queryArg) => ({ url: `/api/v1/energy-systems/${queryArg.systemId}/coverage` }),
        providesTags: ['Energy Systems']
      }),
      getEnergySystemLayout: build.query<GetEnergySystemLayoutResponse, GetEnergySystemLayoutArgs>({
        query: (queryArg) => ({ url: `/api/v1/energy-systems/${queryArg.systemId}/layout` }),
        providesTags: ['Energy Systems']
      }),
      replaceEnergySystemLayout: build.mutation<ReplaceEnergySystemLayoutResponse, ReplaceEnergySystemLayoutArgs>({
        query: (queryArg) => ({
          url: `/api/v1/energy-systems/${queryArg.systemId}/layout`,
          method: 'PUT',
          body: queryArg.replaceEnergySystemLayoutRequest
        }),
        invalidatesTags: ['Energy Systems']
      }),
      resetEnergySystemLayout: build.mutation<ResetEnergySystemLayoutResponse, ResetEnergySystemLayoutArgs>({
        query: (queryArg) => ({ url: `/api/v1/energy-systems/${queryArg.systemId}/layout`, method: 'DELETE' }),
        invalidatesTags: ['Energy Systems']
      }),
      addEnergySystemConnection: build.mutation<AddEnergySystemConnectionResponse, AddEnergySystemConnectionArgs>({
        query: (queryArg) => ({
          url: `/api/v1/energy-systems/${queryArg.systemId}/connections`,
          method: 'POST',
          body: queryArg.createEnergySystemConnectionRequest
        }),
        invalidatesTags: ['Energy Systems']
      }),
      deleteEnergySystemConnection: build.mutation<
        DeleteEnergySystemConnectionResponse,
        DeleteEnergySystemConnectionArgs
      >({
        query: (queryArg) => ({
          url: `/api/v1/energy-systems/${queryArg.systemId}/connections/${queryArg.connectionId}`,
          method: 'DELETE'
        }),
        invalidatesTags: ['Energy Systems']
      }),
      listEnergySystemArchetypes: build.query<ListEnergySystemArchetypesResponse, ListEnergySystemArchetypesArgs>({
        query: (queryArg) => ({
          url: `/api/v1/energy-system-archetypes`,
          params: {
            page: queryArg.page,
            count: queryArg.count
          }
        }),
        providesTags: ['Energy Systems']
      }),
      listEmsPlacements: build.query<ListEmsPlacementsResponse, ListEmsPlacementsArgs>({
        query: (queryArg) => ({
          url: `/api/v1/ems-placements`,
          params: {
            managedBy: queryArg.managedBy
          }
        }),
        providesTags: ['EMS Placement']
      }),
      getEmsPlacement: build.query<GetEmsPlacementResponse, GetEmsPlacementArgs>({
        query: (queryArg) => ({ url: `/api/v1/ems-placements/${queryArg.siteId}` }),
        providesTags: ['EMS Placement']
      }),
      setEmsPlacement: build.mutation<SetEmsPlacementResponse, SetEmsPlacementArgs>({
        query: (queryArg) => ({
          url: `/api/v1/ems-placements/${queryArg.siteId}`,
          method: 'PUT',
          body: queryArg.setEmsPlacementRequest
        }),
        invalidatesTags: ['EMS Placement']
      }),
      sweepScope: build.mutation<SweepScopeResponse, SweepScopeArgs>({
        query: (queryArg) => ({ url: `/api/v1/datasync/scopes/${queryArg.scopeId}/sweep`, method: 'POST' }),
        invalidatesTags: ['DataSync']
      }),
      getSynoplinks: build.query<GetSynoplinksResponse, GetSynoplinksArgs>({
        query: (queryArg) => ({
          url: `/api/v2/synoplinks`,
          params: {
            orgId: queryArg.orgId,
            siteId: queryArg.siteId,
            thingName: queryArg.thingName,
            serialNumber: queryArg.serialNumber,
            lifecycleStatus: queryArg.lifecycleStatus,
            includeChildren: queryArg.includeChildren,
            page: queryArg.page,
            count: queryArg.count
          }
        }),
        providesTags: ['Synop Link']
      }),
      createSynoplink: build.mutation<CreateSynoplinkResponse, CreateSynoplinkArgs>({
        query: (queryArg) => ({ url: `/api/v2/synoplinks`, method: 'POST', body: queryArg.createSynopLinkRequest }),
        invalidatesTags: ['Synop Link']
      }),
      getSynoplink: build.query<GetSynoplinkResponse, GetSynoplinkArgs>({
        query: (queryArg) => ({ url: `/api/v2/synoplinks/${queryArg.synoplinkId}` }),
        providesTags: ['Synop Link']
      }),
      updateSynoplink: build.mutation<UpdateSynoplinkResponse, UpdateSynoplinkArgs>({
        query: (queryArg) => ({
          url: `/api/v2/synoplinks/${queryArg.synoplinkId}`,
          method: 'PATCH',
          body: queryArg.updateSynopLinkRequest
        }),
        invalidatesTags: ['Synop Link']
      }),
      getConnectivityStatus: build.query<GetConnectivityStatusResponse, GetConnectivityStatusArgs>({
        query: (queryArg) => ({ url: `/api/v2/synoplinks/${queryArg.synoplinkId}/connectivity-status` }),
        providesTags: ['Synop Link']
      }),
      getDevicesBySynoplink: build.query<GetDevicesBySynoplinkResponse, GetDevicesBySynoplinkArgs>({
        query: (queryArg) => ({ url: `/api/v2/synoplinks/${queryArg.synoplinkId}/connected-devices` }),
        providesTags: ['Synop Link', 'Connected Devices']
      }),
      getComponentConfig: build.query<GetComponentConfigResponse, GetComponentConfigArgs>({
        query: (queryArg) => ({ url: `/api/v2/synoplinks/${queryArg.synoplinkId}/component-config` }),
        providesTags: ['Synop Link']
      }),
      getOcppProxyConfig: build.query<GetOcppProxyConfigResponse, GetOcppProxyConfigArgs>({
        query: (queryArg) => ({ url: `/api/v2/synoplinks/${queryArg.synoplinkId}/component-config/ocpp-proxy` }),
        providesTags: ['Synop Link']
      }),
      replaceOcppProxyConfig: build.mutation<ReplaceOcppProxyConfigResponse, ReplaceOcppProxyConfigArgs>({
        query: (queryArg) => ({
          url: `/api/v2/synoplinks/${queryArg.synoplinkId}/component-config/ocpp-proxy`,
          method: 'PUT',
          body: queryArg.updateOcppProxyConfigRequest
        }),
        invalidatesTags: ['Synop Link']
      }),
      deleteOcppProxyConfig: build.mutation<DeleteOcppProxyConfigResponse, DeleteOcppProxyConfigArgs>({
        query: (queryArg) => ({
          url: `/api/v2/synoplinks/${queryArg.synoplinkId}/component-config/ocpp-proxy`,
          method: 'DELETE'
        }),
        invalidatesTags: ['Synop Link']
      }),
      getOcppProxyMode: build.query<GetOcppProxyModeResponse, GetOcppProxyModeArgs>({
        query: (queryArg) => ({ url: `/api/v2/synoplinks/${queryArg.synoplinkId}/ocpp-proxy-mode` }),
        providesTags: ['Synop Link']
      }),
      replaceOcppProxyMode: build.mutation<ReplaceOcppProxyModeResponse, ReplaceOcppProxyModeArgs>({
        query: (queryArg) => ({
          url: `/api/v2/synoplinks/${queryArg.synoplinkId}/ocpp-proxy-mode`,
          method: 'PUT',
          body: queryArg.updateOcppProxyModeRequest
        }),
        invalidatesTags: ['Synop Link']
      }),
      replaceOptimizerConfig: build.mutation<ReplaceOptimizerConfigResponse, ReplaceOptimizerConfigArgs>({
        query: (queryArg) => ({
          url: `/api/v2/synoplinks/${queryArg.synoplinkId}/component-config/optimizer`,
          method: 'PUT',
          body: queryArg.updateOptimizerConfigRequest
        }),
        invalidatesTags: ['Synop Link']
      }),
      deleteOptimizerConfig: build.mutation<DeleteOptimizerConfigResponse, DeleteOptimizerConfigArgs>({
        query: (queryArg) => ({
          url: `/api/v2/synoplinks/${queryArg.synoplinkId}/component-config/optimizer`,
          method: 'DELETE'
        }),
        invalidatesTags: ['Synop Link']
      }),
      replaceSitePowerManagerConfig: build.mutation<
        ReplaceSitePowerManagerConfigResponse,
        ReplaceSitePowerManagerConfigArgs
      >({
        query: (queryArg) => ({
          url: `/api/v2/synoplinks/${queryArg.synoplinkId}/component-config/site-power-manager`,
          method: 'PUT',
          body: queryArg.updateSitePowerManagerConfigRequest
        }),
        invalidatesTags: ['Synop Link']
      }),
      deleteSitePowerManagerConfig: build.mutation<
        DeleteSitePowerManagerConfigResponse,
        DeleteSitePowerManagerConfigArgs
      >({
        query: (queryArg) => ({
          url: `/api/v2/synoplinks/${queryArg.synoplinkId}/component-config/site-power-manager`,
          method: 'DELETE'
        }),
        invalidatesTags: ['Synop Link']
      }),
      replaceRelayConfig: build.mutation<ReplaceRelayConfigResponse, ReplaceRelayConfigArgs>({
        query: (queryArg) => ({
          url: `/api/v2/synoplinks/${queryArg.synoplinkId}/component-config/relay`,
          method: 'PUT',
          body: queryArg.updateRelayConfigRequest
        }),
        invalidatesTags: ['Synop Link']
      }),
      deleteRelayConfig: build.mutation<DeleteRelayConfigResponse, DeleteRelayConfigArgs>({
        query: (queryArg) => ({
          url: `/api/v2/synoplinks/${queryArg.synoplinkId}/component-config/relay`,
          method: 'DELETE'
        }),
        invalidatesTags: ['Synop Link']
      }),
      replaceDefaultPowerPlannerConfig: build.mutation<
        ReplaceDefaultPowerPlannerConfigResponse,
        ReplaceDefaultPowerPlannerConfigArgs
      >({
        query: (queryArg) => ({
          url: `/api/v2/synoplinks/${queryArg.synoplinkId}/component-config/default-power-planner`,
          method: 'PUT',
          body: queryArg.updateDefaultPowerPlannerConfigRequest
        }),
        invalidatesTags: ['Synop Link']
      }),
      deleteDefaultPowerPlannerConfig: build.mutation<
        DeleteDefaultPowerPlannerConfigResponse,
        DeleteDefaultPowerPlannerConfigArgs
      >({
        query: (queryArg) => ({
          url: `/api/v2/synoplinks/${queryArg.synoplinkId}/component-config/default-power-planner`,
          method: 'DELETE'
        }),
        invalidatesTags: ['Synop Link']
      }),
      replaceAstroConfig: build.mutation<ReplaceAstroConfigResponse, ReplaceAstroConfigArgs>({
        query: (queryArg) => ({
          url: `/api/v2/synoplinks/${queryArg.synoplinkId}/component-config/astro`,
          method: 'PUT',
          body: queryArg.updateAstroConfigRequest
        }),
        invalidatesTags: ['Synop Link']
      }),
      deleteAstroConfig: build.mutation<DeleteAstroConfigResponse, DeleteAstroConfigArgs>({
        query: (queryArg) => ({
          url: `/api/v2/synoplinks/${queryArg.synoplinkId}/component-config/astro`,
          method: 'DELETE'
        }),
        invalidatesTags: ['Synop Link']
      }),
      getLoggingPosture: build.query<GetLoggingPostureResponse, GetLoggingPostureArgs>({
        query: (queryArg) => ({ url: `/api/v2/synoplinks/${queryArg.synoplinkId}/logging-posture` }),
        providesTags: ['Synop Link']
      }),
      replaceLoggingPosture: build.mutation<ReplaceLoggingPostureResponse, ReplaceLoggingPostureArgs>({
        query: (queryArg) => ({
          url: `/api/v2/synoplinks/${queryArg.synoplinkId}/logging-posture`,
          method: 'PUT',
          body: queryArg.updateLoggingPostureRequest
        }),
        invalidatesTags: ['Synop Link']
      }),
      deleteLoggingPosture: build.mutation<DeleteLoggingPostureResponse, DeleteLoggingPostureArgs>({
        query: (queryArg) => ({ url: `/api/v2/synoplinks/${queryArg.synoplinkId}/logging-posture`, method: 'DELETE' }),
        invalidatesTags: ['Synop Link']
      }),
      getNetworkConfig: build.query<GetNetworkConfigResponse, GetNetworkConfigArgs>({
        query: (queryArg) => ({ url: `/api/v2/synoplinks/${queryArg.synoplinkId}/network-config` }),
        providesTags: ['Synop Link']
      }),
      replaceNetworkConfig: build.mutation<ReplaceNetworkConfigResponse, ReplaceNetworkConfigArgs>({
        query: (queryArg) => ({
          url: `/api/v2/synoplinks/${queryArg.synoplinkId}/network-config`,
          method: 'PUT',
          body: queryArg.updateNetworkConfigRequest
        }),
        invalidatesTags: ['Synop Link']
      }),
      deleteNetworkConfig: build.mutation<DeleteNetworkConfigResponse, DeleteNetworkConfigArgs>({
        query: (queryArg) => ({ url: `/api/v2/synoplinks/${queryArg.synoplinkId}/network-config`, method: 'DELETE' }),
        invalidatesTags: ['Synop Link']
      }),
      triggerNetworkScan: build.mutation<TriggerNetworkScanResponse, TriggerNetworkScanArgs>({
        query: (queryArg) => ({
          url: `/api/v2/synoplinks/${queryArg.synoplinkId}/network-scans`,
          method: 'POST',
          body: queryArg.networkScanRequest
        }),
        invalidatesTags: ['Network Scans']
      }),
      listNetworkScans: build.query<ListNetworkScansResponse, ListNetworkScansArgs>({
        query: (queryArg) => ({
          url: `/api/v2/synoplinks/${queryArg.synoplinkId}/network-scans`,
          params: {
            page: queryArg.page,
            count: queryArg.count
          }
        }),
        providesTags: ['Network Scans']
      }),
      getDeviceReachability: build.query<GetDeviceReachabilityResponse, GetDeviceReachabilityArgs>({
        query: (queryArg) => ({ url: `/api/v2/synoplinks/${queryArg.synoplinkId}/device-reachability` }),
        providesTags: ['Network Scans']
      }),
      getNetworkScan: build.query<GetNetworkScanResponse, GetNetworkScanArgs>({
        query: (queryArg) => ({ url: `/api/v2/synoplinks/${queryArg.synoplinkId}/network-scans/${queryArg.scanId}` }),
        providesTags: ['Network Scans']
      }),
      getNetworkScanReport: build.query<GetNetworkScanReportResponse, GetNetworkScanReportArgs>({
        query: (queryArg) => ({
          url: `/api/v2/synoplinks/${queryArg.synoplinkId}/network-scans/${queryArg.scanId}/report`
        }),
        providesTags: ['Network Scans']
      }),
      getBatteriesV2: build.query<GetBatteriesV2Response, GetBatteriesV2Args>({
        query: (queryArg) => ({
          url: `/api/v2/batteries`,
          params: {
            nodeIds: queryArg.nodeIds,
            siteIds: queryArg.siteIds,
            orgIds: queryArg.orgIds,
            orgDepth: queryArg.orgDepth,
            includeLocalManaged: queryArg.includeLocalManaged,
            page: queryArg.page,
            count: queryArg.count
          }
        }),
        providesTags: ['Distributed Energy Resources']
      }),
      getLinkControls: build.query<GetLinkControlsResponse, GetLinkControlsArgs>({
        query: (queryArg) => ({ url: `/api/v2/synoplinks/${queryArg.synoplinkId}/link-controls` }),
        providesTags: ['Link Controls']
      }),
      updateLinkControls: build.mutation<UpdateLinkControlsResponse, UpdateLinkControlsArgs>({
        query: (queryArg) => ({
          url: `/api/v2/synoplinks/${queryArg.synoplinkId}/link-controls`,
          method: 'PATCH',
          body: queryArg.linkControlsUpdate,
          params: {
            dryRun: queryArg.dryRun
          }
        }),
        invalidatesTags: ['Link Controls']
      }),
      updateLinkControlsPanel: build.mutation<UpdateLinkControlsPanelResponse, UpdateLinkControlsPanelArgs>({
        query: (queryArg) => ({
          url: `/api/v2/synoplinks/${queryArg.synoplinkId}/link-controls/panels/${queryArg.panelId}`,
          method: 'PATCH',
          body: queryArg.linkControlsPanelUpdate,
          params: {
            dryRun: queryArg.dryRun
          }
        }),
        invalidatesTags: ['Link Controls']
      }),
      putLinkControlsPanel: build.mutation<PutLinkControlsPanelResponse, PutLinkControlsPanelArgs>({
        query: (queryArg) => ({
          url: `/api/v2/synoplinks/${queryArg.synoplinkId}/link-controls/panels/${queryArg.panelId}`,
          method: 'PUT',
          body: queryArg.linkControlsPanelPut,
          params: {
            dryRun: queryArg.dryRun
          }
        }),
        invalidatesTags: ['Link Controls']
      }),
      deleteLinkControlsPanel: build.mutation<DeleteLinkControlsPanelResponse, DeleteLinkControlsPanelArgs>({
        query: (queryArg) => ({
          url: `/api/v2/synoplinks/${queryArg.synoplinkId}/link-controls/panels/${queryArg.panelId}`,
          method: 'DELETE',
          params: {
            dryRun: queryArg.dryRun
          }
        }),
        invalidatesTags: ['Link Controls']
      }),
      putManagedCharger: build.mutation<PutManagedChargerResponse, PutManagedChargerArgs>({
        query: (queryArg) => ({
          url: `/api/v2/synoplinks/${queryArg.synoplinkId}/link-controls/managed-chargers/${queryArg.chargerId}`,
          method: 'PUT',
          body: queryArg.managedChargerPut,
          params: {
            dryRun: queryArg.dryRun
          }
        }),
        invalidatesTags: ['Link Controls']
      }),
      updateManagedCharger: build.mutation<UpdateManagedChargerResponse, UpdateManagedChargerArgs>({
        query: (queryArg) => ({
          url: `/api/v2/synoplinks/${queryArg.synoplinkId}/link-controls/managed-chargers/${queryArg.chargerId}`,
          method: 'PATCH',
          body: queryArg.managedChargerUpdate,
          params: {
            dryRun: queryArg.dryRun
          }
        }),
        invalidatesTags: ['Link Controls']
      }),
      deleteManagedCharger: build.mutation<DeleteManagedChargerResponse, DeleteManagedChargerArgs>({
        query: (queryArg) => ({
          url: `/api/v2/synoplinks/${queryArg.synoplinkId}/link-controls/managed-chargers/${queryArg.chargerId}`,
          method: 'DELETE',
          params: {
            dryRun: queryArg.dryRun
          }
        }),
        invalidatesTags: ['Link Controls']
      }),
      updateLinkControlsFallbacks: build.mutation<UpdateLinkControlsFallbacksResponse, UpdateLinkControlsFallbacksArgs>(
        {
          query: (queryArg) => ({
            url: `/api/v2/synoplinks/${queryArg.synoplinkId}/link-controls/fallbacks`,
            method: 'PATCH',
            body: queryArg.linkControlsFallbacksUpdate,
            params: {
              dryRun: queryArg.dryRun
            }
          }),
          invalidatesTags: ['Link Controls']
        }
      ),
      importLinkControls: build.mutation<ImportLinkControlsResponse, ImportLinkControlsArgs>({
        query: (queryArg) => ({
          url: `/api/v2/synoplinks/${queryArg.synoplinkId}/link-controls/import`,
          method: 'POST',
          body: queryArg.body,
          params: {
            dryRun: queryArg.dryRun,
            overwrite: queryArg.overwrite,
            createMissingPanels: queryArg.createMissingPanels
          }
        }),
        invalidatesTags: ['Link Controls']
      }),
      replaceRawLinkControls: build.mutation<ReplaceRawLinkControlsResponse, ReplaceRawLinkControlsArgs>({
        query: (queryArg) => ({
          url: `/api/v2/synoplinks/${queryArg.synoplinkId}/link-controls/raw`,
          method: 'PUT',
          body: queryArg.document,
          params: {
            dryRun: queryArg.dryRun
          }
        }),
        invalidatesTags: ['Link Controls']
      }),
      createProbe: build.mutation<CreateProbeResponse, CreateProbeArgs>({
        query: (queryArg) => ({
          url: `/api/v2/synoplinks/${queryArg.synoplinkId}/probes`,
          method: 'POST',
          body: queryArg.probeRequest
        }),
        invalidatesTags: ['Synop Link']
      }),
      getProbe: build.query<GetProbeResponse, GetProbeArgs>({
        query: (queryArg) => ({ url: `/api/v2/synoplinks/${queryArg.synoplinkId}/probes/${queryArg.probeId}` }),
        providesTags: ['Synop Link']
      })
    }),
    overrideExisting: false
  })
export { injectedRtkApi as enhancedApi }
export type GetDerAlarmEventsResponse = /** status 200 Successful Response */ PagedResponseAlarmEventModel
export type GetDerAlarmEventsArgs = {
  /** Filter for events with timestamps after this time */
  from?: string
  /** Filter for events with timestamps before this time */
  to?: string
  /** Filter for alarm events from DERs of the given asset type(s) */
  derAssetTypes?: DerAssetType[]
  /** Filter for alarm events from DERs associated with the given node IDs */
  nodeIds?: string[]
  /** Filter for alarm events from DERs associated with the given site IDs */
  siteIds?: string[]
  /** Filter for alarm events from DERs associated with the given organization IDs */
  orgIds?: string[]
  /** Maximum depth of child organizations to include when filtering by org */
  orgDepth?: number
  /** Filter alarm events by DER asset ID. The alarms of inverters that connect this DER to the grid are included, each under its own entityId. */
  entityId?: string
  /** Page number (0-indexed) */
  page?: number
  /** Number of items per page */
  count?: number
  /** Sort direction */
  order?: SortDirection
}
export type CreateBatteryResponse = /** status 200 Successful Response */ BatteryModel
export type CreateBatteryArgs = {
  createBatteryRequest: CreateBatteryRequest
}
export type GetBatteriesResponse = /** status 200 Successful Response */ BatteryModel[]
export type GetBatteriesArgs = {
  /** Filter for batteries associated with the given node ID */
  nodeId?: string
  /** Filter for batteries associated with the given site ID */
  siteId?: string
  /** Include locally managed batteries in results */
  includeLocalManaged?: boolean
}
export type UpdateBatteryResponse = /** status 200 Successful Response */ BatteryModel
export type UpdateBatteryArgs = {
  /** When true, runs every check and answers the battery as the update would leave it, without saving anything or changing the Link. A refusal is the same one the update would meet. desiredState and powerBoostStatus are null in the answer, since the Link is sent nothing. */
  dryRun?: boolean
  updateBatteryRequest: UpdateBatteryRequest
}
export type GetBatteryResponse = /** status 200 Successful Response */ BatteryModel
export type GetBatteryArgs = {
  batteryId: string
}
export type DeleteBatteryResponse = unknown
export type DeleteBatteryArgs = {
  batteryId: string
}
export type GetBatterySnapshotResponse = /** status 200 Successful Response */ DerSnapshotResponse
export type GetBatterySnapshotArgs = {
  batteryId: string
}
export type GetBatteryTransactionsResponse = /** status 200 Successful Response */ PagedResponseBatteryTransactionModel
export type GetBatteryTransactionsArgs = {
  batteryId: string
  /** Filter for events with timestamps after this time */
  from?: string
  /** Filter for events with timestamps before this time */
  to?: string
  /** Page number (0-indexed) */
  page?: number
  /** Number of items per page */
  count?: number
  /** Field to sort by */
  sortBy?: string
}
export type GetBatteryUptimeResponse = /** status 200 Successful Response */ BatteryUptimeModel
export type GetBatteryUptimeArgs = {
  batteryId: string
  /** Filter for events with timestamps after this time */
  from?: string
  /** Filter for events with timestamps before this time */
  to?: string
}
export type GetDersResponse = /** status 200 Successful Response */ PagedResponseDerSummaryModel
export type GetDersArgs = {
  /** Filter for DERs of the given asset type(s) */
  type?: DerAssetType[]
  /** Filter for DERs associated with the given node IDs */
  nodeIds?: string[]
  /** Filter for DERs associated with the given site IDs */
  siteIds?: string[]
  /** Filter for DERs associated with the given organization IDs */
  orgIds?: string[]
  /** Maximum depth of child organizations to include when filtering by org */
  orgDepth?: number
  /** Page number (0-indexed) */
  page?: number
  /** Number of items per page */
  count?: number
}
export type GetDerCapabilitySetResponse = /** status 200 Successful Response */ DerAssetCapabilitySetResponse
export type GetDerCapabilitySetArgs = {
  /** Unique identifier of the DER asset */
  derId: string
}
export type GetDerSnapshotResponse = /** status 200 Successful Response */ DerSnapshotResponse
export type GetDerSnapshotArgs = {
  /** Unique identifier of the DER asset */
  derId: string
}
export type GetDerSamplesResponse = /** status 200 Successful Response */ PagedResponseSample
export type GetDerSamplesArgs = {
  /** Unique identifier of the DER asset */
  derId: string
  /** Filter for events with timestamps after this time */
  from?: string
  /** Filter for events with timestamps before this time */
  to?: string
  /** Metrics to include per sample. */
  fields?: DerSampleField[]
  /** Bucket size for the time-series rollup. */
  resolution?: '1m' | '5m' | '15m' | '1h'
  /** Page number (0-indexed) */
  page?: number
  /** Number of items per page */
  count?: number
  /** Sort direction */
  order?: SortDirection
}
export type GetDerAggregatesResponse = /** status 200 Successful Response */ DerAggregatesResponseModel
export type GetDerAggregatesArgs = {
  /** Unique identifier of the DER asset */
  derId: string
  /** Filter for events with timestamps after this time */
  from?: string
  /** Filter for events with timestamps before this time */
  to?: string
  /** Aggregated metrics to include in the response. */
  fields?: DerAggregateField[]
}
export type GetDerDestinationResponse = /** status 200 Successful Response */ DerDestinationAssignmentModel
export type GetDerDestinationArgs = {
  derId: string
}
export type SetDerDestinationResponse = /** status 200 Successful Response */ DerDestinationAssignmentModel
export type SetDerDestinationArgs = {
  derId: string
  updateDerDestinationRequest: UpdateDerDestinationRequest
}
export type ListDestinationsResponse = /** status 200 Successful Response */ PagedResponseDerDestinationModel
export type ListDestinationsArgs = {
  /** Sites whose destinations to list. Required — destination pick-lists are always site-scoped. */
  siteIds: string[]
  /** Page number (0-indexed) */
  page?: number
  /** Number of items per page */
  count?: number
}
export type AssignDersResponse = /** status 200 Successful Response */ AssignDersResult
export type AssignDersArgs = {
  destinationId: string
  assignDersRequest: AssignDersRequest
}
export type GetDerSnapshotsResponse = /** status 200 Successful Response */ PagedResponseDerSnapshotListItem
export type GetDerSnapshotsArgs = {
  /** Filter for DERs associated with the given node IDs */
  nodeIds?: string[]
  /** Filter for DERs associated with the given site IDs */
  siteIds?: string[]
  /** Filter for DERs associated with the given organization IDs */
  orgIds?: string[]
  /** Maximum depth of child organizations to include when filtering by org */
  orgDepth?: number
  /** Page number (0-indexed) */
  page?: number
  /** Number of items per page */
  count?: number
}
export type ListDeviceModelsResponse = /** status 200 Successful Response */ PagedResponseDeviceModelSpec
export type ListDeviceModelsArgs = {
  /** Return only the models available for this kind of device */
  deviceType?: ConnectedDeviceType | null
  /** Page number (0-indexed) */
  page?: number
  /** Number of items per page */
  count?: number
}
export type CreateGeneratorResponse = /** status 200 Successful Response */ GeneratorModel
export type CreateGeneratorArgs = {
  createGeneratorRequest: CreateGeneratorRequest
}
export type GetGeneratorsResponse = /** status 200 Successful Response */ PagedResponseGeneratorModel
export type GetGeneratorsArgs = {
  /** Filter for generators associated with the given node IDs */
  nodeIds?: string[]
  /** Filter for generators associated with the given site IDs */
  siteIds?: string[]
  /** Filter for generators associated with the given organization IDs */
  orgIds?: string[]
  /** Maximum depth of child organizations to include when filtering by org */
  orgDepth?: number
  /** Include locally managed generators in results */
  includeLocalManaged?: boolean
  /** Page number (0-indexed) */
  page?: number
  /** Number of items per page */
  count?: number
}
export type UpdateGeneratorResponse = /** status 200 Successful Response */ GeneratorModel
export type UpdateGeneratorArgs = {
  updateGeneratorRequest: UpdateGeneratorRequest
}
export type GetGeneratorResponse = /** status 200 Successful Response */ GeneratorModel
export type GetGeneratorArgs = {
  generatorId: string
}
export type DeleteGeneratorResponse = unknown
export type DeleteGeneratorArgs = {
  generatorId: string
}
export type CreateInverterResponse = /** status 200 Successful Response */ InverterModel
export type CreateInverterArgs = {
  createInverterRequest: CreateInverterRequest
}
export type GetInvertersResponse = /** status 200 Successful Response */ PagedResponseInverterModel
export type GetInvertersArgs = {
  /** Filter for inverters associated with the given node IDs */
  nodeIds?: string[]
  /** Filter for inverters associated with the given site IDs */
  siteIds?: string[]
  /** Filter for inverters associated with the given organization IDs */
  orgIds?: string[]
  /** Maximum depth of child organizations to include when filtering by org */
  orgDepth?: number
  /** Page number (0-indexed) */
  page?: number
  /** Number of items per page */
  count?: number
}
export type UpdateInverterResponse = /** status 200 Successful Response */ InverterModel
export type UpdateInverterArgs = {
  updateInverterRequest: UpdateInverterRequest
}
export type GetInverterResponse = /** status 200 Successful Response */ InverterModel
export type GetInverterArgs = {
  inverterId: string
}
export type DeleteInverterResponse = unknown
export type DeleteInverterArgs = {
  inverterId: string
}
export type CreateFuelTankResponse = /** status 200 Successful Response */ FuelTankModel
export type CreateFuelTankArgs = {
  createFuelTankRequest: CreateFuelTankRequest
}
export type GetFuelTanksResponse = /** status 200 Successful Response */ PagedResponseFuelTankModel
export type GetFuelTanksArgs = {
  /** Filter for fuel tanks associated with the given node IDs */
  nodeIds?: string[]
  /** Filter for fuel tanks associated with the given site IDs */
  siteIds?: string[]
  /** Filter for fuel tanks associated with the given organization IDs */
  orgIds?: string[]
  /** Maximum depth of child organizations to include when filtering by org */
  orgDepth?: number
  /** Include locally managed fuel tanks in results */
  includeLocalManaged?: boolean
  /** Page number (0-indexed) */
  page?: number
  /** Number of items per page */
  count?: number
}
export type UpdateFuelTankResponse = /** status 200 Successful Response */ FuelTankModel
export type UpdateFuelTankArgs = {
  updateFuelTankRequest: UpdateFuelTankRequest
}
export type GetFuelTankResponse = /** status 200 Successful Response */ FuelTankModel
export type GetFuelTankArgs = {
  /** Unique identifier of the fuel tank */
  fuelTankId: string
}
export type DeleteFuelTankResponse = unknown
export type DeleteFuelTankArgs = {
  /** Unique identifier of the fuel tank */
  fuelTankId: string
}
export type CreateFuelTankReadingsResponse = /** status 200 Successful Response */ FuelLevelIngestionResponse
export type CreateFuelTankReadingsArgs = {
  /** Unique identifier of the fuel tank */
  fuelTankId: string
  fuelLevelReadingBatch: FuelLevelReadingBatch
}
export type GetFuelTankSnapshotResponse = /** status 200 Successful Response */ FuelTankSnapshotResponse
export type GetFuelTankSnapshotArgs = {
  /** Unique identifier of the fuel tank */
  fuelTankId: string
}
export type GetFuelTankSamplesResponse = /** status 200 Successful Response */ PagedResponseFuelTankSample
export type GetFuelTankSamplesArgs = {
  /** Unique identifier of the fuel tank */
  fuelTankId: string
  /** Filter for events with timestamps after this time */
  from?: string
  /** Filter for events with timestamps before this time */
  to?: string
  /** Bucket size for the time-series rollup. */
  resolution?: '1m' | '5m' | '15m' | '1h'
  /** Page number (0-indexed) */
  page?: number
  /** Number of items per page */
  count?: number
  /** Sort direction */
  order?: SortDirection
}
export type GetFuelTankAggregatesResponse = /** status 200 Successful Response */ FuelTankAggregatesResponse
export type GetFuelTankAggregatesArgs = {
  /** Unique identifier of the fuel tank */
  fuelTankId: string
  /** Filter for events with timestamps after this time */
  from?: string
  /** Filter for events with timestamps before this time */
  to?: string
}
export type CreateGridConnectionResponse = /** status 200 Successful Response */ GridConnectionModel
export type CreateGridConnectionArgs = {
  createGridConnectionRequest: CreateGridConnectionRequest
}
export type GetGridConnectionsResponse = /** status 200 Successful Response */ PagedResponseGridConnectionModel
export type GetGridConnectionsArgs = {
  /** Filter for grid connections associated with the given node IDs */
  nodeIds?: string[]
  /** Filter for grid connections associated with the given site IDs */
  siteIds?: string[]
  /** Filter for grid connections associated with the given organization IDs */
  orgIds?: string[]
  /** Maximum depth of child organizations to include when filtering by org */
  orgDepth?: number
  /** Include locally managed grid connections in results */
  includeLocalManaged?: boolean
  /** Page number (0-indexed) */
  page?: number
  /** Number of items per page */
  count?: number
}
export type UpdateGridConnectionResponse = /** status 200 Successful Response */ GridConnectionModel
export type UpdateGridConnectionArgs = {
  updateGridConnectionRequest: UpdateGridConnectionRequest
}
export type GetGridConnectionResponse = /** status 200 Successful Response */ GridConnectionModel
export type GetGridConnectionArgs = {
  gridConnectionId: string
}
export type DeleteGridConnectionResponse = unknown
export type DeleteGridConnectionArgs = {
  gridConnectionId: string
}
export type CreateLoadResponse = /** status 200 Successful Response */ LoadModel
export type CreateLoadArgs = {
  createLoadRequest: CreateLoadRequest
}
export type GetLoadsResponse = /** status 200 Successful Response */ PagedResponseLoadModel
export type GetLoadsArgs = {
  /** Filter for loads associated with the given node IDs */
  nodeIds?: string[]
  /** Filter for loads associated with the given site IDs */
  siteIds?: string[]
  /** Filter for loads associated with the given organization IDs */
  orgIds?: string[]
  /** Maximum depth of child organizations to include when filtering by org */
  orgDepth?: number
  /** Include locally managed loads in results */
  includeLocalManaged?: boolean
  /** Page number (0-indexed) */
  page?: number
  /** Number of items per page */
  count?: number
}
export type UpdateLoadResponse = /** status 200 Successful Response */ LoadModel
export type UpdateLoadArgs = {
  updateLoadRequest: UpdateLoadRequest
}
export type GetLoadResponse = /** status 200 Successful Response */ LoadModel
export type GetLoadArgs = {
  loadId: string
}
export type DeleteLoadResponse = unknown
export type DeleteLoadArgs = {
  loadId: string
}
export type CreatePanelResponse = /** status 200 Successful Response */ PanelModel
export type CreatePanelArgs = {
  createPanelRequest: CreatePanelRequest
}
export type GetPanelsResponse = /** status 200 Successful Response */ PagedResponsePanelModel
export type GetPanelsArgs = {
  /** Filter for panels associated with the given node IDs */
  nodeIds?: string[]
  /** Filter for panels associated with the given site IDs */
  siteIds?: string[]
  /** Filter for panels associated with the given organization IDs */
  orgIds?: string[]
  /** Maximum depth of child organizations to include when filtering by org */
  orgDepth?: number
  /** Include locally managed panels in results */
  includeLocalManaged?: boolean
  /** Page number (0-indexed) */
  page?: number
  /** Number of items per page */
  count?: number
}
export type UpdatePanelResponse = /** status 200 Successful Response */ PanelModel
export type UpdatePanelArgs = {
  updatePanelRequest: UpdatePanelRequest
}
export type GetPanelResponse = /** status 200 Successful Response */ PanelModel
export type GetPanelArgs = {
  panelId: string
}
export type DeletePanelResponse = unknown
export type DeletePanelArgs = {
  panelId: string
}
export type CreateSolarArrayResponse = /** status 200 Successful Response */ SolarArrayModel
export type CreateSolarArrayArgs = {
  createSolarArrayRequest: CreateSolarArrayRequest
}
export type GetSolarArraysResponse = /** status 200 Successful Response */ PagedResponseSolarArrayModel
export type GetSolarArraysArgs = {
  /** Filter for solar arrays associated with the given node IDs */
  nodeIds?: string[]
  /** Filter for solar arrays associated with the given site IDs */
  siteIds?: string[]
  /** Filter for solar arrays associated with the given organization IDs */
  orgIds?: string[]
  /** Maximum depth of child organizations to include when filtering by org */
  orgDepth?: number
  /** Include locally managed solar arrays in results */
  includeLocalManaged?: boolean
  /** Page number (0-indexed) */
  page?: number
  /** Number of items per page */
  count?: number
}
export type UpdateSolarArrayResponse = /** status 200 Successful Response */ SolarArrayModel
export type UpdateSolarArrayArgs = {
  updateSolarArrayRequest: UpdateSolarArrayRequest
}
export type GetSolarArrayResponse = /** status 200 Successful Response */ SolarArrayModel
export type GetSolarArrayArgs = {
  solarArrayId: string
}
export type DeleteSolarArrayResponse = unknown
export type DeleteSolarArrayArgs = {
  solarArrayId: string
}
export type GetLatestCellularStatusResponse = /** status 200 Successful Response */ CellularStatusModel[]
export type GetLatestCellularStatusArgs = {
  /** Filter for one or more organizations */
  orgId?: string[]
  /** Include data from child organizations */
  includeChildren?: boolean
}
export type GetCellularStatusResponse = /** status 200 Successful Response */ CellularStatusModel
export type GetCellularStatusArgs = {
  synoplinkId: string
}
export type GetCellularStatusHistoryResponse = /** status 200 Successful Response */ CellularStatusHistoryResponse
export type GetCellularStatusHistoryArgs = {
  synoplinkId: string
  /** Filter for events with timestamps after this time */
  from?: string
  /** Filter for events with timestamps before this time */
  to?: string
}
export type CreateConnectedDeviceResponse = /** status 200 Successful Response */ ConnectedDeviceModel
export type CreateConnectedDeviceArgs = {
  createConnectedDeviceRequest: CreateConnectedDeviceRequest
}
export type ListConnectedDevicesResponse = /** status 200 Successful Response */ PagedResponseConnectedDeviceModel
export type ListConnectedDevicesArgs = {
  /** Filter for connected devices owned by these organization IDs. When omitted, results are scoped to organizations the caller can access. */
  orgId?: string[]
  /** Filter for connected devices at these site IDs */
  siteId?: string[]
  /** Filter for connected devices of the given device type */
  deviceType?: ConnectedDeviceType
  /** Filter for connected devices linked to the given energy entity ID */
  energyEntityId?: string
  /** Filter for connected devices linked to the given energy entity type */
  energyEntityType?: EnergyEntityType
  /** Maximum depth of child organizations to include when filtering by org */
  orgDepth?: number
  /** Page number (0-indexed) */
  page?: number
  /** Number of items per page */
  count?: number
}
export type GetConnectedDeviceResponse = /** status 200 Successful Response */ ConnectedDeviceModel
export type GetConnectedDeviceArgs = {
  deviceId: string
}
export type UpdateConnectedDeviceResponse = /** status 200 Successful Response */ ConnectedDeviceModel
export type UpdateConnectedDeviceArgs = {
  deviceId: string
  updateConnectedDeviceRequest: UpdateConnectedDeviceRequest
}
export type DeleteConnectedDeviceResponse = unknown
export type DeleteConnectedDeviceArgs = {
  deviceId: string
}
export type GetLatestConnectivityResponse = /** status 200 Successful Response */ SynopLinkConnectivityLatestModel[]
export type GetLatestConnectivityArgs = {
  /** Filter for one or more organizations */
  orgId?: string[]
  /** Include data from child organizations */
  includeChildren?: boolean
}
export type GetConnectivityIntervalsResponse = /** status 200 Successful Response */ ConnectivityIntervalsResponse
export type GetConnectivityIntervalsArgs = {
  synoplinkId: string
  /** Filter for events with timestamps after this time */
  from?: string
  /** Filter for events with timestamps before this time */
  to?: string
}
export type ListCurtailmentsResponse = /** status 200 Successful Response */ PagedResponseCurtailmentWindowModel
export type ListCurtailmentsArgs = {
  /** Filter curtailments for the given DER IDs */
  derIds?: string[]
  /** Filter curtailments on the given node IDs */
  nodeIds?: string[]
  /** Filter curtailments at the given site IDs */
  siteIds?: string[]
  /** Filter curtailments in the given organization IDs */
  orgIds?: string[]
  /** Maximum depth of child organizations to include when filtering by org */
  orgDepth?: number
  /** Only return curtailments that started at or after this time. */
  startsAfter?: string
  /** Only return curtailments that started before this time. */
  startsBefore?: string
  /** Only return curtailments that ended at or after this time, or are still active. */
  endsAfter?: string
  /** Only return curtailments that ended before this time. Still-active curtailments are excluded. */
  endsBefore?: string
  /** Page number (0-indexed) */
  page?: number
  /** Number of items per page */
  count?: number
}
export type GetLatestDeviceHealthResponse = /** status 200 Successful Response */ DeviceHealthSummaryModel[]
export type GetLatestDeviceHealthArgs = {
  /** Filter for one or more organizations */
  orgId?: string[]
  /** Include data from child organizations */
  includeChildren?: boolean
}
export type GetDeviceHealthResponse = /** status 200 Successful Response */ DeviceHealthSnapshotModel
export type GetDeviceHealthArgs = {
  /** Unique identifier of the SynopLink */
  synoplinkId: string
}
export type GetDeviceHealthHistoryResponse =
  /** status 200 Successful Response */ PagedResponseDeviceHealthSnapshotModel
export type GetDeviceHealthHistoryArgs = {
  /** Unique identifier of the SynopLink */
  synoplinkId: string
  /** Filter for events with timestamps after this time */
  from?: string
  /** Filter for events with timestamps before this time */
  to?: string
  /** Page number (0-indexed) */
  page?: number
  /** Number of items per page */
  count?: number
}
export type SyncSimCardsResponse = /** status 200 Successful Response */ SimCardSyncResponse
export type SyncSimCardsArgs = {
  items: SimCardUpsertItem[]
}
export type RetireSimCardResponse = /** status 200 Successful Response */ SimCardModel
export type RetireSimCardArgs = {
  simCardId: string
}
export type GetVpnStateSnapshotsResponse = /** status 200 Successful Response */ PagedResponseVpnStateSnapshotModel
export type GetVpnStateSnapshotsArgs = {
  synoplinkId: string
  /** Filter for events with timestamps after this time */
  from?: string
  /** Filter for events with timestamps before this time */
  to?: string
  /** Page number (0-indexed) */
  page?: number
  /** Number of items per page */
  count?: number
}
export type ListMakesResponse = /** status 200 Successful Response */ PagedResponseDerMakeModel
export type ListMakesArgs = {
  nameContains?: string
  assetType?: DerAssetType
  /** Page number (0-indexed) */
  page?: number
  /** Number of items per page */
  count?: number
}
export type CreateMakeResponse = /** status 201 Successful Response */ DerMakeModel
export type CreateMakeArgs = {
  createDerMakeRequest: CreateDerMakeRequest
}
export type GetMakeResponse = /** status 200 Successful Response */ DerMakeModel
export type GetMakeArgs = {
  makeId: string
}
export type UpdateMakeResponse = /** status 200 Successful Response */ DerMakeModel
export type UpdateMakeArgs = {
  makeId: string
  updateDerMakeRequest: UpdateDerMakeRequest
}
export type DeleteMakeResponse = unknown
export type DeleteMakeArgs = {
  makeId: string
  force?: boolean
}
export type BulkUpsertMakesResponse = /** status 200 Successful Response */ {
  [key: string]: string
}[]
export type BulkUpsertMakesArgs = {
  items: CreateDerMakeRequest[]
}
export type ListModelsResponse = /** status 200 Successful Response */ PagedResponseDerModelModel
export type ListModelsArgs = {
  assetType: DerAssetType
  makeId?: string
  nameContains?: string
  /** Page number (0-indexed) */
  page?: number
  /** Number of items per page */
  count?: number
}
export type CreateModelResponse = /** status 201 Successful Response */ DerModelModel
export type CreateModelArgs = {
  createDerModelRequest: CreateDerModelRequest
}
export type GetModelResponse = /** status 200 Successful Response */ DerModelModel
export type GetModelArgs = {
  modelId: string
}
export type UpdateModelResponse = /** status 200 Successful Response */ DerModelModel
export type UpdateModelArgs = {
  modelId: string
  updateDerModelRequest: UpdateDerModelRequest
}
export type DeleteModelResponse = unknown
export type DeleteModelArgs = {
  modelId: string
  force?: boolean
}
export type BulkUpsertModelsResponse = /** status 200 Successful Response */ {
  [key: string]: string
}[]
export type BulkUpsertModelsArgs = {
  items: CreateDerModelRequest[]
}
export type ListAllCapabilitySetsResponse =
  /** status 200 Successful Response */ PagedResponseAnnotatedUnionBessCapabilitySetModelGensetCapabilitySetModelPanelCapabilitySetModelInverterCapabilitySetModelFieldInfoannotationNoneTyperequiredTruediscriminatorassettype
export type ListAllCapabilitySetsArgs = {
  assetType: DerAssetType
  /** Page number (0-indexed) */
  page?: number
  /** Number of items per page */
  count?: number
}
export type ListCapabilitySetsResponse =
  /** status 200 Successful Response */ PagedResponseAnnotatedUnionBessCapabilitySetModelGensetCapabilitySetModelPanelCapabilitySetModelInverterCapabilitySetModelFieldInfoannotationNoneTyperequiredTruediscriminatorassettype
export type ListCapabilitySetsArgs = {
  modelId: string
  publishedOnly?: boolean
  /** Page number (0-indexed) */
  page?: number
  /** Number of items per page */
  count?: number
}
export type CreateCapabilitySetResponse = /** status 201 Successful Response */
  | BessCapabilitySetModel
  | GensetCapabilitySetModel
  | PanelCapabilitySetModel
  | InverterCapabilitySetModel
export type CreateCapabilitySetArgs = {
  modelId: string
  params:
    | CreateBessCapabilitySetRequest
    | CreateGensetCapabilitySetRequest
    | CreatePanelCapabilitySetRequest
    | CreateInverterCapabilitySetRequest
}
export type GetCapabilitySetResponse = /** status 200 Successful Response */
  | BessCapabilitySetModel
  | GensetCapabilitySetModel
  | PanelCapabilitySetModel
  | InverterCapabilitySetModel
export type GetCapabilitySetArgs = {
  capId: string
}
export type UpdateCapabilitySetResponse = /** status 200 Successful Response */
  | BessCapabilitySetModel
  | GensetCapabilitySetModel
  | PanelCapabilitySetModel
  | InverterCapabilitySetModel
export type UpdateCapabilitySetArgs = {
  capId: string
  updateDerCapabilitySetRequest: UpdateDerCapabilitySetRequest
}
export type DeleteCapabilitySetResponse = unknown
export type DeleteCapabilitySetArgs = {
  capId: string
}
export type SubmitDerCommandResponse = /** status 200 Successful Response */ DerCommandOutcome
export type SubmitDerCommandArgs = {
  /** Unique identifier of the DER asset */
  derId: string
  derCommandRequest: DerCommandRequest
}
export type ReadDerCommandCapabilitiesResponse = /** status 200 Successful Response */ DerCommandCapabilities
export type ReadDerCommandCapabilitiesArgs = {
  /** Unique identifier of the DER asset */
  derId: string
}
export type ReadDerCommandResponse = /** status 200 Successful Response */ DerCommandOutcome
export type ReadDerCommandArgs = {
  /** Unique identifier of the DER asset */
  derId: string
  /** The command's ``requestId``, as its outcome returned it */
  requestId: string
}
export type CreateCurtailmentOverrideResponse = /** status 200 Successful Response */ CurtailmentOverrideResponse
export type CreateCurtailmentOverrideArgs = {
  curtailmentOverrideRequest: CurtailmentOverrideRequest
}
export type RevokeCurtailmentOverrideResponse = /** status 200 Successful Response */ CurtailmentOverrideRevokeResponse
export type RevokeCurtailmentOverrideArgs = {
  eventId: string
}
export type GetMeterSnapshotResponse = /** status 200 Successful Response */ MeterSnapshotResponse
export type GetMeterSnapshotArgs = {
  /** Unique identifier of the meter's connected device */
  meterId: string
}
export type GetMeterSamplesResponse = /** status 200 Successful Response */ PagedResponseMeterSample
export type GetMeterSamplesArgs = {
  /** Unique identifier of the meter's connected device */
  meterId: string
  /** Filter for events with timestamps after this time */
  from?: string
  /** Filter for events with timestamps before this time */
  to?: string
  /** Bucket size for the time-series rollup. */
  resolution?: '1m' | '5m' | '15m' | '1h'
  /** Page number (0-indexed) */
  page?: number
  /** Number of items per page */
  count?: number
  /** Sort direction */
  order?: SortDirection
}
export type CreateNoteResponse = /** status 200 Successful Response */ NoteModel
export type CreateNoteArgs = {
  createNoteRequest: CreateNoteRequest
}
export type GetNotesResponse = /** status 200 Successful Response */ PagedResponseNoteModel
export type GetNotesArgs = {
  /** Filter for notes attached to entities of this type */
  entityType?: EntityType
  /** Filter for notes attached to this entity ID */
  entityId?: string
  /** Filter for notes associated with the given organization IDs */
  orgIds?: string[]
  /** Maximum depth of child organizations to include when filtering by org */
  orgDepth?: number
  /** Filter for pinned (or unpinned) notes */
  isPinned?: boolean
  /** Page number (0-indexed) */
  page?: number
  /** Number of items per page */
  count?: number
}
export type GetNoteResponse = /** status 200 Successful Response */ NoteModel
export type GetNoteArgs = {
  noteId: string
}
export type UpdateNoteResponse = /** status 200 Successful Response */ NoteModel
export type UpdateNoteArgs = {
  noteId: string
  updateNoteRequest: UpdateNoteRequest
}
export type DeleteNoteResponse = unknown
export type DeleteNoteArgs = {
  noteId: string
}
export type CreateEnergySystemResponse = /** status 201 Successful Response */ EnergySystemDetailModel
export type CreateEnergySystemArgs = {
  createEnergySystemRequest: CreateEnergySystemRequest
}
export type ListEnergySystemsResponse = /** status 200 Successful Response */ PagedResponseEnergySystemModel
export type ListEnergySystemsArgs = {
  /** Return energy systems owned by these organization IDs. When omitted, results are scoped to organizations the caller can access. */
  orgId?: string[]
  /** Return energy systems at this site ID */
  siteId?: string
  /** Kind of asset to look up, together with ``entityId``. Returns the energy systems holding a component that stands for that asset, each reporting which of its components do. */
  entityType?: ComponentEntityType
  /** Identifier of the asset to look up, in the identifier space of the kind named by ``entityType``. Must be given together with it. */
  entityId?: string
  /** Maximum depth of child organizations to include when filtering by org */
  orgDepth?: number
  /** Page number (0-indexed) */
  page?: number
  /** Number of items per page */
  count?: number
}
export type GetSitePowerFlowSummaryResponse =
  /** status 200 Successful Response */ PagedResponseEnergySystemPowerFlowSummaryModel
export type GetSitePowerFlowSummaryArgs = {
  /** The site whose energy systems to summarize */
  siteId: string
  /** Page number (0-indexed) */
  page?: number
  /** Number of items per page */
  count?: number
}
export type GetSitePowerFlowHistoryResponse = /** status 200 Successful Response */ SitePowerFlowHistoryModel
export type GetSitePowerFlowHistoryArgs = {
  /** Filter for events with timestamps after this time */
  from?: string
  /** Filter for events with timestamps before this time */
  to?: string
  /** The site whose power-flow history to read */
  siteId: string
  /** Bucket size. Each bucket averages the per-minute values that fall in it. */
  resolution?: '1m' | '5m' | '15m' | '1h'
}
export type ListUnplacedAssetsResponse = /** status 200 Successful Response */ PagedResponseUnplacedAssetModel
export type ListUnplacedAssetsArgs = {
  /** The site whose unplaced assets to list */
  siteId: string
  /** Page number (0-indexed) */
  page?: number
  /** Number of items per page */
  count?: number
}
export type GetEnergySystemResponse = /** status 200 Successful Response */ EnergySystemDetailModel
export type GetEnergySystemArgs = {
  systemId: string
}
export type UpdateEnergySystemResponse = /** status 200 Successful Response */ EnergySystemDetailModel
export type UpdateEnergySystemArgs = {
  systemId: string
  updateEnergySystemRequest: UpdateEnergySystemRequest
}
export type DeleteEnergySystemResponse = unknown
export type DeleteEnergySystemArgs = {
  systemId: string
}
export type AddEnergySystemComponentResponse = /** status 201 Successful Response */ EnergySystemDetailModel
export type AddEnergySystemComponentArgs = {
  systemId: string
  createEnergySystemComponentRequest: CreateEnergySystemComponentRequest
}
export type ReplaceEnergySystemComponentResponse = /** status 200 Successful Response */ EnergySystemDetailModel
export type ReplaceEnergySystemComponentArgs = {
  systemId: string
  componentId: string
  updateEnergySystemComponentRequest: UpdateEnergySystemComponentRequest
}
export type DeleteEnergySystemComponentResponse = /** status 200 Successful Response */ EnergySystemGraphDeletionModel
export type DeleteEnergySystemComponentArgs = {
  systemId: string
  componentId: string
}
export type ApplyEnergySystemChangesResponse = /** status 200 Successful Response */ EnergySystemDetailModel
export type ApplyEnergySystemChangesArgs = {
  systemId: string
  applyEnergySystemChangesRequest: ApplyEnergySystemChangesRequest
}
export type AddEnergySystemMeasurementPointResponse = /** status 201 Successful Response */ EnergySystemDetailModel
export type AddEnergySystemMeasurementPointArgs = {
  systemId: string
  createEnergySystemMeasurementPointRequest: CreateEnergySystemMeasurementPointRequest
}
export type ReplaceEnergySystemMeasurementPointResponse = /** status 200 Successful Response */ EnergySystemDetailModel
export type ReplaceEnergySystemMeasurementPointArgs = {
  systemId: string
  measurementPointId: string
  updateEnergySystemMeasurementPointRequest: UpdateEnergySystemMeasurementPointRequest
}
export type DeleteEnergySystemMeasurementPointResponse =
  /** status 200 Successful Response */ EnergySystemGraphDeletionModel
export type DeleteEnergySystemMeasurementPointArgs = {
  systemId: string
  measurementPointId: string
}
export type GetEnergySystemCoverageResponse = /** status 200 Successful Response */ EnergySystemCoverageModel
export type GetEnergySystemCoverageArgs = {
  systemId: string
}
export type GetEnergySystemLayoutResponse = /** status 200 Successful Response */ EnergySystemLayoutModel
export type GetEnergySystemLayoutArgs = {
  systemId: string
}
export type ReplaceEnergySystemLayoutResponse = /** status 200 Successful Response */ EnergySystemLayoutModel
export type ReplaceEnergySystemLayoutArgs = {
  systemId: string
  replaceEnergySystemLayoutRequest: ReplaceEnergySystemLayoutRequest
}
export type ResetEnergySystemLayoutResponse = unknown
export type ResetEnergySystemLayoutArgs = {
  systemId: string
}
export type AddEnergySystemConnectionResponse = /** status 201 Successful Response */ EnergySystemDetailModel
export type AddEnergySystemConnectionArgs = {
  systemId: string
  createEnergySystemConnectionRequest: CreateEnergySystemConnectionRequest
}
export type DeleteEnergySystemConnectionResponse = /** status 200 Successful Response */ EnergySystemGraphDeletionModel
export type DeleteEnergySystemConnectionArgs = {
  systemId: string
  connectionId: string
}
export type ListEnergySystemArchetypesResponse =
  /** status 200 Successful Response */ PagedResponseEnergySystemArchetypeModel
export type ListEnergySystemArchetypesArgs = {
  /** Page number (0-indexed) */
  page?: number
  /** Number of items per page */
  count?: number
}
export type ListEmsPlacementsResponse = /** status 200 Successful Response */ EmsPlacementSiteIdsModel
export type ListEmsPlacementsArgs = {
  /** Where a site's energy management has to run for the site to be listed: in the cloud, or on the SynopLink installed at the site. Required, because the two answers are not complements of one another. Only sites whose placement has been set are listed, so asking for cloud returns the sites that were placed there, not every site the cloud manages -- a site that has never been placed runs in the cloud and has nothing recorded to list. */
  managedBy: EmsPlacementTarget
}
export type GetEmsPlacementResponse = /** status 200 Successful Response */ EmsPlacementModel
export type GetEmsPlacementArgs = {
  /** Identifier of the site */
  siteId: string
}
export type SetEmsPlacementResponse = /** status 200 Successful Response */ EmsPlacementModel
export type SetEmsPlacementArgs = {
  /** Identifier of the site */
  siteId: string
  setEmsPlacementRequest: SetEmsPlacementRequest
}
export type SweepScopeResponse = /** status 202 Successful Response */ ScopeSweepAccepted
export type SweepScopeArgs = {
  /** Identifier of the datasync scope */
  scopeId: string
}
export type GetSynoplinksResponse = /** status 200 Successful Response */ PagedResponseSynopLinkModel
export type GetSynoplinksArgs = {
  /** Return SynopLinks owned by these organization IDs. When omitted, results are scoped to organizations the caller can access. */
  orgId?: string[]
  /** Return SynopLinks installed at these site IDs */
  siteId?: string[]
  /** Return SynopLinks matching these cloud device names */
  thingName?: string[]
  /** Return SynopLinks whose hardware serial number matches any of these. Normalized the same way a stored serial is (uppercase, whitespace stripped), so case and padding don't affect matching. */
  serialNumber?: string[]
  /** Return SynopLinks in any of these lifecycle statuses (for example installed or commissioned) */
  lifecycleStatus?: SynopLinkLifecycleStatus[]
  /** When true, also include SynopLinks from child organizations of the filtered or inferred organizations */
  includeChildren?: boolean
  /** Page number (0-indexed) */
  page?: number
  /** Number of items per page */
  count?: number
}
export type CreateSynoplinkResponse = /** status 200 Successful Response */ SynopLinkModel
export type CreateSynoplinkArgs = {
  createSynopLinkRequest: CreateSynopLinkRequest
}
export type GetSynoplinkResponse = /** status 200 Successful Response */ SynopLinkModel
export type GetSynoplinkArgs = {
  synoplinkId: string
}
export type UpdateSynoplinkResponse = /** status 200 Successful Response */ SynopLinkModel
export type UpdateSynoplinkArgs = {
  synoplinkId: string
  updateSynopLinkRequest: UpdateSynopLinkRequest
}
export type GetConnectivityStatusResponse = /** status 200 Successful Response */ SynopLinkConnectivityStatus
export type GetConnectivityStatusArgs = {
  /** Unique identifier of the SynopLink */
  synoplinkId: string
}
export type GetDevicesBySynoplinkResponse = /** status 200 Successful Response */ ConnectedDevicesResponse
export type GetDevicesBySynoplinkArgs = {
  /** Unique identifier of the SynopLink */
  synoplinkId: string
}
export type GetComponentConfigResponse = /** status 200 Successful Response */ ComponentConfigResponse
export type GetComponentConfigArgs = {
  /** Unique identifier of the SynopLink */
  synoplinkId: string
}
export type GetOcppProxyConfigResponse = /** status 200 Successful Response */ OcppProxyConfigModel
export type GetOcppProxyConfigArgs = {
  /** Unique identifier of the SynopLink */
  synoplinkId: string
}
export type ReplaceOcppProxyConfigResponse = /** status 200 Successful Response */ OcppProxyConfigModel
export type ReplaceOcppProxyConfigArgs = {
  /** Unique identifier of the SynopLink */
  synoplinkId: string
  updateOcppProxyConfigRequest: UpdateOcppProxyConfigRequest
}
export type DeleteOcppProxyConfigResponse = unknown
export type DeleteOcppProxyConfigArgs = {
  /** Unique identifier of the SynopLink */
  synoplinkId: string
}
export type GetOcppProxyModeResponse = /** status 200 Successful Response */ OcppProxyModeModel
export type GetOcppProxyModeArgs = {
  /** Unique identifier of the SynopLink */
  synoplinkId: string
}
export type ReplaceOcppProxyModeResponse = /** status 200 Successful Response */ OcppProxyModeModel
export type ReplaceOcppProxyModeArgs = {
  /** Unique identifier of the SynopLink */
  synoplinkId: string
  updateOcppProxyModeRequest: UpdateOcppProxyModeRequest
}
export type ReplaceOptimizerConfigResponse = /** status 200 Successful Response */ OptimizerConfigModel
export type ReplaceOptimizerConfigArgs = {
  /** Unique identifier of the SynopLink */
  synoplinkId: string
  updateOptimizerConfigRequest: UpdateOptimizerConfigRequest
}
export type DeleteOptimizerConfigResponse = unknown
export type DeleteOptimizerConfigArgs = {
  /** Unique identifier of the SynopLink */
  synoplinkId: string
}
export type ReplaceSitePowerManagerConfigResponse = /** status 200 Successful Response */ SitePowerManagerConfigModel
export type ReplaceSitePowerManagerConfigArgs = {
  /** Unique identifier of the SynopLink */
  synoplinkId: string
  updateSitePowerManagerConfigRequest: UpdateSitePowerManagerConfigRequest
}
export type DeleteSitePowerManagerConfigResponse = unknown
export type DeleteSitePowerManagerConfigArgs = {
  /** Unique identifier of the SynopLink */
  synoplinkId: string
}
export type ReplaceRelayConfigResponse = /** status 200 Successful Response */ RelayConfigModel
export type ReplaceRelayConfigArgs = {
  /** Unique identifier of the SynopLink */
  synoplinkId: string
  updateRelayConfigRequest: UpdateRelayConfigRequest
}
export type DeleteRelayConfigResponse = unknown
export type DeleteRelayConfigArgs = {
  /** Unique identifier of the SynopLink */
  synoplinkId: string
}
export type ReplaceDefaultPowerPlannerConfigResponse =
  /** status 200 Successful Response */ DefaultPowerPlannerConfigModel
export type ReplaceDefaultPowerPlannerConfigArgs = {
  /** Unique identifier of the SynopLink */
  synoplinkId: string
  updateDefaultPowerPlannerConfigRequest: UpdateDefaultPowerPlannerConfigRequest
}
export type DeleteDefaultPowerPlannerConfigResponse = unknown
export type DeleteDefaultPowerPlannerConfigArgs = {
  /** Unique identifier of the SynopLink */
  synoplinkId: string
}
export type ReplaceAstroConfigResponse = /** status 200 Successful Response */ AstroConfigModel
export type ReplaceAstroConfigArgs = {
  /** Unique identifier of the SynopLink */
  synoplinkId: string
  updateAstroConfigRequest: UpdateAstroConfigRequest
}
export type DeleteAstroConfigResponse = unknown
export type DeleteAstroConfigArgs = {
  /** Unique identifier of the SynopLink */
  synoplinkId: string
}
export type GetLoggingPostureResponse = /** status 200 Successful Response */ LoggingPostureModel
export type GetLoggingPostureArgs = {
  /** Unique identifier of the SynopLink */
  synoplinkId: string
}
export type ReplaceLoggingPostureResponse = /** status 200 Successful Response */ LoggingPostureModel
export type ReplaceLoggingPostureArgs = {
  /** Unique identifier of the SynopLink */
  synoplinkId: string
  updateLoggingPostureRequest: UpdateLoggingPostureRequest
}
export type DeleteLoggingPostureResponse = unknown
export type DeleteLoggingPostureArgs = {
  /** Unique identifier of the SynopLink */
  synoplinkId: string
}
export type GetNetworkConfigResponse = /** status 200 Successful Response */ NetworkConfigModel
export type GetNetworkConfigArgs = {
  /** Unique identifier of the SynopLink */
  synoplinkId: string
}
export type ReplaceNetworkConfigResponse = /** status 200 Successful Response */ NetworkConfigModel
export type ReplaceNetworkConfigArgs = {
  /** Unique identifier of the SynopLink */
  synoplinkId: string
  updateNetworkConfigRequest: UpdateNetworkConfigRequest
}
export type DeleteNetworkConfigResponse = unknown
export type DeleteNetworkConfigArgs = {
  /** Unique identifier of the SynopLink */
  synoplinkId: string
}
export type TriggerNetworkScanResponse = /** status 202 Successful Response */ NetworkScanTriggerResponse
export type TriggerNetworkScanArgs = {
  /** Unique identifier of the SynopLink */
  synoplinkId: string
  networkScanRequest: NetworkScanRequest
}
export type ListNetworkScansResponse = /** status 200 Successful Response */ PagedResponseNetworkScanSummary
export type ListNetworkScansArgs = {
  /** Unique identifier of the SynopLink */
  synoplinkId: string
  /** Page number (0-indexed) */
  page?: number
  /** Number of items per page */
  count?: number
}
export type GetDeviceReachabilityResponse = /** status 200 Successful Response */ DeviceReachabilityItem[]
export type GetDeviceReachabilityArgs = {
  /** Unique identifier of the SynopLink */
  synoplinkId: string
}
export type GetNetworkScanResponse = /** status 200 Successful Response */ NetworkScanDetail
export type GetNetworkScanArgs = {
  /** Unique identifier of the SynopLink */
  synoplinkId: string
  /** Identifier of the scan. */
  scanId: string
}
export type GetNetworkScanReportResponse = /** status 200 The scan report as markdown. */ string
export type GetNetworkScanReportArgs = {
  /** Unique identifier of the SynopLink */
  synoplinkId: string
  /** Identifier of the scan. */
  scanId: string
}
export type GetBatteriesV2Response = /** status 200 Successful Response */ PagedResponseBatteryModel
export type GetBatteriesV2Args = {
  /** Filter for batteries associated with the given node IDs */
  nodeIds?: string[]
  /** Filter for batteries associated with the given site IDs */
  siteIds?: string[]
  /** Filter for batteries associated with the given organization IDs */
  orgIds?: string[]
  /** Maximum depth of child organizations to include when filtering by org */
  orgDepth?: number
  /** Include locally managed batteries in results */
  includeLocalManaged?: boolean
  /** Page number (0-indexed) */
  page?: number
  /** Number of items per page */
  count?: number
}
export type GetLinkControlsResponse = /** status 200 Successful Response */ LinkControlsResponse
export type GetLinkControlsArgs = {
  /** Unique identifier of the Link */
  synoplinkId: string
}
export type UpdateLinkControlsResponse = /** status 200 Successful Response */ LinkControlsChangeResponse
export type UpdateLinkControlsArgs = {
  /** Unique identifier of the Link */
  synoplinkId: string
  /** When true, validates and reports without writing anything. */
  dryRun?: boolean
  linkControlsUpdate: LinkControlsUpdate
}
export type UpdateLinkControlsPanelResponse = /** status 200 Successful Response */ LinkControlsChangeResponse
export type UpdateLinkControlsPanelArgs = {
  /** Unique identifier of the Link */
  synoplinkId: string
  /** The panel's identifier on the Link */
  panelId: string
  /** When true, validates and reports without writing anything. */
  dryRun?: boolean
  linkControlsPanelUpdate: LinkControlsPanelUpdate
}
export type PutLinkControlsPanelResponse = /** status 200 Successful Response */ LinkControlsChangeResponse
export type PutLinkControlsPanelArgs = {
  /** Unique identifier of the Link */
  synoplinkId: string
  /** The panel's identifier on the Link */
  panelId: string
  /** When true, validates and reports without writing anything. */
  dryRun?: boolean
  linkControlsPanelPut: LinkControlsPanelPut
}
export type DeleteLinkControlsPanelResponse = /** status 200 Successful Response */ LinkControlsChangeResponse
export type DeleteLinkControlsPanelArgs = {
  /** Unique identifier of the Link */
  synoplinkId: string
  /** The panel's identifier on the Link */
  panelId: string
  /** When true, validates and reports without writing anything. */
  dryRun?: boolean
}
export type PutManagedChargerResponse = /** status 200 Successful Response */ LinkControlsChangeResponse
export type PutManagedChargerArgs = {
  /** Unique identifier of the Link */
  synoplinkId: string
  /** The charger's charge box identifier */
  chargerId: string
  /** When true, validates and reports without writing anything. */
  dryRun?: boolean
  managedChargerPut: ManagedChargerPut
}
export type UpdateManagedChargerResponse = /** status 200 Successful Response */ LinkControlsChangeResponse
export type UpdateManagedChargerArgs = {
  /** Unique identifier of the Link */
  synoplinkId: string
  /** The charger's charge box identifier */
  chargerId: string
  /** When true, validates and reports without writing anything. */
  dryRun?: boolean
  managedChargerUpdate: ManagedChargerUpdate
}
export type DeleteManagedChargerResponse = /** status 200 Successful Response */ LinkControlsChangeResponse
export type DeleteManagedChargerArgs = {
  /** Unique identifier of the Link */
  synoplinkId: string
  /** The charger's charge box identifier */
  chargerId: string
  /** When true, validates and reports without writing anything. */
  dryRun?: boolean
}
export type UpdateLinkControlsFallbacksResponse = /** status 200 Successful Response */ LinkControlsChangeResponse
export type UpdateLinkControlsFallbacksArgs = {
  /** Unique identifier of the Link */
  synoplinkId: string
  /** When true, validates and reports without writing anything. */
  dryRun?: boolean
  linkControlsFallbacksUpdate: LinkControlsFallbacksUpdate
}
export type ImportLinkControlsResponse = /** status 200 Successful Response */ LinkControlsStaffResponse
export type ImportLinkControlsArgs = {
  /** Unique identifier of the Link */
  synoplinkId: string
  /** When true, validates and reports without writing anything. */
  dryRun?: boolean
  /** Replace settings already stored for the Link. */
  overwrite?: boolean
  /** Create a Panel asset for each panel the import cannot map to one. */
  createMissingPanels?: boolean
  body: LinkControlsImportRequest | null
}
export type ReplaceRawLinkControlsResponse = /** status 200 Successful Response */ LinkControlsStaffResponse
export type ReplaceRawLinkControlsArgs = {
  /** Unique identifier of the Link */
  synoplinkId: string
  /** When true, validates and reports without writing anything. */
  dryRun?: boolean
  document: {
    [key: string]: unknown
  }
}
export type CreateProbeResponse = /** status 202 Successful Response */ ProbeQueuedResponse
export type CreateProbeArgs = {
  /** Unique identifier of the SynopLink */
  synoplinkId: string
  probeRequest: ProbeRequest
}
export type GetProbeResponse = /** status 200 Successful Response */ ProbeModel
export type GetProbeArgs = {
  /** Unique identifier of the SynopLink */
  synoplinkId: string
  /** Unique identifier of the probe */
  probeId: string
}
export type Pagination = {
  /** Whether this is the first page */
  first: boolean
  /** Whether this is the last page */
  last: boolean
  /** Number of items per page */
  pageSize: number
  /** Current page number (0-indexed) */
  page: number
  /** Total number of pages */
  totalPages: number
  /** Total number of items */
  totalItems: number
}
export type PaginationMeta = {
  pagination: Pagination
}
export type AlarmEventType = 'TRIGGERED' | 'RESOLVED'
export type AlarmSeverity = 'WARNING' | 'ERROR' | 'CRITICAL'
export type AlarmEventModel = {
  /** Unique identifier of the alarm event */
  id: string
  /** Unique identifier of the DER asset that produced the alarm */
  entityId: string
  /** Component or subsystem where the alarm originated, if known */
  location?: string
  /** When the alarm was triggered or resolved */
  timestamp: string
  /** Whether the alarm was triggered or resolved */
  eventType: AlarmEventType
  /** Device-specific code identifying the alarm condition */
  alarmCode?: string
  /** Human-readable explanation of the alarm condition */
  alarmReason?: string
  /** Severity level of the alarm */
  alarmSeverity: AlarmSeverity
  /** Bit mask identifying this alarm within a multi-alarm status value; null when the alarm is not bit-encoded */
  bitValue?: number
}
export type PagedResponseAlarmEventModel = {
  meta: PaginationMeta
  data: AlarmEventModel[]
}
export type ValidationError = {
  loc: (string | number)[]
  msg: string
  type: string
  ctx?: object
}
export type HttpValidationError = {
  detail?: ValidationError[]
}
export type DerAssetType =
  | 'BESS'
  | 'GENSET'
  | 'PANEL'
  | 'INVERTER'
  | 'SOLAR_ARRAY'
  | 'FUEL_TANK'
  | 'LOAD'
  | 'GRID_CONNECTION'
export type SortDirection = 'asc' | 'desc'
export type EnergyEntityState = {
  nowSupply?: number
  supplyUnit?: string
  capacity?: number
  capacityUnit?: string
  stateOfCharge?: number
}
export type PowerBoostTuning = {
  /** The battery's dead time, in seconds. */
  batteryDeadTimeSeconds?: number | null
  /** The battery's ramp rate, in kW per second. Above zero. */
  batteryRampKwPerSecond?: number | null
  /** The battery's grace period, in seconds. */
  batteryGraceSeconds?: number | null
  /** The lead, in kW. */
  leadKw?: number | null
  /** The charge reserve, in kW. */
  chargeReserveKw?: number | null
  /** The most the battery may recharge at from headroom, in kW. Zero stops recharging from headroom. */
  rechargeMaxKw?: number | null
  /** The chargers' response time, in seconds. Above zero. */
  chargerResponseSeconds?: number | null
  /** The fraction of its limit a charger reports delivering when it is at it, above zero and at most 1. A charger that delivers short of what it is asked reads under its limit by the gap; set this to read it against the limit. Unset, readings count as they come. */
  chargerDeliveryFraction?: number | null
  /** The most the battery may boost, as a multiple of the panel's operating limit. */
  boostRatioMax?: number | null
  /** The least time, in seconds, before boost re-arms after the battery faults. */
  holdSeconds?: number | null
  /** The watchdog's timed threshold, in kW. Above zero. */
  watchdogTimeKw?: number | null
  /** The watchdog's time window, in seconds. Above zero. */
  watchdogTimeSeconds?: number | null
  /** The watchdog's instant threshold, in kW. Above zero. */
  watchdogInstantKw?: number | null
  /** How many readings in a row at or above watchdogInstantKw trip the watchdog. A whole number, at least 1. */
  watchdogInstantReadings?: number | null
  /** The watchdog's hold, in seconds. */
  watchdogHoldSeconds?: number | null
  /** A second trip or battery fault within this many seconds of the last one locks boost out. */
  lockoutWindowSeconds?: number | null
  /** How long each lockout in a row lasts, in seconds, in order; each above zero. A lockout past the end of the list lasts until lockoutClearedAt clears it, and an empty list makes every lockout last until then. */
  lockoutSeconds?: number[] | null
}
export type PowerBoostControl = {
  /** The control's kind. */
  kind: 'power_boost'
  /** Whether the control is on. Switching power boost on needs its panel to have an operating limit and a meter, and the battery to be managed locally. A panel a Link's controls name must also have an operating limit no higher than the power its panel limit carries, where its voltage and phase are recorded (POWER_BOOST_OPERATING_LIMIT_ABOVE_PANEL_LIMIT). Switching it off is never refused. */
  enabled?: boolean
  /** The lowest state of charge, in percent, this control uses. For power boost, within the battery's lowSocEntry (20 when unset) to highSocEntry (100 when unset). Boost stops discharging below it and resumes once the battery charges past it by the battery's own low gap (lowSocRecovery minus lowSocEntry), so it must leave room for that before highSocEntry and socMax, and sit at or below highSocRecovery. Null leaves the battery's own thresholds as the bound. */
  socMin?: number | null
  /** The highest state of charge, in percent, this control uses. For power boost, within the battery's lowSocEntry to highSocEntry. Boost stops charging the battery above it and resumes once it discharges below it by the battery's high gap (highSocEntry minus highSocRecovery, or the low gap without a high band), so it must leave room for that above lowSocEntry and socMin, and sit at or above lowSocRecovery. */
  socMax?: number | null
  /** The panel whose operating limit power boost holds, on the same SynopLink as the battery. Its meter is the one power boost follows. */
  panelId: string
  /** The panel for the site's supply, on the same Link as the battery and not panelId. Its operating limit and meter let power boost follow the supply. Null holds panelId's limit. */
  sitePanelId?: string | null
  /** How power boost uses the site supply: off ignores it, observe measures it without acting, on follows it. Observe and on need sitePanelId. Set through the API only. */
  siteHeadroomMode?: 'off' | 'observe' | 'on'
  /** The margin, in kW, kept under the site supply's limit. Null uses 30. */
  siteMarginKw?: number | null
  /** How long, in seconds, a site meter value may stand unchanged before it counts as stale. Null uses 45. Set through the API only. */
  siteMeterStalenessSeconds?: number | null
  /** The least power, in kW, the cabinet imports while boost discharges. Null uses the Link's default, 5. */
  minGridImportKw?: number | null
  /** The longest, in seconds, a stop may take to step the battery and the chargers down together. Null uses the Link's default, 180. Set through the API only. */
  batteryFirstHoldSeconds?: number | null
  /** The step, in kW, the battery and the chargers move down together when boost stops. Null uses the Link's default, 20. */
  stopStepKw?: number | null
  /** The band, in percent above the SoC floor, over which boost tapers to zero. Null uses the Link's default, 5. Set through the API only. */
  socApproachBandPercent?: number | null
  /** site keeps the battery's discharge within what the rest of the site can absorb; cabinet uses the cabinet meter alone. Null uses site when sitePanelId is set. */
  exportGuardMode?: ('site' | 'cabinet') | null
  /** The margin, in kW, kept under what the rest of the site can absorb. Null uses the Link's default, 10. */
  absorbMarginKw?: number | null
  /** The most power, in kW, power boost asks the battery to supply. At most the battery's maxPower. Null leaves the battery's live available power as the only limit. */
  dischargeLimitKw?: number | null
  /** What sets the chargers' limit while power boost runs: load-following (today's two-loop charger control, the default) leaves it to the panel's own load management; boost-loop-integrated (the boost loop owns all charger control) has power boost set it together with the battery. Null uses load-following. Set through the API only. */
  chargerControl?: ('load-following' | 'boost-loop-integrated') | null
  /** Per-site tuning for power boost, mostly for chargerControl boost-loop-integrated. Each key left out or null uses the Link's default. Set through the API only. */
  tuning?: PowerBoostTuning | null
  /** Clears a power boost lockout: every lock that began at or before this time ends, and earlier trips stop counting toward a lockout. Set it to the current time (ISO 8601, UTC when no offset is given) to clear. Null clears nothing. Set through the API only. */
  lockoutClearedAt?: string | null
}
export type TransitionConstraint = {
  requires_idle?: boolean
  min_idle_seconds?: number
}
export type TransitionConstraints = {
  charging_to_discharging?: TransitionConstraint | null
}
export type DerCapabilityQuirks = {
  transition_constraints?: TransitionConstraints | null
  telemetry_stale_after_seconds?: number | null
  notes?: {
    [key: string]: string
  } | null
}
export type CapabilitySetMakeInfo = {
  id: string
  name: string
}
export type CapabilitySetModelInfo = {
  id: string
  name: string
  make: CapabilitySetMakeInfo
}
export type BessChemistry = 'LFP' | 'NMC' | 'LTO' | 'OTHER'
export type BessCapabilitySetModel = {
  id: string
  modelId: string
  version: string
  published: boolean
  notes?: string
  knownQuirks?: DerCapabilityQuirks
  model?: CapabilitySetModelInfo
  assetType?: 'BESS'
  maxRatedChargePowerKw: number
  maxRatedDischargePowerKw: number
  minChargePowerKw?: number
  minDischargePowerKw?: number
  ratedStorageCapacityKwh: number
  usableStorageCapacityKwh?: number
  nominalVoltageV?: number
  providesPackLevelData: boolean
  providesRackLevelData: boolean
  providesCellLevelData: boolean
  supportsGridForming: boolean
  supportsIslanding: boolean
  supportsRemoteModeChange: boolean
  supportedOperatingModes: string[]
  chemistry?: BessChemistry
}
export type BatteryModel = {
  id: string
  desiredState?: EnergyEntityState
  name?: string
  nodeId: string
  siteId: string
  organizationId: string
  type: DerAssetType
  maxCapacity: number
  minCapacity: number
  maxRatedCapacity: number
  maxPower: number
  /** The most power, in kW, Synop's controls may discharge this battery at. It is what the operator allows, at most the rated power (maxPower); null means the rated power applies. Power boost's discharge limit is capped by it. */
  maxDischargeKw?: number | null
  minPower: number
  nominalVoltage: number
  numRacks?: number
  packsPerRack?: number
  cellsPerRack?: number
  /** Low state-of-charge entry threshold, in percent. */
  lowSocEntry?: number | null
  /** Low state-of-charge recovery threshold, in percent. */
  lowSocRecovery?: number | null
  /** High state-of-charge entry threshold, in percent. */
  highSocEntry?: number | null
  /** High state-of-charge recovery threshold, in percent. */
  highSocRecovery?: number | null
  manufacturer?: string
  modelNumber?: string
  firmwareVersion?: string
  serialNumber?: string
  cloudManaged: boolean
  modelId?: string
  capabilitySetId?: string
  /** The controls the battery runs. Each entry is a kind with its own settings, which the battery may run at the same time as others. Power boost is the only kind today, and each kind appears at most once. */
  controls?: PowerBoostControl[]
  /** Whether the SynopLink runs this battery's power boost control as saved: 'applied' when it confirms them, 'pending' until it does, usually a few seconds after a change. Null when power boost has never been set up for this battery, when the SynopLink could not be reached, and in battery lists, which do not report it. */
  powerBoostStatus?: ('applied' | 'pending') | null
  capabilitySet?: BessCapabilitySetModel | null
  defaultedFields?: string[]
}
export type CreateBatteryRequest = {
  name?: string
  nodeId: string
  maxCapacity: number
  minCapacity: number
  maxRatedCapacity: number
  maxPower: number
  /** The most power, in kW, Synop's controls may discharge this battery at. It is what the operator allows, at most the rated power (maxPower); null means the rated power applies. Power boost's discharge limit is capped by it. */
  maxDischargeKw?: number
  minPower: number
  nominalVoltage: number
  numRacks?: number
  packsPerRack?: number
  cellsPerRack?: number
  /** State of charge, in percent, below which the SynopLink places the battery in its low state. Set together with lowSocRecovery; with neither set, the SynopLink uses 20 and 30. Stored to two decimal places and checked as stored. */
  lowSocEntry?: number
  /** State of charge, in percent, above which a battery in its low state returns to normal. Must be above lowSocEntry. Stored to two decimal places and checked as stored. */
  lowSocRecovery?: number
  /** State of charge, in percent, above which the SynopLink places the battery in its high state. Set together with highSocRecovery; with neither set, the battery has no high state. Stored to two decimal places and checked as stored. */
  highSocEntry?: number
  /** State of charge, in percent, below which a battery in its high state returns to normal. Must be below highSocEntry and at or above the low recovery the SynopLink runs: lowSocRecovery, or the default when the low band is not fully set. Stored to two decimal places and checked as stored. */
  highSocRecovery?: number
  manufacturer?: string
  modelNumber?: string
  firmwareVersion?: string
  serialNumber?: string
  cloudManaged?: boolean
  modelId?: string
  capabilitySetId?: string
}
export type UpdateBatteryRequest = {
  /** ID of the DER asset to update */
  id: string
  name?: string
  nodeId?: string
  maxCapacity?: number
  minCapacity?: number
  maxRatedCapacity?: number
  maxPower?: number
  /** The most power, in kW, Synop's controls may discharge this battery at. It is what the operator allows, at most the rated power (maxPower); null means the rated power applies. Power boost's discharge limit is capped by it. An explicit null clears it; omit it to keep it. */
  maxDischargeKw?: number | null
  minPower?: number
  nominalVoltage?: number
  numRacks?: number
  packsPerRack?: number
  cellsPerRack?: number
  /** State of charge, in percent, below which the SynopLink places the battery in its low state. Omit to keep the stored value; send null to clear it. lowSocEntry and lowSocRecovery are set and cleared as a pair; with both cleared, the SynopLink uses 20 and 30. Stored to two decimal places and checked as stored. */
  lowSocEntry?: number | null
  /** State of charge, in percent, above which a battery in its low state returns to normal. Must be above lowSocEntry. Omit to keep the stored value; send null to clear it. lowSocEntry and lowSocRecovery are set and cleared as a pair; with both cleared, the SynopLink uses 20 and 30. Stored to two decimal places and checked as stored. */
  lowSocRecovery?: number | null
  /** State of charge, in percent, above which the SynopLink places the battery in its high state. Omit to keep the stored value; send null to clear it. highSocEntry and highSocRecovery are set and cleared as a pair; with both cleared, the battery has no high state. Stored to two decimal places and checked as stored. */
  highSocEntry?: number | null
  /** State of charge, in percent, below which a battery in its high state returns to normal. Must be below highSocEntry and at or above the low recovery the SynopLink runs: lowSocRecovery, or the default when the low band is not fully set. Omit to keep the stored value; send null to clear it. highSocEntry and highSocRecovery are set and cleared as a pair; with both cleared, the battery has no high state. Stored to two decimal places and checked as stored. */
  highSocRecovery?: number | null
  manufacturer?: string
  modelNumber?: string
  firmwareVersion?: string
  serialNumber?: string
  cloudManaged?: boolean
  /** The controls the battery runs. Each entry is a kind with its own settings, which the battery may run at the same time as others. Power boost is the only kind today, and each kind appears at most once. The whole list is replaced; omit it to keep it. */
  controls?: PowerBoostControl[]
  desiredState?: EnergyEntityState
  modelId?: string
  capabilitySetId?: string
}
export type RunState = 'NORMAL' | 'DEGRADED' | 'CRITICAL'
export type Alarm = {
  code?: string | number | null
  reason?: string | null
  severity?: AlarmSeverity | null
  bitValue?: number | null
  conditionCode?: number | null
}
export type OperationalState = {
  entityId: string
  eventTime: string
  eventId?: string
  oem?: string | null
  schemaVersion?: number | null
  snapshotType?: 'operational_state'
  runState?: RunState | null
  gridMode?: string | null
  controlMode?: string | null
  controllerMode?: string | null
  remoteStart?: boolean | null
  alarms?: Alarm[] | null
}
export type Rack = {
  voltage: number
  current: number
  soc: number
  maxCellVoltage?: number | null
  minCellVoltage?: number | null
  avgCellVoltage?: number | null
  maxCellTemp?: number | null
  minCellTemp?: number | null
  avgCellTemp?: number | null
  soh?: number | null
  power?: number | null
  soe?: number | null
  currentAvg?: number | null
  maxChargeCurrent?: number | null
  maxDischargeCurrent?: number | null
  maxCellVoltageCellId?: number | null
  minCellVoltageCellId?: number | null
  maxTempCellId?: number | null
  minTempCellId?: number | null
  contactorStatus?: number | null
  insulation?: number | null
  positiveInsulation?: number | null
  negativeInsulation?: number | null
  maxCellSelfDischargeRate?: number | null
  minCellSelfDischargeRate?: number | null
  avgCellSelfDischargeRate?: number | null
  totalStringCount?: number | null
  onlineStringCount?: number | null
  alarms?: Alarm[] | null
}
export type RackSnapshotRack = {
  entityId: string
  eventTime: string
  eventId?: string
  oem?: string | null
  schemaVersion?: number | null
  snapshotType?: 'rack'
  racks: {
    [key: string]: Rack
  }
}
export type PowerFlow = 'IMPORT' | 'EXPORT' | 'IDLE' | 'UNKNOWN'
export type PowerSnapshotMeterV1 = {
  entityId: string
  eventTime: string
  eventId?: string
  oem?: 'meter'
  schemaVersion?: 1
  snapshotType?: 'power_snapshot'
  boundary?: 'ac'
  activePowerOut?: number | null
  activePowerIn?: number | null
  activePower?: number | null
  voltage?: number | null
  current?: number | null
  apparentPower?: number | null
  reactivePower?: number | null
  powerFactor?: number | null
  frequency?: number | null
  availablePower?: number | null
  phase?: ('A' | 'B' | 'C') | null
  cumulativeEnergyProduced?: number | null
  thetaDeg?: number | null
  powerFlow: PowerFlow
}
export type PowerSnapshotPixiiV1 = {
  entityId: string
  eventTime: string
  eventId?: string
  oem?: 'pixii'
  schemaVersion?: 1
  snapshotType?: 'power_snapshot'
  boundary?: 'ac'
  activePowerOut?: number | null
  activePowerIn?: number | null
  activePower?: number | null
  voltage?: number | null
  current?: number | null
  apparentPower?: number | null
  reactivePower?: number | null
  powerFactor?: number | null
  frequency?: number | null
  availablePower?: number | null
  phase?: ('A' | 'B' | 'C') | null
  cumulativeEnergyProduced?: number | null
  cumulativeEnergyImported?: number | null
  cumulativeEnergyExported?: number | null
  powerFlow: PowerFlow
}
export type DcPowerSnapshotPixiiV1 = {
  entityId: string
  eventTime: string
  eventId?: string
  oem?: 'pixii-dc'
  schemaVersion?: 1
  snapshotType?: 'power_snapshot'
  boundary?: 'dc'
  activePowerOut?: number | null
  activePowerIn?: number | null
  activePower?: number | null
  voltage?: number | null
  current?: number | null
  panelTemperature?: number | null
  powerFlow: PowerFlow
}
export type PowerSnapshot = {
  entityId: string
  eventTime: string
  eventId?: string
  oem?: string | null
  schemaVersion?: number | null
  snapshotType?: 'power_snapshot'
  boundary?: null
  activePowerOut?: number | null
  activePowerIn?: number | null
  activePower?: number | null
  voltage?: number | null
  current?: number | null
  powerFlow: PowerFlow
}
export type AcPowerSnapshot = {
  entityId: string
  eventTime: string
  eventId?: string
  oem?: string | null
  schemaVersion?: number | null
  snapshotType?: 'power_snapshot'
  boundary?: 'ac'
  activePowerOut?: number | null
  activePowerIn?: number | null
  activePower?: number | null
  voltage?: number | null
  current?: number | null
  apparentPower?: number | null
  reactivePower?: number | null
  powerFactor?: number | null
  frequency?: number | null
  availablePower?: number | null
  phase?: ('A' | 'B' | 'C') | null
  cumulativeEnergyProduced?: number | null
  powerFlow: PowerFlow
}
export type DcPowerSnapshot = {
  entityId: string
  eventTime: string
  eventId?: string
  oem?: string | null
  schemaVersion?: number | null
  snapshotType?: 'power_snapshot'
  boundary?: 'dc'
  activePowerOut?: number | null
  activePowerIn?: number | null
  activePower?: number | null
  voltage?: number | null
  current?: number | null
  panelTemperature?: number | null
  powerFlow: PowerFlow
}
export type StorageSnapshot = {
  entityId: string
  eventTime: string
  eventId?: string
  oem?: string | null
  schemaVersion?: number | null
  snapshotType?: 'storage_snapshot'
  stateOfCharge: number
  availableChargeEnergy: number
  availableDischargeEnergy: number
  stateOfHealth?: number | null
  chargePowerLimit?: number | null
  dischargePowerLimit?: number | null
}
export type EngineSnapshot = {
  entityId: string
  eventTime: string
  eventId?: string
  oem?: string | null
  schemaVersion?: number | null
  snapshotType?: 'engine_snapshot'
  starterBatteryVoltage?: number | null
  engineSpeedRpm?: number | null
  coolantTempC?: number | null
  oilPressureKpa?: number | null
  engineLoadPct?: number | null
  runHours?: number | null
  defLevelPct?: number | null
}
export type FrontingInverterSnapshot = {
  /** Unique identifier of the inverter, as the SynopLink that polls it is configured. The inverter has no DER asset of its own. */
  derId: string
  /** The inverter's latest operational state, including its active alarms. Null until the inverter has reported one. */
  operationalState?: OperationalState | null
}
export type DerSnapshotResponse = {
  operationalState?: OperationalState | null
  rack?: RackSnapshotRack | null
  power?:
    | PowerSnapshotMeterV1
    | PowerSnapshotPixiiV1
    | DcPowerSnapshotPixiiV1
    | PowerSnapshot
    | AcPowerSnapshot
    | DcPowerSnapshot
    | null
  dcPower?:
    | PowerSnapshotMeterV1
    | PowerSnapshotPixiiV1
    | DcPowerSnapshotPixiiV1
    | PowerSnapshot
    | AcPowerSnapshot
    | DcPowerSnapshot
    | null
  storage?: StorageSnapshot | null
  /** The latest condition measurements of the DER's combustion engine: starter battery voltage, engine speed, coolant temperature, oil pressure, load, run hours and diesel exhaust fluid level, each null when the engine does not report it. Null for a DER without a combustion engine, or until one has reported. */
  engine?: EngineSnapshot | null
  /** The inverters that connect this DER to the grid and have no DER asset of their own, each with its latest operational state. Empty for every DER that has none, and always empty in the bulk /der-snapshots response. */
  frontingInverters?: FrontingInverterSnapshot[]
}
export type ChargeEvent = 'CHARGING' | 'DISCHARGING' | 'IDLE' | 'FAULTED' | 'UNKNOWN' | 'MAX_CHARGE' | 'MIN_CHARGE'
export type BatteryTransactionModel = {
  batteryId: string
  chargeEvent?: ChargeEvent
  startTime: string
  endTime: string
  startingSoc?: number
  endingSoc?: number
  energyChange?: number
}
export type PagedResponseBatteryTransactionModel = {
  meta: PaginationMeta
  data: BatteryTransactionModel[]
}
export type BatteryUptimeModel = {
  /** Map of charge event to percentage (0-100) */
  uptime?: {
    [key: string]: number
  }
}
export type DerSummaryModel = {
  derId: string
  type: DerAssetType
  name: string
  nodeId: string
  siteId: string
  orgId: string
  cloudManaged: boolean
  /** Name of the company that built the asset, as recorded on its details page. Null when it has not been recorded. */
  manufacturer?: string | null
  /** Manufacturer's model number for the asset, as recorded on its details page. Null when it has not been recorded. */
  modelNumber?: string | null
  /** Manufacturer's serial number for the asset, as recorded on its details page. Null when it has not been recorded. */
  serialNumber?: string | null
}
export type PagedResponseDerSummaryModel = {
  meta: PaginationMeta
  data: DerSummaryModel[]
}
export type DerMakeModel = {
  id: string
  name: string
  updatedAt: string
}
export type DerModelModel = {
  id: string
  makeId: string
  assetType: DerAssetType
  name: string
  helperText?: string
  defaultCapabilitySetId?: string
  updatedAt: string
}
export type PhaseConfiguration = 'SPLIT_PHASE' | 'THREE_PHASE'
export type FuelType = 'DIESEL' | 'NATURAL_GAS' | 'LP_VAPOR' | 'GASOLINE'
export type GensetCapabilitySetModel = {
  id: string
  modelId: string
  version: string
  published: boolean
  notes?: string
  knownQuirks?: DerCapabilityQuirks
  model?: CapabilitySetModelInfo
  assetType?: 'GENSET'
  ratedPowerKw: number
  ratedApparentPowerKva: number
  ratedVoltageV: number
  ratedCurrentA: number
  ratedFrequencyHz: number
  phaseConfiguration: PhaseConfiguration
  fuelType: FuelType
  minPowerKw: number
  maxPowerKw: number
  supportsRemoteStart: boolean
  supportsRemoteStop: boolean
}
export type PanelCapabilitySetModel = {
  id: string
  modelId: string
  version: string
  published: boolean
  notes?: string
  knownQuirks?: DerCapabilityQuirks
  model?: CapabilitySetModelInfo
  assetType?: 'PANEL'
  ratedAmperageA: number
  ratedVoltageV: number
  phaseConfiguration: PhaseConfiguration
  numCircuits: number
  supportsPerCircuitTelemetry: boolean
  supportsPerCircuitControl: boolean
}
export type InverterCapabilitySetModel = {
  id: string
  modelId: string
  version: string
  published: boolean
  notes?: string
  knownQuirks?: DerCapabilityQuirks
  model?: CapabilitySetModelInfo
  assetType?: 'INVERTER'
  gridCapable: boolean
  islandable: boolean
  bidirectional: boolean
  pvHybrid: boolean
  ratedPowerKw: number
  ratedVoltageV: number
  mpptCount: number
  peakEfficiencyPct?: number
  supportsReactivePowerControl: boolean
}
export type DerAssetCapabilitySetResponse = {
  make: DerMakeModel
  model: DerModelModel
  capabilitySet:
    | BessCapabilitySetModel
    | GensetCapabilitySetModel
    | PanelCapabilitySetModel
    | InverterCapabilitySetModel
}
export type IntDistribution = {
  /** Mean over the interval */
  avg?: number | null
  /** Minimum value in the interval */
  min?: number | null
  /** Maximum value in the interval */
  max?: number | null
}
export type FloatDistribution = {
  /** Mean over the interval */
  avg?: number | null
  /** Minimum value in the interval */
  min?: number | null
  /** Maximum value in the interval */
  max?: number | null
}
export type PowerFlowMode = {
  /** Most common value in the interval */
  mode?: PowerFlow | null
}
export type Sample = {
  /** Bucket start time */
  timestamp: string
  /** Active power, in watts (signed) */
  activePower?: IntDistribution
  /** State of charge, as a percentage (0-100) */
  stateOfCharge?: FloatDistribution
  /** PowerFlow category (IMPORT / EXPORT / IDLE / UNKNOWN) */
  powerFlow?: PowerFlowMode
  /** Live dispatchable active power, in watts (>=0) */
  availablePower?: IntDistribution
  /** Voltage at the boundary, in volts */
  voltage?: FloatDistribution
  /** Current at the boundary, in amps */
  current?: FloatDistribution
  /** DC-side voltage, in volts (solar arrays; from the interleaved DC power stream) */
  dcVoltage?: FloatDistribution
  /** DC-side current, in amps (solar arrays; from the interleaved DC power stream) */
  dcCurrent?: FloatDistribution
  /** DC-side active power, in watts (solar arrays; from the interleaved DC power stream) */
  dcPower?: IntDistribution
  /** Panel/module temperature, in degrees Celsius (solar arrays) */
  panelTemperature?: FloatDistribution
  /** Voltage of the battery that cranks the engine, in volts (generators with a combustion engine) */
  starterBatteryVoltage?: FloatDistribution
  /** Engine speed, in revolutions per minute (generators with a combustion engine) */
  engineSpeedRpm?: FloatDistribution
  /** Engine coolant temperature, in degrees Celsius (generators with a combustion engine) */
  coolantTempC?: FloatDistribution
  /** Engine oil pressure, in kilopascals (generators with a combustion engine) */
  oilPressureKpa?: FloatDistribution
  /** Engine load as a percentage of its rating; can exceed 100 (generators with a combustion engine) */
  engineLoadPct?: FloatDistribution
  /** Cumulative engine run time, in hours (generators with a combustion engine) */
  runHours?: FloatDistribution
  /** Diesel exhaust fluid tank level, as a percentage (0-100) (generators with a combustion engine) */
  defLevelPct?: FloatDistribution
}
export type PagedResponseSample = {
  meta: PaginationMeta
  data: Sample[]
}
export type DerSampleField =
  | 'activePower'
  | 'stateOfCharge'
  | 'powerFlow'
  | 'availablePower'
  | 'voltage'
  | 'current'
  | 'dcVoltage'
  | 'dcCurrent'
  | 'dcPower'
  | 'panelTemperature'
  | 'starterBatteryVoltage'
  | 'engineSpeedRpm'
  | 'coolantTempC'
  | 'oilPressureKpa'
  | 'engineLoadPct'
  | 'runHours'
  | 'defLevelPct'
export type IntSum = {
  /** Sum over the interval */
  sum?: number | null
}
export type DerAggregatesResponseModel = {
  /** Energy imported (charged into the DER), in watt-hours */
  energyImported?: IntSum
  /** Energy exported (discharged from the DER), in watt-hours */
  energyExported?: IntSum
  /** Energy produced over the range, in watt-hours (sum of positive deltas of the cumulative production register published by solar arrays) */
  energyProduced?: IntSum
  /** Active power over the range, in watts (signed) */
  activePower?: IntDistribution
  /** Live dispatchable active power over the range, in watts (>=0) */
  availablePower?: IntDistribution
  /** Voltage over the range, in volts */
  voltage?: FloatDistribution
  /** Current over the range, in amps */
  current?: FloatDistribution
  /** Voltage of the battery that cranks the engine, in volts (generators with a combustion engine) */
  starterBatteryVoltage?: FloatDistribution
  /** Engine speed, in revolutions per minute (generators with a combustion engine) */
  engineSpeedRpm?: FloatDistribution
  /** Engine coolant temperature, in degrees Celsius (generators with a combustion engine) */
  coolantTempC?: FloatDistribution
  /** Engine oil pressure, in kilopascals (generators with a combustion engine) */
  oilPressureKpa?: FloatDistribution
  /** Engine load as a percentage of its rating; can exceed 100 (generators with a combustion engine) */
  engineLoadPct?: FloatDistribution
  /** Cumulative engine run time, in hours (generators with a combustion engine) */
  runHours?: FloatDistribution
  /** Diesel exhaust fluid tank level, as a percentage (0-100) (generators with a combustion engine) */
  defLevelPct?: FloatDistribution
}
export type DerAggregateField =
  | 'energyImported'
  | 'energyExported'
  | 'energyProduced'
  | 'activePower'
  | 'availablePower'
  | 'voltage'
  | 'current'
  | 'starterBatteryVoltage'
  | 'engineSpeedRpm'
  | 'coolantTempC'
  | 'oilPressureKpa'
  | 'engineLoadPct'
  | 'runHours'
  | 'defLevelPct'
export type DerDestinationType = 'STEVE' | 'CLOUD_GATEWAY' | 'LINK_DEVICE'
export type DerDestinationAssignmentModel = {
  derId: string
  destinationId: string
  destinationType: DerDestinationType
}
export type UpdateDerDestinationRequest = {
  /** Destination to move the DER's communication to. Must name a live destination. */
  destinationId: string
}
export type DerDestinationModel = {
  /** The communication destination identifier a DER can be assigned to; shared with the chargers API's destination catalog. */
  destinationId: string
  destinationType: DerDestinationType
  siteId?: string | null
  updatedAt: string
}
export type PagedResponseDerDestinationModel = {
  meta: PaginationMeta
  data: DerDestinationModel[]
}
export type DerSkipReason = 'UNAUTHORIZED' | 'UNSUPPORTED_TYPE' | 'POWER_BOOST_ON'
export type SkippedDerModel = {
  derId: string
  reason: DerSkipReason
}
export type AssignDersResult = {
  destinationId: string
  assignedDerIds: string[]
  skipped: SkippedDerModel[]
}
export type AssignDersRequest = {
  /** DERs to assign. Mutually exclusive with fromDestinationId; exactly one selector is required. */
  derIds?: string[]
  /** Move every DER currently assigned to this destination. Mutually exclusive with derIds; exactly one selector is required. */
  fromDestinationId?: string
}
export type DerSnapshotListItem = {
  operationalState?: OperationalState | null
  rack?: RackSnapshotRack | null
  power?:
    | PowerSnapshotMeterV1
    | PowerSnapshotPixiiV1
    | DcPowerSnapshotPixiiV1
    | PowerSnapshot
    | AcPowerSnapshot
    | DcPowerSnapshot
    | null
  dcPower?:
    | PowerSnapshotMeterV1
    | PowerSnapshotPixiiV1
    | DcPowerSnapshotPixiiV1
    | PowerSnapshot
    | AcPowerSnapshot
    | DcPowerSnapshot
    | null
  storage?: StorageSnapshot | null
  /** The latest condition measurements of the DER's combustion engine: starter battery voltage, engine speed, coolant temperature, oil pressure, load, run hours and diesel exhaust fluid level, each null when the engine does not report it. Null for a DER without a combustion engine, or until one has reported. */
  engine?: EngineSnapshot | null
  /** The inverters that connect this DER to the grid and have no DER asset of their own, each with its latest operational state. Empty for every DER that has none, and always empty in the bulk /der-snapshots response. */
  frontingInverters?: FrontingInverterSnapshot[]
  derId: string
}
export type PagedResponseDerSnapshotListItem = {
  meta: PaginationMeta
  data: DerSnapshotListItem[]
}
export type ConnectedDeviceType =
  | 'switch'
  | 'charger'
  | 'battery'
  | 'meter'
  | 'beacon'
  | 'generator'
  | 'inverter'
  | 'relay'
  | 'wireless_access_point'
export type DeviceModelSpec = {
  /** Hardware or firmware model used to collect and interpret a device's data. This is the value a connected device carries as its model */
  modelType: string
  /** The kind of device this model can be used on */
  deviceType: ConnectedDeviceType
  /** How the device can be addressed: 'tcp' when its config takes a host, 'serial' when it takes a tty device path */
  transports: string[]
  /** Whether a host must be supplied to configure this model */
  hostRequired?: boolean
  /** Whether a port must be supplied to configure this model. The meters all default theirs to 502 and the generators do not, so this is the difference between a field a form may omit and one it has to collect */
  portRequired?: boolean
  /** Factory default Modbus unit id, when the model has one */
  unitIdDefault?: number | null
  /** Whether a Modbus unit id must be supplied to configure this model */
  unitIdRequired?: boolean
  /** Whether this model can be configured with a Modbus unit id at all. True even when the unit id has no default and is optional, which is how a device reached through a Modbus gateway declares it */
  unitIdSupported?: boolean
  /** Factory default RS485 baud rate, when serial */
  baudRateDefault?: number | null
  /** The rates this model's hardware accepts. Per model rather than one shared list, because the sets genuinely diverge */
  baudRates?: number[] | null
  /** The ways this model can be driven, when it offers a choice. Absent for a model that has only one */
  regulationTypes?: string[] | null
  /** The way a new device of this model is driven by default */
  regulationTypeDefault?: string | null
  /** Whether this model can be configured to accept commands as well as report readings. A model that can is still read-only until control is turned on for the device */
  supportsControl?: boolean
  /** Whether a device of this model must be linked to an energy entity. A device of such a model is refused on create and on update without one */
  energyEntityRequired?: boolean
  /** Whether this model serves a single charger and must name it by that charger's id */
  chargerRequired?: boolean
  /** Whether this model needs each of its charger's connectors assigned to a port on the device */
  connectorPortsRequired?: boolean
  /** Whether this model can be configured with the battery's nameplate energy capacity in kWh, sent as nameplateEnergyKwh in the config. A battery that reports no capacity of its own derives its stored energy from this and its state of charge */
  nameplateEnergyKwhSupported?: boolean
  /** Whether the nameplate energy capacity must be supplied to configure this model. A device of such a model is refused without one */
  nameplateEnergyKwhRequired?: boolean
  /** Whether this model can be configured with a current scale, sent as currentScale in the config. It multiplies the current and power the meter reads, never its voltage or frequency, and corrects a meter whose current sensors do not match its configured rating until the hardware is fixed. Between 0.01 and 100; unset reads as 1. A device of any other model is refused with one */
  currentScaleSupported?: boolean
}
export type PagedResponseDeviceModelSpec = {
  meta: PaginationMeta
  data: DeviceModelSpec[]
}
export type GeneratorModel = {
  id: string
  name?: string
  nodeId: string
  siteId: string
  organizationId: string
  type: DerAssetType
  ratedPowerKw: number
  ratedApparentPowerKva?: number
  ratedVoltageV?: number
  ratedCurrentA?: number
  ratedFrequencyHz?: number
  phaseConfiguration?: PhaseConfiguration
  fuelType?: FuelType
  minPowerKw?: number
  maxPowerKw?: number
  manufacturer?: string
  modelNumber?: string
  firmwareVersion?: string
  serialNumber?: string
  cloudManaged: boolean
  modelId?: string
  capabilitySetId?: string
  capabilitySet?: GensetCapabilitySetModel | null
  defaultedFields?: string[]
}
export type CreateGeneratorRequest = {
  name?: string
  nodeId: string
  ratedPowerKw: number
  ratedApparentPowerKva?: number
  ratedVoltageV?: number
  ratedCurrentA?: number
  ratedFrequencyHz?: number
  /** AC phase configuration of the generator. Omit it when the phase configuration is unknown, or when the machine is a DC generator and has none */
  phaseConfiguration?: PhaseConfiguration
  fuelType: FuelType
  minPowerKw?: number
  maxPowerKw?: number
  manufacturer?: string
  modelNumber?: string
  firmwareVersion?: string
  serialNumber?: string
  cloudManaged?: boolean
  modelId?: string
  capabilitySetId?: string
}
export type PagedResponseGeneratorModel = {
  meta: PaginationMeta
  data: GeneratorModel[]
}
export type UpdateGeneratorRequest = {
  /** ID of the DER asset to update */
  id: string
  name?: string
  nodeId?: string
  ratedPowerKw?: number
  ratedApparentPowerKva?: number | null
  ratedVoltageV?: number | null
  ratedCurrentA?: number | null
  ratedFrequencyHz?: number | null
  phaseConfiguration?: PhaseConfiguration | null
  fuelType?: FuelType | null
  minPowerKw?: number | null
  maxPowerKw?: number | null
  manufacturer?: string | null
  modelNumber?: string | null
  firmwareVersion?: string | null
  serialNumber?: string | null
  cloudManaged?: boolean
  modelId?: string
  capabilitySetId?: string
}
export type InverterModel = {
  id: string
  name?: string
  nodeId: string
  siteId: string
  organizationId: string
  type: DerAssetType
  gridCapable: boolean
  islandable: boolean
  bidirectional: boolean
  pvHybrid: boolean
  phaseConfiguration?: PhaseConfiguration
  ratedPowerKw: number
  ratedApparentPowerKva?: number
  ratedVoltageV?: number
  ratedCurrentA?: number
  ratedFrequencyHz?: number
  minPowerKw?: number
  maxPowerKw?: number
  maxDcInputVoltageV?: number
  minDcInputVoltageV?: number
  maxDcInputCurrentA?: number
  maxDcInputPowerKw?: number
  mpptChannelCount?: number
  peakEfficiencyPct?: number
  cecEfficiencyPct?: number
  islandingProtection?: boolean
  manufacturer?: string
  modelNumber?: string
  firmwareVersion?: string
  serialNumber?: string
  modelId?: string
  capabilitySetId?: string
  capabilitySet?: InverterCapabilitySetModel | null
  defaultedFields?: string[]
}
export type CreateInverterRequest = {
  nodeId: string
  name: string
  ratedPowerKw: number
  gridCapable?: boolean
  islandable?: boolean
  bidirectional?: boolean
  pvHybrid?: boolean
  phaseConfiguration?: PhaseConfiguration
  ratedApparentPowerKva?: number
  ratedVoltageV?: number
  ratedCurrentA?: number
  ratedFrequencyHz?: number
  minPowerKw?: number
  maxPowerKw?: number
  maxDcInputVoltageV?: number
  minDcInputVoltageV?: number
  maxDcInputCurrentA?: number
  maxDcInputPowerKw?: number
  mpptChannelCount?: number
  peakEfficiencyPct?: number
  cecEfficiencyPct?: number
  islandingProtection?: boolean
  manufacturer?: string
  modelNumber?: string
  firmwareVersion?: string
  serialNumber?: string
  modelId?: string
  capabilitySetId?: string
}
export type PagedResponseInverterModel = {
  meta: PaginationMeta
  data: InverterModel[]
}
export type UpdateInverterRequest = {
  /** ID of the DER asset to update */
  id: string
  name?: string
  nodeId?: string
  gridCapable?: boolean
  islandable?: boolean
  bidirectional?: boolean
  pvHybrid?: boolean
  ratedPowerKw?: number
  phaseConfiguration?: PhaseConfiguration | null
  ratedApparentPowerKva?: number | null
  ratedVoltageV?: number | null
  ratedCurrentA?: number | null
  ratedFrequencyHz?: number | null
  minPowerKw?: number | null
  maxPowerKw?: number | null
  maxDcInputVoltageV?: number | null
  minDcInputVoltageV?: number | null
  maxDcInputCurrentA?: number | null
  maxDcInputPowerKw?: number | null
  mpptChannelCount?: number | null
  peakEfficiencyPct?: number | null
  cecEfficiencyPct?: number | null
  islandingProtection?: boolean | null
  manufacturer?: string | null
  modelNumber?: string | null
  firmwareVersion?: string | null
  serialNumber?: string | null
  modelId?: string
  capabilitySetId?: string
}
export type FuelTankFuelType = 'DIESEL' | 'PROPANE' | 'NATURAL_GAS' | 'GASOLINE' | 'HVO' | 'DEF'
export type TankShape = 'CYLINDRICAL' | 'RECTANGULAR' | 'CUSTOM'
export type FuelCapacityUnit = 'GALLONS' | 'LITERS'
export type FuelTankModel = {
  /** Unique identifier of the fuel tank */
  id: string
  /** Name of the fuel tank. Empty when no name has been set. */
  name?: string
  /** ID of the node the tank is installed at */
  nodeId: string
  /** ID of the site the tank's node belongs to */
  siteId: string
  /** ID of the organization that owns the tank's site */
  organizationId: string
  /** Asset type. Always FUEL_TANK. */
  type: DerAssetType
  /** Fuel the tank stores */
  fuelType: FuelTankFuelType
  /** Geometry of the vessel */
  tankShape: TankShape
  /** Nominal volume capacity of the tank, in capacityUnit */
  nominalVolume: number
  /** Unit the nominal volume is quoted in. Fill volumes reported for the tank are quoted in the same unit. */
  capacityUnit: FuelCapacityUnit
  /** Name of the company that built the tank. Null when it has not been recorded. */
  manufacturer?: string
  /** Manufacturer's model number for the tank. Null when it has not been recorded. */
  modelNumber?: string
  /** Firmware version of the tank's equipment. Null when it has not been recorded. */
  firmwareVersion?: string
  /** Manufacturer's serial number for the tank. Null when it has not been recorded. */
  serialNumber?: string
  /** Whether the tank is managed through the platform. A tank that is not is left out of list results unless includeLocalManaged is true. */
  cloudManaged: boolean
}
export type CreateFuelTankRequest = {
  /** Name of the fuel tank, up to 255 characters */
  name?: string
  /** ID of the node the tank is installed at. The tank's site and organization follow from the node. */
  nodeId: string
  /** Fuel the tank stores */
  fuelType: FuelTankFuelType
  /** Nominal volume capacity of the tank */
  nominalVolume: number
  /** Geometry of the vessel; defaults to CUSTOM when omitted */
  tankShape?: TankShape
  /** Unit the nominal volume is quoted in; defaults to GALLONS when omitted */
  capacityUnit?: FuelCapacityUnit
  /** Name of the company that built the tank, up to 255 characters */
  manufacturer?: string
  /** Manufacturer's model number for the tank, up to 255 characters */
  modelNumber?: string
  /** Firmware version of the tank's equipment, up to 255 characters */
  firmwareVersion?: string
  /** Manufacturer's serial number for the tank, up to 255 characters */
  serialNumber?: string
  /** Whether the tank is managed through the platform. Defaults to true. A tank created with false is left out of list results unless includeLocalManaged is true. */
  cloudManaged?: boolean
}
export type PagedResponseFuelTankModel = {
  meta: PaginationMeta
  data: FuelTankModel[]
}
export type UpdateFuelTankRequest = {
  /** ID of the fuel tank to update */
  id: string
  /** New name for the tank, up to 255 characters */
  name?: string
  /** ID of the node to move the tank to. Its site and organization follow the new node. */
  nodeId?: string
  /** Fuel the tank stores */
  fuelType?: FuelTankFuelType
  /** Nominal volume capacity of the tank, in its capacity unit */
  nominalVolume?: number
  /** Geometry of the vessel */
  tankShape?: TankShape
  /** Unit the nominal volume is quoted in. Cannot be changed once fuel level readings have been recorded for the tank. */
  capacityUnit?: FuelCapacityUnit
  /** Name of the company that built the tank, up to 255 characters. Null clears it. */
  manufacturer?: string | null
  /** Manufacturer's model number for the tank, up to 255 characters. Null clears it. */
  modelNumber?: string | null
  /** Firmware version of the tank's equipment, up to 255 characters. Null clears it. */
  firmwareVersion?: string | null
  /** Manufacturer's serial number for the tank, up to 255 characters. Null clears it. */
  serialNumber?: string | null
  /** Whether the tank is managed through the platform. A tank that is not is left out of list results unless includeLocalManaged is true. */
  cloudManaged?: boolean
}
export type FuelLevelIngestionResponse = {
  /** Readings in the request */
  received: number
  /** Readings stored by this request */
  accepted: number
  /** Readings skipped because a reading already existed for the tank at that timestamp */
  duplicates: number
}
export type FuelLevelReading = {
  /** When the level was measured, as an ISO-8601 timestamp. A value without a timezone offset is interpreted as UTC. Together with the tank this identifies the reading, so re-sending a reading with the same timestamp is a no-op rather than a second row. */
  eventTime: string
  /** How full the tank is, as a percentage of its nominal volume. At least one of fillPercentage and fillVolume is required. */
  fillPercentage?: number
  /** How much fuel the tank holds, in fillVolumeUnits. At least one of fillPercentage and fillVolume is required. */
  fillVolume?: number
  /** Unit fillVolume is quoted in. Must match the unit the tank's capacity is configured in. Defaults to that unit when omitted, and is ignored when no fillVolume is supplied. */
  fillVolumeUnits?: FuelCapacityUnit
}
export type FuelLevelReadingBatch = FuelLevelReading[]
export type FuelTankSnapshotResponse = {
  /** When the level was measured, as reported by the sensor */
  eventTime?: string | null
  /** How full the tank is, as a percentage of its nominal volume */
  fillPercentage?: number | null
  /** How much fuel the tank holds, in fillVolumeUnits */
  fillVolume?: number | null
  /** Unit fillVolume is quoted in. Null when no volume was reported. */
  fillVolumeUnits?: FuelCapacityUnit | null
}
export type FuelTankSample = {
  /** Bucket start time */
  timestamp: string
  /** How full the tank was over the bucket, as a percentage of its nominal volume */
  fillPercentage?: FloatDistribution
  /** How much fuel the tank held over the bucket, in the unit the tank's capacity is configured in */
  fillVolume?: FloatDistribution
}
export type PagedResponseFuelTankSample = {
  meta: PaginationMeta
  data: FuelTankSample[]
}
export type FuelTankAggregatesResponse = {
  /** Fill percentage of the newest reading in the range, as a percentage of the tank's nominal volume */
  latestFillPercentage?: number | null
  /** Fill volume of the newest reading in the range. Null when that reading reported no volume, even if an earlier one in the range did. */
  latestFillVolume?: number | null
  /** Lowest fill percentage reported in the range */
  minFillPercentage?: number | null
  /** Highest fill percentage reported in the range */
  maxFillPercentage?: number | null
  /** Net decrease in volume across the range: the first reported volume minus the last, never below zero. A range that ends fuller than it started reports 0. Refills inside the range are not added back, so this understates fuel actually burned whenever the tank was refilled mid-range. */
  netVolumeConsumed?: number | null
}
export type GridConnectionModel = {
  id: string
  name?: string
  nodeId: string
  siteId: string
  organizationId: string
  type: DerAssetType
  ratedImportKw?: number | null
  exportEnabled: boolean
  ratedExportKw?: number
  serviceVoltage?: number
  utilityName?: string
  manufacturer?: string
  modelNumber?: string
  firmwareVersion?: string
  serialNumber?: string
  cloudManaged: boolean
}
export type CreateGridConnectionRequest = {
  name?: string
  nodeId: string
  /** Maximum power the site may draw from the utility, in kilowatts. Omit it when the service carries no contractual ceiling or the ceiling is not known; the connection then records no import limit */
  ratedImportKw?: number
  /** Whether the interconnection permits exporting power to the utility */
  exportEnabled?: boolean
  /** Maximum power the site may export to the utility, in kilowatts. Required when export is enabled, and rejected when it is not */
  ratedExportKw?: number
  /** Nominal voltage of the utility service, in volts */
  serviceVoltage?: number
  /** Name of the utility providing the service */
  utilityName?: string
  manufacturer?: string
  modelNumber?: string
  firmwareVersion?: string
  serialNumber?: string
  cloudManaged?: boolean
}
export type PagedResponseGridConnectionModel = {
  meta: PaginationMeta
  data: GridConnectionModel[]
}
export type UpdateGridConnectionRequest = {
  /** ID of the DER asset to update */
  id: string
  name?: string
  nodeId?: string
  ratedImportKw?: number | null
  exportEnabled?: boolean
  ratedExportKw?: number | null
  serviceVoltage?: number | null
  utilityName?: string | null
  manufacturer?: string | null
  modelNumber?: string | null
  firmwareVersion?: string | null
  serialNumber?: string | null
  cloudManaged?: boolean
}
export type LoadCategory = 'BUILDING' | 'HVAC' | 'LIGHTING' | 'PROCESS' | 'OTHER'
export type LoadModel = {
  id: string
  name?: string
  nodeId: string
  siteId: string
  organizationId: string
  type: DerAssetType
  ratedPowerKw?: number | null
  loadCategory: LoadCategory
  managed: boolean
  manufacturer?: string
  modelNumber?: string
  firmwareVersion?: string
  serialNumber?: string
  cloudManaged: boolean
}
export type CreateLoadRequest = {
  name?: string
  nodeId: string
  /** Nameplate power draw of the load, in kilowatts. Omit it when the load is unsized; the load then records no rated draw */
  ratedPowerKw?: number
  /** Kind of consumer this load represents; defaults to OTHER when omitted */
  loadCategory?: LoadCategory
  /** Whether this load is one the platform is allowed to switch. Recording the designation only; no control is performed today. */
  managed?: boolean
  manufacturer?: string
  modelNumber?: string
  firmwareVersion?: string
  serialNumber?: string
  cloudManaged?: boolean
}
export type PagedResponseLoadModel = {
  meta: PaginationMeta
  data: LoadModel[]
}
export type UpdateLoadRequest = {
  /** ID of the DER asset to update */
  id: string
  name?: string
  nodeId?: string
  ratedPowerKw?: number | null
  loadCategory?: LoadCategory
  managed?: boolean
  manufacturer?: string | null
  modelNumber?: string | null
  firmwareVersion?: string | null
  serialNumber?: string | null
  cloudManaged?: boolean
}
export type PanelModel = {
  id: string
  name?: string
  nodeId: string
  siteId: string
  organizationId: string
  type: DerAssetType
  ratedAmperageA?: number
  ratedVoltageV?: number
  phaseConfiguration?: PhaseConfiguration
  numCircuits?: number
  /** The most power, in kW, the site draws through this panel. It is what the site chooses to run the panel at, and is never above what the panel's rating allows (three-phase: 1.732 x rated voltage x rated amperage). Power boost holds grid import at this limit, and for a panel a Link's controls name, refuses one above the power the Link's panel limit carries at this panel's voltage and phase. */
  operatingLimitKw?: number | null
  manufacturer?: string
  modelNumber?: string
  firmwareVersion?: string
  serialNumber?: string
  cloudManaged: boolean
  modelId?: string
  capabilitySetId?: string
  capabilitySet?: PanelCapabilitySetModel | null
  defaultedFields?: string[]
}
export type CreatePanelRequest = {
  name?: string
  nodeId: string
  ratedAmperageA?: number
  ratedVoltageV?: number
  phaseConfiguration?: PhaseConfiguration
  numCircuits?: number
  /** The most power, in kW, the site draws through this panel. It is what the site chooses to run the panel at, and is never above what the panel's rating allows (three-phase: 1.732 x rated voltage x rated amperage). Power boost holds grid import at this limit, and for a panel a Link's controls name, refuses one above the power the Link's panel limit carries at this panel's voltage and phase. */
  operatingLimitKw?: number
  manufacturer?: string
  modelNumber?: string
  firmwareVersion?: string
  serialNumber?: string
  cloudManaged?: boolean
  modelId?: string
  capabilitySetId?: string
}
export type PagedResponsePanelModel = {
  meta: PaginationMeta
  data: PanelModel[]
}
export type UpdatePanelRequest = {
  /** ID of the DER asset to update */
  id: string
  name?: string
  nodeId?: string
  ratedAmperageA?: number | null
  ratedVoltageV?: number | null
  phaseConfiguration?: PhaseConfiguration | null
  numCircuits?: number | null
  /** The most power, in kW, the site draws through this panel. It is what the site chooses to run the panel at, and is never above what the panel's rating allows (three-phase: 1.732 x rated voltage x rated amperage). Power boost holds grid import at this limit, and for a panel a Link's controls name, refuses one above the power the Link's panel limit carries at this panel's voltage and phase. Omit to keep; null clears. */
  operatingLimitKw?: number | null
  manufacturer?: string | null
  modelNumber?: string | null
  firmwareVersion?: string | null
  serialNumber?: string | null
  cloudManaged?: boolean
  modelId?: string
  capabilitySetId?: string
}
export type SolarArrayModel = {
  id: string
  name?: string
  nodeId: string
  siteId: string
  organizationId: string
  type: DerAssetType
  nameplateDcPowerKw: number
  ratedAcPowerKw?: number
  make?: string
  model?: string
  manufacturer?: string
  modelNumber?: string
  firmwareVersion?: string
  serialNumber?: string
  cloudManaged: boolean
}
export type CreateSolarArrayRequest = {
  name?: string
  nodeId: string
  nameplateDcPowerKw: number
  ratedAcPowerKw?: number
  make?: string
  model?: string
  manufacturer?: string
  modelNumber?: string
  firmwareVersion?: string
  serialNumber?: string
  cloudManaged?: boolean
}
export type PagedResponseSolarArrayModel = {
  meta: PaginationMeta
  data: SolarArrayModel[]
}
export type UpdateSolarArrayRequest = {
  /** ID of the DER asset to update */
  id: string
  name?: string
  nodeId?: string
  nameplateDcPowerKw?: number
  ratedAcPowerKw?: number | null
  make?: string | null
  model?: string | null
  manufacturer?: string | null
  modelNumber?: string | null
  firmwareVersion?: string | null
  serialNumber?: string | null
  cloudManaged?: boolean
}
export type CellularStatusModel = {
  /** AWS IoT thing name for the SynopLink device */
  entityId: string
  /** Timestamp of the status event */
  eventTime: string
  /** Connection state */
  state?: string
  /** Cellular carrier name */
  carrier?: string
  /** Signal quality metric (0-100) */
  signalQuality?: number
  /** International Mobile Subscriber Identity */
  imsi?: string
  /** International Mobile Equipment Identity */
  imei?: string
  /** Integrated Circuit Card Identifier */
  iccid?: string
  /** Cellular frequency band */
  band?: string
  /** Received Signal Strength Indicator (dBm) */
  rssi?: number
  /** Reference Signal Received Quality (dB) */
  rsrq?: number
  /** Reference Signal Received Power (dBm) */
  rsrp?: number
  /** Signal-to-Noise Ratio (dB) */
  snr?: number
}
export type CellularStatusHistoryResponse = {
  /** AWS IoT thing name for the SynopLink device */
  entityId: string
  /** Time-series data points ordered by event time */
  data: CellularStatusModel[]
}
export type JsonValue = unknown
export type EnergyEntityType =
  | 'charger'
  | 'battery'
  | 'generator'
  | 'panel'
  | 'load'
  | 'grid_connection'
  | 'inverter'
  | 'beacon'
export type ConnectedDeviceModel = {
  /** Unique identifier of the connected device */
  id: string
  /** Parent connected-device ID when this device is nested under another device on the same SynopLink */
  parentId?: string
  /** Kind of device on the SynopLink local network (for example meter, charger, battery, or switch) */
  deviceType: ConnectedDeviceType
  /** Hardware or firmware model used to collect and interpret this device's data */
  modelType?: string
  /** Display name for the connected device */
  name?: string
  /** IPv4 or IPv6 address of the device on the local network */
  ipAddress?: string | null
  /** Ethernet or Wi-Fi MAC address of the device, if known */
  macAddress?: string | null
  /** Device-specific configuration key/value pairs */
  config?: {
    [key: string]: JsonValue
  }
  /** Identifier of the energy asset this device is linked to, if any */
  energyEntityId?: string
  /** Type of energy asset this device is linked to (for example charger, battery, generator, or panel) */
  energyEntityType?: EnergyEntityType
  /** Site where the connected device is located */
  siteId: string
  /** SynopLink through which this device is connected */
  synoplinkId?: string
  /** When the connected device record was created */
  createdAt: string
  /** When the connected device record was last updated */
  updatedAt: string
  /** Whether the device's current configuration has been confirmed applied by its SynopLink. `applies_on_restart` means the configuration was saved and is correct, and this SynopLink cannot pick it up until it restarts or is updated, so it will not change on its own. Null on list endpoints, for devices not configured with a hardware or firmware model, and on a create or update that did not change the device's configuration. Fetch the device to read it in that case. */
  configurationStatus?: ('pending' | 'applied' | 'applies_on_restart') | null
}
export type CreateConnectedDeviceRequest = {
  /** The SynopLink this device connects through */
  synoplinkId: string
  /** Parent device in the hierarchy (must belong to the same SynopLink) */
  parentId?: string
  /** Type of device */
  deviceType: ConnectedDeviceType
  /** Hardware/firmware model of the device, used to determine how its data is collected and interpreted */
  modelType?: string
  /** Display name */
  name?: string
  /** IPv4 or IPv6 address on the local network */
  ipAddress?: string
  /** MAC address in format AA:BB:CC:DD:EE:FF or AA-BB-CC-DD-EE-FF */
  macAddress?: string
  /** Device-specific configuration */
  config?: {
    [key: string]: JsonValue
  }
  /** Associated energy entity ID */
  energyEntityId?: string
  /** Type of the associated energy entity */
  energyEntityType?: EnergyEntityType
}
export type PagedResponseConnectedDeviceModel = {
  meta: PaginationMeta
  data: ConnectedDeviceModel[]
}
export type UpdateConnectedDeviceRequest = {
  /** Parent device in the hierarchy (must belong to the same SynopLink) */
  parentId?: string | null
  /** Hardware/firmware model of the device, used to determine how its data is collected and interpreted */
  modelType?: string | null
  /** Display name */
  name?: string | null
  /** IPv4 or IPv6 address on the local network */
  ipAddress?: string | null
  /** MAC address in format AA:BB:CC:DD:EE:FF or AA-BB-CC-DD-EE-FF */
  macAddress?: string | null
  /** Device-specific configuration */
  config?: {
    [key: string]: JsonValue
  } | null
  /** Associated energy entity ID */
  energyEntityId?: string | null
  /** Type of the associated energy entity */
  energyEntityType?: EnergyEntityType | null
}
export type SynopLinkConnectivityLatestModel = {
  /** Unique identifier of the SynopLink */
  synoplinkId: string
  /** AWS IoT thing name for the SynopLink device */
  thingName: string
  /** Whether the SynopLink's VPN tunnel to the backend is up */
  online?: boolean
  /** Event time of the most recent snapshot (i.e. last contact) */
  lastEventTime: string
  /** VPN IP address reported in the most recent snapshot */
  ipAddress?: string
}
export type ConnectivityIntervalStatus = 'online' | 'offline' | 'unknown'
export type ConnectivityInterval = {
  /** Connectivity state held during the interval */
  status: ConnectivityIntervalStatus
  /** Inclusive start of the interval */
  start: string
  /** Exclusive end of the interval */
  end: string
  /** Length of the interval in whole seconds */
  durationSeconds: number
}
export type ConnectivitySummary = {
  /** Online share of known time: onlineSeconds / (onlineSeconds + offlineSeconds) * 100. 0.0 when there is no known online/offline data. Unknown time is excluded. */
  uptimePercent: number
  /** Total online time, in seconds */
  onlineSeconds: number
  /** Total offline time, in seconds */
  offlineSeconds: number
  /** Total time in an unknown state, in seconds */
  unknownSeconds: number
  /** Number of distinct offline intervals */
  outageCount: number
  /** Duration of the longest offline interval, in seconds */
  longestOutageSeconds: number
}
export type ConnectivityIntervalsResponse = {
  /** Unique identifier of the SynopLink */
  synoplinkId: string
  /** AWS IoT thing name for the SynopLink device */
  thingName: string
  /** Inclusive start of the resolved query window */
  from: string
  /** Exclusive end of the resolved query window */
  to: string
  /** Connectivity intervals ordered by start time */
  intervals: ConnectivityInterval[]
  /** Aggregate connectivity statistics over the window */
  summary: ConnectivitySummary
}
export type CurtailmentReason =
  | 'LOW_SOC'
  | 'COMMS_LOSS'
  | 'BATTERY_ALARM'
  | 'HEALTHY'
  | 'ALARM_PARTIAL'
  | 'ALARM_FULL'
  | 'RUN_STATE_DEGRADED'
  | 'COMMS_STALE'
  | 'OFFLINE'
  | 'UNKNOWN'
  | 'SUPPLY_SHORT'
  | 'DERATED'
export type Unit = 'KW' | 'AMPS'
export type AppliedLimit = {
  unit: Unit
  value: number
}
export type LowSocCurtailmentCreated = {
  eventId?: string
  curtailmentId: string
  derUuid: string
  generatedAt: string
  eventType?: 'low_soc_curtailment_created'
  appliedLimit: AppliedLimit
  socAtTrigger: number
  socEntryThreshold: number
  socRecoveryThreshold: number
}
export type CommsLossCurtailmentCreated = {
  eventId?: string
  curtailmentId: string
  derUuid: string
  generatedAt: string
  eventType?: 'comms_loss_curtailment_created'
  appliedLimit: AppliedLimit
  commsLost: string
  lastHealthyReadingAt?: string | null
}
export type BatteryAlarmCurtailmentCreated = {
  eventId?: string
  curtailmentId: string
  derUuid: string
  generatedAt: string
  eventType?: 'battery_alarm_curtailment_created'
  appliedLimit: AppliedLimit
  alarmCodes: string[]
  observedAlarmCodes?: string[] | null
}
export type LowSocCurtailmentEnded = {
  eventId?: string
  curtailmentId: string
  derUuid: string
  generatedAt: string
  eventType?: 'low_soc_curtailment_ended'
  socAtRecovery: number
}
export type CommsLossCurtailmentEnded = {
  eventId?: string
  curtailmentId: string
  derUuid: string
  generatedAt: string
  eventType?: 'comms_loss_curtailment_ended'
}
export type BatteryAlarmCurtailmentEnded = {
  eventId?: string
  curtailmentId: string
  derUuid: string
  generatedAt: string
  eventType?: 'battery_alarm_curtailment_ended'
}
export type NodeAvailabilityAssetType = 'BESS' | 'GENERATOR'
export type NodeCurtailmentEventAsset = {
  derId: string
  type: NodeAvailabilityAssetType
  reason: CurtailmentReason
  ratedKw: number
  availableKw: number
}
export type NodeCurtailmentCreated = {
  eventId?: string
  curtailmentId: string
  siteId: string
  nodeId: string
  generatedAt: string
  staticLimitKw: number
  availableKw: number
  eventType?: 'node_curtailment_created'
  reason: CurtailmentReason
  appliedLimit: AppliedLimit
  assets?: NodeCurtailmentEventAsset[]
}
export type NodeCurtailmentChanged = {
  eventId?: string
  curtailmentId: string
  siteId: string
  nodeId: string
  generatedAt: string
  staticLimitKw: number
  availableKw: number
  eventType?: 'node_curtailment_changed'
  reason: CurtailmentReason
  appliedLimit: AppliedLimit
  assets?: NodeCurtailmentEventAsset[]
}
export type NodeCurtailmentEnded = {
  eventId?: string
  curtailmentId: string
  siteId: string
  nodeId: string
  generatedAt: string
  staticLimitKw: number
  availableKw: number
  eventType?: 'node_curtailment_ended'
  assets?: NodeCurtailmentEventAsset[]
}
export type ActorType = 'USER' | 'ORGANIZATION'
export type Actor = {
  actorType: ActorType
  id: string
}
export type CurtailmentOverridden = {
  eventId?: string
  curtailmentId: string
  derUuid: string
  generatedAt: string
  eventType?: 'curtailment_overridden'
  requestedBy: Actor
  overrideLimit?: AppliedLimit | null
  note?: string | null
}
export type CurtailmentOverrideRevoked = {
  eventId?: string
  curtailmentId: string
  derUuid: string
  generatedAt: string
  eventType?: 'curtailment_override_revoked'
  revokedBy: Actor
  revokedOverrideId: string
  note?: string | null
}
export type CurtailmentEventModel = {
  recordedAt: string
  acknowledgedAt?: string
  payload:
    | LowSocCurtailmentCreated
    | CommsLossCurtailmentCreated
    | BatteryAlarmCurtailmentCreated
    | LowSocCurtailmentEnded
    | CommsLossCurtailmentEnded
    | BatteryAlarmCurtailmentEnded
    | NodeCurtailmentCreated
    | NodeCurtailmentChanged
    | NodeCurtailmentEnded
    | CurtailmentOverridden
    | CurtailmentOverrideRevoked
}
export type CurtailmentWindowModel = {
  curtailmentId: string
  nodeId: string
  siteId?: string
  derId?: string
  reason?: CurtailmentReason
  startedAt?: string
  endedAt?: string
  events: CurtailmentEventModel[]
}
export type PagedResponseCurtailmentWindowModel = {
  meta: PaginationMeta
  data: CurtailmentWindowModel[]
}
export type DeviceHealthSummaryModel = {
  /** AWS IoT thing name for the SynopLink device */
  entityId: string
  /** Stable per-publish UUID minted on the device */
  eventId: string
  /** Always the literal 'deviceHealth' */
  eventType: string
  /** UTC instant the snapshot was assembled on the device */
  eventTime: string
  /** Worst-of per-section rollup: one of 'healthy', 'warning', 'degraded', 'critical' */
  health: string
  /** Version of the on-device health agent that produced the event */
  rscVersion: string
  /** Free-form {section_path: reason_string} map populated only for non-healthy sections */
  healthReasons?: {
    [key: string]: string | number | boolean | null | object
  }
  /** Host distro NAME */
  osName?: string
  /** Host distro VERSION_ID */
  osVersion?: string
  /** Host distro PRETTY_NAME */
  osPretty?: string
  /** `uname -r` output */
  kernelRelease?: string
  /** `uname -m` output */
  arch?: string
  /** Best-effort hardware identifier */
  hardwareModel?: string
  /** Whole-host CPU utilization percent */
  cpuPct?: number
  /** Total physical RAM */
  memTotalMb?: number
  /** Resident memory in use */
  memUsedMb?: number
  /** Memory available without swapping */
  memAvailableMb?: number
  /** Total disk capacity at the host root mount */
  diskTotalGb?: number
  /** Disk used at the host root */
  diskUsedGb?: number
  /** Disk free at the host root */
  diskAvailableGb?: number
  /** Best-effort CPU package temperature in degrees C */
  tempCpuC?: number
  /** Seconds since the host booted */
  uptimeS?: number
  /** 1-minute load average */
  loadAvg1M?: number
  /** 5-minute load average */
  loadAvg5M?: number
  /** 15-minute load average */
  loadAvg15M?: number
  /** All thermal zones the kernel exposed, keyed by zone type */
  tempZones?: {
    [key: string]: string | number | boolean | null | object
  }
  /** IPv4 of the first ethernet interface */
  lan1Ip?: string
  /** IPv4 of the second ethernet interface */
  lan2Ip?: string
  /** IPv4 of the OpenVPN tun* or tap* interface */
  vpnIp?: string
  /** True iff a tun* or tap* interface has an IPv4 address */
  vpnConnected: boolean
  /** True iff a tun* or tap* interface exists at all */
  vpnInterfacePresent: boolean
  /** IPv4 from a wwan* or ppp* cellular interface */
  cellularIp?: string
  /** True iff a TCP connect to 1.1.1.1:443 succeeded within 3s */
  internetReachable: boolean
  /** True iff DNS resolution for one.one.one.one succeeded */
  dnsOk: boolean
  /** True iff a cellular modem is detected */
  modemDetected: boolean
  /** Default-route gateway IP or egress device */
  gateway?: string
  /** Connected client count on the on-device broker */
  mqttConnectedClients?: number
  /** Broker-reported 1-minute message rate (msgs/sec) */
  mqttMsgRate1M?: number
  /** Broker-reported 5-minute message rate (msgs/sec) */
  mqttMsgRate5M?: number
  /** Broker-reported 15-minute message rate (msgs/sec) */
  mqttMsgRate15M?: number
  /** Distinct device state documents tracked by the relay component */
  mqttShadowCount?: number
  /** Broker-reported retained message count */
  mqttRetainedMessages?: number
  /** Broker-reported active subscription count */
  mqttSubscriptions?: number
  /** Raw $SYS/# topic snapshot keyed by topic path */
  mqttSysTopics?: {
    [key: string]: string | number | boolean | null | object
  }
  /** Redis used_memory in MiB */
  redisMemoryMb?: number
  /** Whether Redis AOF persistence is enabled */
  redisAofEnabled?: boolean
  /** Last AOF fsync status */
  redisAofLastWriteStatus?: string
  /** Last AOF rewrite status */
  redisAofLastBgrewriteStatus?: string
  /** LLEN of the relay's outbound event queue */
  redisRelayQueueDepth?: number
  /** Seconds since the last successful RDB snapshot */
  redisLastSaveS?: number
  /** Redis uptime in seconds */
  redisUptimeS?: number
  /** Curated subset of Redis INFO captured for forward compatibility */
  redisInfo?: {
    [key: string]: string | number | boolean | null | object
  }
}
export type DeviceHealthContainerModel = {
  /** Docker container name */
  name: string
  /** Raw docker container state (e.g. 'running', 'exited', 'restarting'); the synthetic value 'missing' is used for previously-seen components that are no longer present. */
  status?: string
  /** Full image reference */
  image?: string
  /** Image tag parsed from the image reference */
  version?: string
  /** Cumulative docker RestartCount since container creation */
  restartCount?: number
  /** Number of restarts observed in the trailing 5 minutes */
  restarts5M: number
  /** Seconds since the container was last started */
  uptimeS?: number
  /** Container CPU utilization as a percent of whole-host capacity */
  cpuPct?: number
  /** Container memory usage in MiB */
  memUsageMb?: number
  /** True when the container restarted at least 3 times in the trailing 5 minutes (forces device-level health to critical) */
  crashLoopDetected: boolean
}
export type DeviceHealthInterfaceModel = {
  /** Kernel interface name */
  name: string
  /** First IPv4 address bound to the interface */
  ipv4?: string
  /** First globally-scoped IPv6 address */
  ipv6?: string
  /** Effective operational state (UP, DOWN, NO-CARRIER, ...) */
  operstate?: string
}
export type DeviceHealthSnapshotModel = {
  /** AWS IoT thing name for the SynopLink device */
  entityId: string
  /** Stable per-publish UUID minted on the device */
  eventId: string
  /** Always the literal 'deviceHealth' */
  eventType: string
  /** UTC instant the snapshot was assembled on the device */
  eventTime: string
  /** Worst-of per-section rollup: one of 'healthy', 'warning', 'degraded', 'critical' */
  health: string
  /** Version of the on-device health agent that produced the event */
  rscVersion: string
  /** Free-form {section_path: reason_string} map populated only for non-healthy sections */
  healthReasons?: {
    [key: string]: string | number | boolean | null | object
  }
  /** Host distro NAME */
  osName?: string
  /** Host distro VERSION_ID */
  osVersion?: string
  /** Host distro PRETTY_NAME */
  osPretty?: string
  /** `uname -r` output */
  kernelRelease?: string
  /** `uname -m` output */
  arch?: string
  /** Best-effort hardware identifier */
  hardwareModel?: string
  /** Whole-host CPU utilization percent */
  cpuPct?: number
  /** Total physical RAM */
  memTotalMb?: number
  /** Resident memory in use */
  memUsedMb?: number
  /** Memory available without swapping */
  memAvailableMb?: number
  /** Total disk capacity at the host root mount */
  diskTotalGb?: number
  /** Disk used at the host root */
  diskUsedGb?: number
  /** Disk free at the host root */
  diskAvailableGb?: number
  /** Best-effort CPU package temperature in degrees C */
  tempCpuC?: number
  /** Seconds since the host booted */
  uptimeS?: number
  /** 1-minute load average */
  loadAvg1M?: number
  /** 5-minute load average */
  loadAvg5M?: number
  /** 15-minute load average */
  loadAvg15M?: number
  /** All thermal zones the kernel exposed, keyed by zone type */
  tempZones?: {
    [key: string]: string | number | boolean | null | object
  }
  /** IPv4 of the first ethernet interface */
  lan1Ip?: string
  /** IPv4 of the second ethernet interface */
  lan2Ip?: string
  /** IPv4 of the OpenVPN tun* or tap* interface */
  vpnIp?: string
  /** True iff a tun* or tap* interface has an IPv4 address */
  vpnConnected: boolean
  /** True iff a tun* or tap* interface exists at all */
  vpnInterfacePresent: boolean
  /** IPv4 from a wwan* or ppp* cellular interface */
  cellularIp?: string
  /** True iff a TCP connect to 1.1.1.1:443 succeeded within 3s */
  internetReachable: boolean
  /** True iff DNS resolution for one.one.one.one succeeded */
  dnsOk: boolean
  /** True iff a cellular modem is detected */
  modemDetected: boolean
  /** Default-route gateway IP or egress device */
  gateway?: string
  /** Connected client count on the on-device broker */
  mqttConnectedClients?: number
  /** Broker-reported 1-minute message rate (msgs/sec) */
  mqttMsgRate1M?: number
  /** Broker-reported 5-minute message rate (msgs/sec) */
  mqttMsgRate5M?: number
  /** Broker-reported 15-minute message rate (msgs/sec) */
  mqttMsgRate15M?: number
  /** Distinct device state documents tracked by the relay component */
  mqttShadowCount?: number
  /** Broker-reported retained message count */
  mqttRetainedMessages?: number
  /** Broker-reported active subscription count */
  mqttSubscriptions?: number
  /** Raw $SYS/# topic snapshot keyed by topic path */
  mqttSysTopics?: {
    [key: string]: string | number | boolean | null | object
  }
  /** Redis used_memory in MiB */
  redisMemoryMb?: number
  /** Whether Redis AOF persistence is enabled */
  redisAofEnabled?: boolean
  /** Last AOF fsync status */
  redisAofLastWriteStatus?: string
  /** Last AOF rewrite status */
  redisAofLastBgrewriteStatus?: string
  /** LLEN of the relay's outbound event queue */
  redisRelayQueueDepth?: number
  /** Seconds since the last successful RDB snapshot */
  redisLastSaveS?: number
  /** Redis uptime in seconds */
  redisUptimeS?: number
  /** Curated subset of Redis INFO captured for forward compatibility */
  redisInfo?: {
    [key: string]: string | number | boolean | null | object
  }
  /** Per-container snapshots captured with this event */
  containers?: DeviceHealthContainerModel[]
  /** Per-network-interface snapshots captured with this event */
  interfaces?: DeviceHealthInterfaceModel[]
}
export type PagedResponseDeviceHealthSnapshotModel = {
  meta: PaginationMeta
  data: DeviceHealthSnapshotModel[]
}
export type SimCardSyncResponse = {
  /** Number of new SIM cards inserted */
  created: number
  /** Number of existing SIM cards whose host fields changed */
  updated: number
  /** Number of SIM cards that were already up-to-date or retired */
  unchanged: number
  /** Number of SIM cards left unchanged because their ICCID is already assigned to a different SIM */
  conflicts?: number
}
export type SimProvider = 'TEAL' | 'VERIZON'
export type HostDeviceType = 'SYNOPLINK' | 'CHARGER'
export type SimCardUpsertItem = {
  providerName: SimProvider
  providerId: string
  iccid: string
  imsi?: string
  imei?: string
  hostDeviceType?: HostDeviceType
  hostDeviceId?: string
}
export type SimCardModel = {
  /** Unique identifier for the SIM card */
  id: string
  /** SIM provider */
  providerName: SimProvider
  /** Provider-specific SIM identifier */
  providerId: string
  /** SIM card identifier, cross-reference key across data sources */
  iccid: string
  /** Subscriber identifier on the network */
  imsi?: string
  /** Hardware identifier of the modem the SIM is installed in */
  imei?: string
  /** Type of device the SIM is installed in */
  hostDeviceType?: HostDeviceType
  /** Identifier of the host device */
  hostDeviceId?: string
  /** Timestamp when the SIM was retired, null if active */
  retiredAt?: string
}
export type VpnStateSnapshotModel = {
  eventTime: string
  thingName: string
  shadowName?: string
  online?: boolean
  ipAddress?: string
  reportedState?: {
    [key: string]: string | number | boolean | null | object
  }
}
export type PagedResponseVpnStateSnapshotModel = {
  meta: PaginationMeta
  data: VpnStateSnapshotModel[]
}
export type PagedResponseDerMakeModel = {
  meta: PaginationMeta
  data: DerMakeModel[]
}
export type CreateDerMakeRequest = {
  name: string
}
export type UpdateDerMakeRequest = {
  name?: string
  expectedUpdatedAt?: string
}
export type PagedResponseDerModelModel = {
  meta: PaginationMeta
  data: DerModelModel[]
}
export type CreateBessCapabilitySetRequest = {
  version?: string
  published?: boolean
  notes?: string
  knownQuirks?: DerCapabilityQuirks
  assetType?: 'BESS'
  maxRatedChargePowerKw: number
  maxRatedDischargePowerKw: number
  minChargePowerKw?: number
  minDischargePowerKw?: number
  ratedStorageCapacityKwh: number
  usableStorageCapacityKwh?: number
  nominalVoltageV?: number
  providesPackLevelData?: boolean
  providesRackLevelData?: boolean
  providesCellLevelData?: boolean
  supportsGridForming?: boolean
  supportsIslanding?: boolean
  supportsRemoteModeChange?: boolean
  supportedOperatingModes?: string[]
  chemistry?: BessChemistry
}
export type CreateGensetCapabilitySetRequest = {
  version?: string
  published?: boolean
  notes?: string
  knownQuirks?: DerCapabilityQuirks
  assetType?: 'GENSET'
  ratedPowerKw: number
  ratedApparentPowerKva: number
  ratedVoltageV: number
  ratedCurrentA: number
  ratedFrequencyHz: number
  phaseConfiguration: PhaseConfiguration
  fuelType: FuelType
  minPowerKw: number
  maxPowerKw: number
  supportsRemoteStart?: boolean
  supportsRemoteStop?: boolean
}
export type CreatePanelCapabilitySetRequest = {
  version?: string
  published?: boolean
  notes?: string
  knownQuirks?: DerCapabilityQuirks
  assetType?: 'PANEL'
  ratedAmperageA: number
  ratedVoltageV: number
  phaseConfiguration: PhaseConfiguration
  numCircuits: number
  supportsPerCircuitTelemetry?: boolean
  supportsPerCircuitControl?: boolean
}
export type CreateInverterCapabilitySetRequest = {
  version?: string
  published?: boolean
  notes?: string
  knownQuirks?: DerCapabilityQuirks
  assetType?: 'INVERTER'
  gridCapable?: boolean
  islandable?: boolean
  bidirectional?: boolean
  pvHybrid?: boolean
  ratedPowerKw: number
  ratedVoltageV: number
  mpptCount: number
  peakEfficiencyPct?: number
  supportsReactivePowerControl?: boolean
}
export type CreateDerModelRequest = {
  makeId: string
  assetType: DerAssetType
  name: string
  helperText?: string
  capabilitySet:
    | CreateBessCapabilitySetRequest
    | CreateGensetCapabilitySetRequest
    | CreatePanelCapabilitySetRequest
    | CreateInverterCapabilitySetRequest
}
export type UpdateDerModelRequest = {
  name?: string
  helperText?: string
  defaultCapabilitySetId?: string
  expectedUpdatedAt?: string
}
export type PagedResponseAnnotatedUnionBessCapabilitySetModelGensetCapabilitySetModelPanelCapabilitySetModelInverterCapabilitySetModelFieldInfoannotationNoneTyperequiredTruediscriminatorassettype =
  {
    meta: PaginationMeta
    data: (BessCapabilitySetModel | GensetCapabilitySetModel | PanelCapabilitySetModel | InverterCapabilitySetModel)[]
  }
export type UpdateDerCapabilitySetRequest = {
  notes?: string
  knownQuirks?: DerCapabilityQuirks
  published?: boolean
  expectedUpdatedAt?: string
}
export type CommandType =
  | 'power_on'
  | 'power_off'
  | 'clear_alarms'
  | 'set_control_mode'
  | 'close_breaker'
  | 'open_breaker'
export type CommandStatus = 'processed' | 'failed' | 'rejected' | 'timeout'
export type DerCommandOutcome = {
  /** Always `derCommandOutcome`. A command's non-2xx responses carry this outcome rather than an error document, so check `kind` to tell an outcome from an error response. */
  kind: 'derCommandOutcome'
  /** Correlation id for this command. Look the command up by it to read an outcome that resolved after the response was sent. */
  requestId: string
  derId: string
  command: CommandType
  /** Resolved outcome. `timeout` means the outcome is unknown -- the command may still have executed on the device -- not that it failed to run; confirm the physical effect via device telemetry. */
  status: CommandStatus
  /** Why the command ended the way it did, as a machine-readable code such as `precondition_unmet`, `bad_value` or `no_result_in_time`. Null when the device did not report one. New codes are added over time, so treat an unrecognised code as unknown rather than as an error. */
  reasonCode?: string | null
  /** What the device is believed to have done about the command: `none` (nothing was written), `maybe` (a write was attempted and its fate is unknown), `acknowledged` (the device accepted the write) or `confirmed` (a read-back confirmed it). Null when the device did not report one. */
  effect?: string | null
  /** Failure or rejection reason, if any. */
  error?: string | null
}
export type DerCommandRequest = {
  /** The control command to issue. */
  command: CommandType
  /** Scalar argument for value-carrying commands, such as the control mode for set_control_mode. The accepted values differ by generator model. When the device publishes the values it accepts, a value outside them is refused with a rejected outcome (422) whose error lists the accepted values; otherwise the device itself validates the value and rejects one it does not support. */
  value?: string | null
  /** Optional structured command arguments. */
  data?: {
    [key: string]: unknown
  } | null
}
export type DerCommandRequires = {
  /** The control modes the device must be in for the command to take effect, spelled as the control-mode values the API accepts. */
  controlModes: string[]
}
export type DerCommandCapability = {
  /** The control command the device accepts. */
  command: CommandType
  /** The values the device accepts for this command, in display order. Null when the command is not restricted to a fixed set of values. An empty list means the command takes no value, and a value sent with it is refused. */
  values?: string[] | null
  /** How to read `values`, as a hint for rendering: `enum` (the value is one of `values`) or `none` (the command takes no value). Null when the device gave no hint. Other kinds may be added over time, so treat an unrecognised one as unknown. */
  valueKind?: string | null
  /** A hint that the command only acts when the device is in one of the listed control modes, so a client can show the control disabled with its reason. Advisory: the device enforces its own precondition and the API does not check this. Null means no hint, not that the command has no precondition. */
  requires?: DerCommandRequires | null
}
export type DerCommandCapabilities = {
  /** Unique identifier of the DER asset. */
  derId: string
  /** The commands the device accepts, in the order it lists them. An empty list means the device accepts no remote commands. Null means the device has not published a list, so any command may be sent and the device itself rejects one it does not implement. */
  commands?: DerCommandCapability[] | null
}
export type CurtailmentOverrideResponse = {
  overrideId: string
  generatedAt: string
}
export type CurtailmentOverrideRequest = {
  nodeId: string
  curtailmentId: string
  overrideLimit?: AppliedLimit | null
  note?: string | null
}
export type CurtailmentOverrideRevokeResponse = {
  eventId: string
  generatedAt: string
}
export type MeterPhaseReading = {
  currentRms?: number | null
  voltageLn?: number | null
  thetaDeg?: number | null
  activePowerKw?: number | null
  reactivePowerKvar?: number | null
  apparentPowerKva?: number | null
  powerFactor?: number | null
  /** Signed power reported directly by the meter's own measurement hardware, when the meter provides one, as an independent complement to activePowerKw's calculated value. */
  nativeActivePowerKw?: number | null
}
export type MeterSnapshotResponse = {
  eventTime?: string | null
  lineFrequencyHz?: number | null
  phaseA?: MeterPhaseReading | null
  phaseB?: MeterPhaseReading | null
  phaseC?: MeterPhaseReading | null
  activePowerKw?: number | null
  reactivePowerKvar?: number | null
  apparentPowerKva?: number | null
  powerFactor?: number | null
  /** Combined signed power reported directly by the meter's own measurement hardware, when the meter provides one, as an independent complement to activePowerKw's calculated value. */
  nativeActivePowerKw?: number | null
}
export type MeterPhaseSample = {
  currentRms?: FloatDistribution
  voltageLn?: FloatDistribution
  thetaDeg?: FloatDistribution
  activePowerKw?: FloatDistribution
  reactivePowerKvar?: FloatDistribution
  apparentPowerKva?: FloatDistribution
  powerFactor?: FloatDistribution
  /** Signed power reported directly by the meter's own measurement hardware, when the meter provides one, as an independent complement to activePowerKw's calculated value. */
  nativeActivePowerKw?: FloatDistribution
}
export type MeterSample = {
  /** Bucket start time */
  timestamp: string
  lineFrequencyHz?: FloatDistribution
  phaseA: MeterPhaseSample
  phaseB: MeterPhaseSample
  phaseC: MeterPhaseSample
  activePowerKw?: FloatDistribution
  reactivePowerKvar?: FloatDistribution
  apparentPowerKva?: FloatDistribution
  powerFactor?: FloatDistribution
  /** Combined signed power reported directly by the meter's own measurement hardware, when the meter provides one, as an independent complement to activePowerKw's calculated value. */
  nativeActivePowerKw?: FloatDistribution
}
export type PagedResponseMeterSample = {
  meta: PaginationMeta
  data: MeterSample[]
}
export type EntityType =
  | 'SYNOPLINK'
  | 'GENERATOR'
  | 'BATTERY'
  | 'PANEL'
  | 'CHARGER'
  | 'VEHICLE'
  | 'SITE'
  | 'SOLAR_ARRAY'
  | 'INVERTER'
  | 'METER'
export type NoteModel = {
  id: string
  entityId: string
  entityType: EntityType
  note: string
  isPinned: boolean
  timestamp: string
  createdByUserId: string
  organizationId: string
}
export type CreateNoteRequest = {
  entityId: string
  entityType: EntityType
  /** Note text */
  note: string
  /** Whether the note is pinned */
  isPinned?: boolean
  /** When the note was authored; defaults to the current time. A value with no UTC offset is interpreted as UTC. */
  timestamp?: string
}
export type PagedResponseNoteModel = {
  meta: PaginationMeta
  data: NoteModel[]
}
export type UpdateNoteRequest = {
  /** Whether the note is pinned */
  isPinned?: boolean
}
export type EnergySystemComponentModel = {
  /** Identifier of the component within its energy system, and the identifier connections reference */
  componentId: string
  /** Display name for the component */
  name?: string
  /** Identifier of the equipment archetype the component was created from */
  archetypeId?: string
  /** Type of the asset this component represents (for example a battery, charger, or meter) */
  entityType?: string
  /** Identifier of the asset this component represents */
  entityId?: string
  /** Full component definition: its capabilities, connection points and the media they carry */
  definition: {
    [key: string]: unknown
  }
}
export type EnergySystemConnectionModel = {
  /** Identifier of the connection within its energy system */
  connectionId: string
  /** Full connection definition: the two connection points it joins and its ratings */
  definition: {
    [key: string]: unknown
  }
}
export type EnergySystemMeasurementPointModel = {
  /** Identifier of the measurement point within its energy system */
  measurementPointId: string
  /** Kind of device the readings come from. Measurement points read from connected devices. */
  meterEntityType?: string
  /** Identifier of the device the readings come from */
  meterEntityId?: string
  /** Full measurement point definition: the device it reads from, the connection point whose flow it observes, the quantities it measures, and which direction of flow it reports as positive */
  definition: {
    [key: string]: unknown
  }
}
export type Severity = 'ERROR' | 'WARNING' | 'INFO'
export type EnergySystemFindingModel = {
  /** Stable identifier for the kind of issue detected */
  code: string
  /** How serious the issue is: an error prevents the energy system from describing a workable installation, a warning flags something likely wrong, and info is advisory */
  severity: Severity
  /** Identifier of what the issue is about: a component, a comma-separated group of components, or the energy system itself */
  subjectId: string
  /** Human-readable explanation of the issue */
  message: string
}
export type EnergySystemDetailModel = {
  /** Unique identifier of the energy system */
  id: string
  /** Site the energy system belongs to */
  siteId: string
  /** Organization that owns the energy system */
  organizationId: string
  /** Display name for the energy system */
  name: string
  /** Free-text description of what the energy system covers */
  description?: string
  /** When the energy system was created */
  createdAt: string
  /** When the energy system last changed, counting changes to the equipment and connections in it as well as to the system itself */
  updatedAt: string
  /** Version of the energy system, rising every time the system changes. A reader holding an earlier copy can compare versions to tell whether this system has moved without comparing the whole topology. Two changes within the same second share a version. */
  version: number
  /** Equipment in the energy system. Empty until components are added. */
  components: EnergySystemComponentModel[]
  /** Connections between the energy system's components */
  connections: EnergySystemConnectionModel[]
  /** Metering devices bound to the places in the energy system whose flow they read. A meter is not equipment in the graph: it observes a connection point on equipment that is. */
  measurementPoints: EnergySystemMeasurementPointModel[]
  /** Issues detected in the energy system as it currently stands, recomputed on every read. Empty when nothing is wrong. */
  findings: EnergySystemFindingModel[]
}
export type CreateEnergySystemRequest = {
  /** Site the energy system belongs to */
  siteId: string
  /** Display name for the energy system */
  name: string
  /** Free-text description of what the energy system covers */
  description?: string
}
export type EnergySystemModel = {
  /** Unique identifier of the energy system */
  id: string
  /** Site the energy system belongs to */
  siteId: string
  /** Organization that owns the energy system */
  organizationId: string
  /** Display name for the energy system */
  name: string
  /** Free-text description of what the energy system covers */
  description?: string
  /** When the energy system was created */
  createdAt: string
  /** When the energy system last changed, counting changes to the equipment and connections in it as well as to the system itself */
  updatedAt: string
  /** Version of the energy system, rising every time the system changes. A reader holding an earlier copy can compare versions to tell whether this system has moved without comparing the whole topology. Two changes within the same second share a version. */
  version: number
  /** Number of components (equipment) in the energy system */
  componentCount: number
  /** Number of connections joining components in the energy system */
  connectionCount: number
  /** Components in this energy system that stand for the asset the request looked up. Empty unless the request named one. */
  matchedComponentIds: string[]
}
export type PagedResponseEnergySystemModel = {
  meta: PaginationMeta
  data: EnergySystemModel[]
}
export type ComponentEntityType =
  | 'BATTERY'
  | 'GENERATOR'
  | 'PANEL'
  | 'INVERTER'
  | 'SOLAR_ARRAY'
  | 'FUEL_TANK'
  | 'LOAD'
  | 'GRID_CONNECTION'
  | 'CHARGER'
  | 'METER'
export type SolveHoleGroupModel = {
  /** Which quantity could not be determined */
  quantity: string
  /** Why the quantity could not be determined */
  reason: string
  /** How many undetermined quantities the group holds, one per subject and phase. Always the whole number, even when ``subjects`` was shortened. */
  count: number
  /** What the quantities belong to, sorted, each listed once whatever its phases: connections, connection points on a piece of equipment, or pieces of equipment */
  subjects: string[]
  /** Whether ``subjects`` was shortened to keep the published summary within its size limit */
  subjectsTruncated: boolean
}
export type ConflictKind = 'MEASUREMENT' | 'PHYSICS' | 'IMBALANCE' | 'ENERGIZATION' | 'DIRECTION'
export type Phase = 'A' | 'B' | 'C'
export type SolveConflictModel = {
  /** What sort of disagreement this is */
  kind: ConflictKind
  /** What the quantity belongs to: a connection, a connection point on a piece of equipment, or a piece of equipment */
  subject: string
  /** Which quantity the disagreement is about */
  quantity: string
  /** The phase the quantity is on, or null when it is not per-phase */
  phase: Phase | null
  /** The value the solve took */
  winnerValue: number | null
  /** Where the value the solve took came from */
  winnerSource: string | null
  /** The value the solve set aside */
  otherValue: number | null
  /** Where the value the solve set aside came from */
  otherSource: string | null
  /** How far apart the two values are */
  delta: number | null
  /** Anything further the solve said about it */
  detail: string | null
}
export type SolveImbalanceModel = {
  /** How many points in the energy system whose flows were all known did not sum to zero */
  count: number
  /** The largest of those shortfalls in power, in kilowatts. Null when none of them is a power imbalance. */
  maxDeltaKw: number | null
}
export type SolveClassSummaryModel = {
  /** The class's net power in kilowatts, positive when the class is putting power into the energy system. Null when none of its values could be determined, which is not the same as zero. */
  netKw: number | null
  /** How many of the class's values came back at each quality, keyed by quality name */
  qualityCounts: {
    [key: string]: number
  }
  /** The share of the class's equipment whose net power was determined, from 0 to 1 */
  coverageFraction: number | null
}
export type SolveSummaryModel = {
  /** The energy system that was solved */
  systemId: string
  /** The instant the solve describes */
  asOf: string
  /** Identifier of the solve, derived from its inputs, so the same inputs give the same identifier */
  solveId: string
  /** Equipment that held the grid reference, absorbing whatever the rest of the energy system did not account for */
  slackComponentIds: string[]
  /** What the balance the grid reference absorbs was worked out from. Null when there is no such balance. */
  residualBasis: string | null
  /** Every quantity the solve could not determine, one group per quantity and reason, largest group first */
  holeGroups: SolveHoleGroupModel[]
  /** The disagreements the solve found between determinations */
  conflicts: SolveConflictModel[]
  /** Whether ``conflicts`` was shortened to keep the published summary within its size limit */
  conflictsTruncated: boolean
  /** How far the fully known parts failed to balance */
  imbalance: SolveImbalanceModel
  /** Each equipment class's share of the solve, keyed by class name (grid, generation, storage, chargers, other_loads) */
  classSummary: {
    [key: string]: SolveClassSummaryModel
  }
  /** Version of the solver that ran */
  solverVersion: string
  /** Version of the energy system's topology the solve ran against, where it is known */
  topologyVersion: number | null
  /** Every piece of equipment the solve covered, keyed by component id, with the identifier of the solve that last changed it */
  components: {
    [key: string]: string
  }
}
export type EnergySystemLatestSolveModel = {
  /** Identifier of the solve. Together with ``asOf`` it says which state this is, so a client applying later updates can tell a repeat of this state from a newer one. */
  solveId: string
  /** The instant the solve describes */
  asOf: string
  /** The solve's summary, in the same shape the live power-flow feed sends it */
  summary: SolveSummaryModel
}
export type EnergySystemPowerFlowSummaryModel = {
  /** The energy system */
  energySystemId: string
  /** The equipment classes this energy system has equipment in, in display order: grid, generation, storage, chargers, other_loads. Worked out from the system's topology, so it is known before the system has ever been solved. A class with no equipment is left out, and equipment that belongs to no class (panels, transformers, switches, inverters, fuel equipment, vehicles) adds none. Empty when no equipment falls in any class. */
  classes: ('grid' | 'generation' | 'storage' | 'chargers' | 'other_loads')[]
  /** The newest solve stored for this energy system, however old it is. Null when the system has never been solved. */
  latestSolve: EnergySystemLatestSolveModel | null
}
export type PagedResponseEnergySystemPowerFlowSummaryModel = {
  meta: PaginationMeta
  data: EnergySystemPowerFlowSummaryModel[]
}
export type PowerFlowHistoryClassModel = {
  /** The class's net power in kilowatts, summed across the site's energy systems, positive when the class is putting power into the site: the grid supplying it, generation producing, storage discharging. Null when any energy system with equipment in the class has no determined value for the bucket, which is not the same as zero. */
  netKw: number | null
  /** The share of the class's equipment whose net power was determined, from 0 to 1, weighted across the site's energy systems by how much equipment each has in the class. Null when any of those systems has no value for the bucket. */
  coverageFraction: number | null
}
export type PowerFlowHistoryPointModel = {
  /** Start of the bucket */
  time: string
  /** Each equipment class the site has equipment in, keyed by class name, in display order: grid, generation, storage, chargers, other_loads */
  classes: {
    [key: string]: PowerFlowHistoryClassModel
  }
}
export type SitePowerFlowHistoryModel = {
  /** The site */
  siteId: string
  /** The bucket size */
  resolution: '1m' | '5m' | '15m' | '1h'
  /** The energy systems the points are summed across: every energy system at the site the caller can access that has equipment in at least one class, ordered by name */
  energySystemIds: string[]
  /** One point per bucket in which at least one of those energy systems was solved, oldest first. A bucket with no solve at all is left out rather than reported as zero. */
  points: PowerFlowHistoryPointModel[]
}
export type UnplacedAssetModel = {
  /** Kind of asset, in the vocabulary a component's binding uses (for example BATTERY or CHARGER) */
  entityType: string
  /** Identifier of the asset: its ID for an energy resource, its charge-box ID for a charger */
  entityId: string
  /** The asset's display name */
  name: string
  /** Equipment archetype the suggested component is built from. Send it with the component to record where the component came from. */
  archetypeId: string
  /** A ready-made starting component standing for this asset: the archetype's preset, named after the asset and bound to it, with an identifier derived from the asset so every read suggests the same one. It can be added to any of the site's energy systems as it comes, then filled in with real ratings. */
  component: {
    [key: string]: unknown
  }
}
export type PagedResponseUnplacedAssetModel = {
  meta: PaginationMeta
  data: UnplacedAssetModel[]
}
export type UpdateEnergySystemRequest = {
  /** Display name for the energy system */
  name?: string
  /** Free-text description of what the energy system covers */
  description?: string | null
}
export type CreateEnergySystemComponentRequest = {
  /** Full component definition: its identifier within the energy system, its capabilities, and the connection points it offers with the media they carry */
  definition: {
    [key: string]: unknown
  }
  /** Identifier of the equipment archetype this component was created from. Recorded alongside the component and used to report whether it still meets that archetype's requirements. */
  archetypeId?: string
}
export type UpdateEnergySystemComponentRequest = {
  /** Full replacement component definition. Its identifier must match the component being updated. */
  definition: {
    [key: string]: unknown
  }
  /** Identifier of the equipment archetype this component was created from. Omit to leave the recorded archetype unchanged. */
  archetypeId?: string | null
}
export type EnergySystemGraphDeletionModel = {
  /** Unique identifier of the energy system */
  id: string
  /** Site the energy system belongs to */
  siteId: string
  /** Organization that owns the energy system */
  organizationId: string
  /** Display name for the energy system */
  name: string
  /** Free-text description of what the energy system covers */
  description?: string
  /** When the energy system was created */
  createdAt: string
  /** When the energy system last changed, counting changes to the equipment and connections in it as well as to the system itself */
  updatedAt: string
  /** Version of the energy system, rising every time the system changes. A reader holding an earlier copy can compare versions to tell whether this system has moved without comparing the whole topology. Two changes within the same second share a version. */
  version: number
  /** Equipment in the energy system. Empty until components are added. */
  components: EnergySystemComponentModel[]
  /** Connections between the energy system's components */
  connections: EnergySystemConnectionModel[]
  /** Metering devices bound to the places in the energy system whose flow they read. A meter is not equipment in the graph: it observes a connection point on equipment that is. */
  measurementPoints: EnergySystemMeasurementPointModel[]
  /** Issues detected in the energy system as it currently stands, recomputed on every read. Empty when nothing is wrong. */
  findings: EnergySystemFindingModel[]
  /** Connections removed alongside the requested deletion because they ended at the component being removed. Empty when deleting a connection or a measurement point, neither of which takes anything else with it. */
  cascadedConnectionIds: string[]
  /** Measurement points removed alongside the requested deletion because they observed the component being removed. Empty when deleting a connection or a measurement point. */
  cascadedMeasurementPointIds: string[]
}
export type AddComponentChange = {
  /** Full component definition: its identifier within the energy system, its capabilities, and the connection points it offers with the media they carry */
  definition: {
    [key: string]: unknown
  }
  /** Identifier of the equipment archetype this component was created from. Recorded alongside the component and used to report whether it still meets that archetype's requirements. */
  archetypeId?: string
  /** The kind of change */
  op: 'addComponent'
}
export type ReplaceComponentChange = {
  /** Full replacement component definition. Its identifier must match the component being updated. */
  definition: {
    [key: string]: unknown
  }
  /** Identifier of the equipment archetype this component was created from. Omit to leave the recorded archetype unchanged. */
  archetypeId?: string | null
  /** The kind of change */
  op: 'replaceComponent'
  /** Identifier of the component being replaced. Must match the definition's own identifier. */
  componentId: string
}
export type DeleteComponentChange = {
  /** The kind of change */
  op: 'deleteComponent'
  /** Identifier of the component being removed */
  componentId: string
}
export type AddConnectionChange = {
  /** Full connection definition: its identifier within the energy system and the two connection points it joins */
  definition: {
    [key: string]: unknown
  }
  /** The kind of change */
  op: 'addConnection'
}
export type DeleteConnectionChange = {
  /** The kind of change */
  op: 'deleteConnection'
  /** Identifier of the connection being removed */
  connectionId: string
}
export type AddMeasurementPointChange = {
  /** Full measurement point definition: its identifier within the energy system, the device it reads from, and the connection point whose flow it observes */
  definition: {
    [key: string]: unknown
  }
  /** The kind of change */
  op: 'addMeasurementPoint'
}
export type ReplaceMeasurementPointChange = {
  /** Full replacement measurement point definition. Its identifier must match the measurement point being updated. */
  definition: {
    [key: string]: unknown
  }
  /** The kind of change */
  op: 'replaceMeasurementPoint'
  /** Identifier of the measurement point being replaced. Must match the definition's own identifier. */
  measurementPointId: string
}
export type DeleteMeasurementPointChange = {
  /** The kind of change */
  op: 'deleteMeasurementPoint'
  /** Identifier of the measurement point being removed */
  measurementPointId: string
}
export type ApplyEnergySystemChangesRequest = {
  /** The changes to make, in the order they are made. Each one is checked against the energy system as the changes before it left it, and only the end result has to hold together. */
  changes: (
    | AddComponentChange
    | ReplaceComponentChange
    | DeleteComponentChange
    | AddConnectionChange
    | DeleteConnectionChange
    | AddMeasurementPointChange
    | ReplaceMeasurementPointChange
    | DeleteMeasurementPointChange
  )[]
}
export type CreateEnergySystemMeasurementPointRequest = {
  /** Full measurement point definition: its identifier within the energy system, the device it reads from, and the connection point whose flow it observes */
  definition: {
    [key: string]: unknown
  }
}
export type UpdateEnergySystemMeasurementPointRequest = {
  /** Full replacement measurement point definition. Its identifier must match the measurement point being updated. */
  definition: {
    [key: string]: unknown
  }
}
export type Determinacy = 'MEASURED' | 'DERIVABLE' | 'RESIDUAL' | 'UNDETERMINED'
export type EnergySystemCoverageRedundancyModel = {
  /** What is established more than once: a connection, or a piece of equipment when it is that equipment's net flow */
  subject: string
  /** Which quantity is established more than once: the power or the fluid flow on a connection, or a piece of equipment's net power or net fluid flow */
  quantity: string
  /** The independent ways this quantity can be established, carrying no precedence between them: a named meter, a port the equipment reports on its own, the equipment's report of its own net, conservation through equipment that neither produces nor consumes, the balance of one piece of equipment's other flows, or the balance the grid reference absorbs */
  paths: string[]
}
export type EnergySystemCoverageModel = {
  /** Whether every flow in the energy system can be established. False when at least one is unknowable from the metering declared. */
  fullyDetermined: boolean
  /** Whether any flow in the energy system can be established more than one way. This is corroboration rather than a fault: two readings of the same quantity check each other. It is independent of whether the system is fully determined, and a system can be both, either or neither. */
  overdetermined: boolean
  /** Equipment that holds the grid reference and absorbs whatever the rest of the system does not account for. Null when the wiring does not say unambiguously which one that is, in which case no amount of metering settles the balance. */
  slackComponentId?: string
  /** The assumption this whole answer is worked out under. Every meter, every port a device reports on its own, and every device that reports its own net is taken to send a fresh value. Equipment that goes quiet leaves exactly the gaps this answer predicts of it. */
  reportingRule: string
  /** How each connection's flow can be established, by connection id */
  connections: {
    [key: string]: Determinacy
  }
  /** How each piece of equipment's net flow can be established, by component id */
  components: {
    [key: string]: Determinacy
  }
  /** Every quantity more than one reading establishes, with the ways each can be established. Empty when nothing is corroborated. */
  redundancy: EnergySystemCoverageRedundancyModel[]
  /** The gaps, in plain language: what cannot be established and what that blocks. Empty when the energy system is fully determined. */
  holes: string[]
}
export type EnergySystemLayoutPositionModel = {
  /** Identifier of the component within its energy system, the same identifier connections reference */
  componentId: string
  /** Which of the diagram's columns the component sits in, counted from the left starting at 0. How wide a column is drawn follows from what is in it, so a layout records the column rather than a horizontal position. */
  column: number
  /** How far the component's top edge sits below the top of the drawing, in diagram units (pixels at full size) */
  y: number
}
export type EnergySystemLayoutModel = {
  /** The energy system this layout arranges */
  energySystemId: string
  /** Where each component the layout places sits, ordered by column, then from the top. Only components currently in the energy system are listed. Empty when nothing is saved and the diagram is arranged automatically. A component the layout does not place, such as one added since it was saved, is placed automatically by whoever draws the diagram. */
  positions: EnergySystemLayoutPositionModel[]
}
export type ReplaceEnergySystemLayoutRequest = {
  /** Where each component sits. Each component may appear once, and each must be in the energy system. Components left out are placed automatically. An empty list saves no layout, the same as resetting it. */
  positions: EnergySystemLayoutPositionModel[]
}
export type CreateEnergySystemConnectionRequest = {
  /** Full connection definition: its identifier within the energy system and the two connection points it joins */
  definition: {
    [key: string]: unknown
  }
}
export type EnergySystemArchetypeModel = {
  /** Stable identifier for the archetype */
  id: string
  /** Display name for the archetype */
  name: string
  /** What this kind of equipment is and how it behaves */
  description: string
  /** Broad family of asset a component built from this archetype stands for. Coarser than the kinds a component can be bound to: every kind of distributed energy resource is one family here. */
  entityType: string
  /** Capabilities a component must have to count as this kind of equipment */
  required: (
    | 'produces_power'
    | 'consumes_power'
    | 'stores_energy'
    | 'converts_power'
    | 'transmits_power'
    | 'supplies_fluid'
    | 'consumes_fluid'
    | 'stores_fluid'
    | 'grid_formable'
    | 'parallelable'
    | 'grid_followable'
    | 'startable'
    | 'power_settable'
    | 'power_schedulable'
  )[]
  /** Groups of alternatives: a component must have at least one capability from each group */
  anyOf: (
    | 'produces_power'
    | 'consumes_power'
    | 'stores_energy'
    | 'converts_power'
    | 'transmits_power'
    | 'supplies_fluid'
    | 'consumes_fluid'
    | 'stores_fluid'
    | 'grid_formable'
    | 'parallelable'
    | 'grid_followable'
    | 'startable'
    | 'power_settable'
    | 'power_schedulable'
  )[][]
  /** Capabilities this kind of equipment usually has. A component missing one is still valid, and is reported as a warning. */
  recommended: (
    | 'produces_power'
    | 'consumes_power'
    | 'stores_energy'
    | 'converts_power'
    | 'transmits_power'
    | 'supplies_fluid'
    | 'consumes_fluid'
    | 'stores_fluid'
    | 'grid_formable'
    | 'parallelable'
    | 'grid_followable'
    | 'startable'
    | 'power_settable'
    | 'power_schedulable'
  )[]
  /** A complete starting component for this archetype, ready to be added to an energy system and then filled in with real ratings */
  preset: {
    [key: string]: unknown
  }
}
export type PagedResponseEnergySystemArchetypeModel = {
  meta: PaginationMeta
  data: EnergySystemArchetypeModel[]
}
export type EmsPlacementSiteIdsModel = {
  /** Sites whose energy management runs where the request asked, in ascending order. Empty when no site does. */
  siteIds?: string[]
}
export type EmsPlacementTarget = 'cloud' | 'link'
export type ScopeRegistryModel = {
  /** Every site this SynopLink is asked to keep energy data for, each against a marker saying the request is in force. More than one site is supported by the device and by this API; today a SynopLink serves the single site it is installed at. */
  sites?: {
    [key: string]: number
  }
  /** Whether this site is among them, which is what a placement on a SynopLink asks for and what a placement in the cloud withdraws. */
  containsSite: boolean
  /** Revision of the device's stored request, which advances every time either side writes to it. Null before the device has one. */
  revision?: number
}
export type EmsPlacementModel = {
  /** Site this placement is for. */
  siteId: string
  /** Where the site's energy management runs. A site that has never been placed runs in the cloud. */
  managedBy: EmsPlacementTarget
  /** Device name of the SynopLink whose stored request carries this site. When the site is managed from the cloud, the SynopLink it was last released from -- null if it was never on one. */
  linkThingName?: string
  /** Whether the platform publishes energy data for this site at all. False means a SynopLink placed here would be asked for a site that nothing feeds, and the placement will not take effect until the site is published; the placement is still recorded. */
  energyDataPublished: boolean
  /** When the placement was last set. Null if it never was. */
  updatedAt?: string
  /** What the SynopLink named above is currently asked to keep energy data for. Null when no SynopLink has ever been named for this site, and also when the device's stored request could not be read -- the placement itself is reported either way. */
  desired?: ScopeRegistryModel
}
export type SetEmsPlacementRequest = {
  /** Where the site's energy management runs: in the cloud, or on the SynopLink installed at the site. */
  managedBy: EmsPlacementTarget
  /** Device name of the SynopLink the site's energy management runs on. Required when running on a SynopLink. When moving a site back to the cloud it may be given to name the SynopLink to release the site from; leaving it out releases the site from whichever SynopLink it was last placed on. */
  linkThingName?: string
}
export type ScopeSweepAccepted = {
  /** The scope whose bundles will be rebuilt. */
  scopeId: string
  /** The bundle groups the requested rebuild covers. */
  groups: string[]
}
export type SynopLinkLifecycleStatus =
  | 'ordered'
  | 'received'
  | 'checked_in'
  | 'provisioned'
  | 'shipped'
  | 'installed'
  | 'commissioned'
  | 'retired'
export type SynopLinkType = 'physical' | 'cloud'
export type SynopLinkModel = {
  /** Unique identifier of the SynopLink */
  id: string
  /** Display name shown for the SynopLink in the Synop platform */
  nickName: string
  /** Unique cloud device name used to identify this SynopLink */
  thingName: string
  /** Manufacturer serial number printed on the SynopLink hardware, stored uppercase and limited to letters, digits and dashes. Null for devices whose serial has not been recorded. */
  serialNumber?: string
  /** Cloud region where the SynopLink is registered */
  awsRegion: string
  /** Organization that owns this SynopLink */
  organizationId: string
  /** Site where the SynopLink is installed, if assigned */
  siteId?: string
  /** Optional free-text description of the SynopLink */
  description?: string
  /** Cellular SIM currently associated with this SynopLink, or null when no active SIM has been matched */
  simCard?: SimCardModel
  /** Whether the SynopLink's VPN tunnel to Synop is currently up. Null when connectivity state has not been observed yet. */
  online?: boolean
  /** VPN IP address of the SynopLink when online; null when unknown */
  ipAddress?: string
  /** When the platform last received a health report from the device itself; null if never. The device publishes one about every minute, so this is the device-originated reading of how recently it was heard from. It is independent of the VPN state fields beside it, which describe the tunnel rather than the device. */
  lastHeard?: string
  /** IP address of the SynopLink on its local site network, if known */
  localIpAddress?: string
  /** Inventory lifecycle status of the SynopLink (for example ordered, shipped, installed, or commissioned). Null for devices that predate lifecycle tracking. */
  lifecycleStatus?: SynopLinkLifecycleStatus
  /** Whether this SynopLink is a physical appliance or a cloud-hosted instance. */
  linkType?: SynopLinkType
}
export type PagedResponseSynopLinkModel = {
  meta: PaginationMeta
  data: SynopLinkModel[]
}
export type CreateSynopLinkRequest = {
  /** User-friendly display name for the SynopLink */
  nickName: string
  /** AWS IoT thing name for the SynopLink */
  thingName: string
  /** Manufacturer serial number printed on the SynopLink hardware. Stored uppercase; letters, digits and dashes only. */
  serialNumber?: string
  /** Organization to assign this SynopLink to. Defaults to the Synop organization when omitted. */
  organizationId?: string
  /** Site where the SynopLink is installed */
  siteId?: string
  /** Description of the SynopLink */
  description?: string
  /** Local network IP address of the SynopLink (IPv4 or IPv6) */
  localIpAddress?: string
  /** Initial lifecycle status for the SynopLink; defaults to ordered. */
  lifecycleStatus?: SynopLinkLifecycleStatus
  /** The kind of host this SynopLink runs on, which decides whether it is registered with ethernet addressing. A physical SynopLink is given the default addressing for its two ports, so it is managed from the moment it is registered. A cloud SynopLink runs on a hosted instance that has no ethernet ports to configure and is registered without any addressing. Defaults to physical. */
  linkType?: SynopLinkType
}
export type UpdateSynopLinkRequest = {
  /** User-friendly display name for the SynopLink */
  nickName?: string
  /** Organization to reassign this SynopLink to. The site must end up cleared: send siteId as null in the same request, or clear it beforehand. Keeping the current site, or assigning a new one, is rejected. */
  organizationId?: string
  /** Site where the SynopLink is installed. Set to null to unset. */
  siteId?: string | null
  /** Description of the SynopLink. Set to null to unset. */
  description?: string | null
  /** Lifecycle status to assign to this SynopLink */
  lifecycleStatus?: SynopLinkLifecycleStatus
  /** Manufacturer serial number printed on the SynopLink hardware. Stored uppercase; letters, digits and dashes only. Set to null to unset. */
  serialNumber?: string | null
  /** Whether this SynopLink is a physical appliance or a cloud-hosted instance. Corrects a misclassified row; does not re-run ethernet addressing seeding. */
  linkType?: SynopLinkType
}
export type SynopLinkConnectivityStatus = {
  /** Whether the SynopLink is currently online and reachable */
  isOnline: boolean
  /** Timestamp when the SynopLink entered its current online session. Null when the device is offline or the start time is unknown. */
  onlineSince?: string
  /** Most recent time the SynopLink was observed online. Null when no connectivity observation is available yet. */
  lastHeartbeat?: string
}
export type ConnectedDevicesResponse = {
  /** Connected devices on the SynopLink's local network. Empty when no devices have been discovered or configured. */
  devices: ConnectedDeviceModel[]
}
export type OcppProxyOutboundFilter = 'ALLOW_ALL' | 'BLOCK_ALL' | 'BLOCK_LIST' | 'ALLOW_LIST'
export type OcppProxyUpstreamRole = 'PRIMARY' | 'FALLBACK'
export type OcppProxyUpstreamModel = {
  /** Name identifying this backend. Referenced by the response routing table and used in the controller's logs. The name 'synop' is reserved for Synop's own backend. */
  name: string
  /** Whether the controller connects to this backend. Disabled backends are ignored entirely and cannot receive charger traffic. */
  enabled: boolean
  /** Which commands this backend may send to the charger: all of them, none of them, all except a blocked list, or only an allowed list. */
  outboundFilter: OcppProxyOutboundFilter
  /** OCPP actions this backend may not send to the charger. Applies only when the outbound filter is a blocked list. */
  blockedActions?: string[]
  /** The only OCPP actions this backend may send to the charger. Applies only when the outbound filter is an allowed list. */
  allowedActions?: string[]
  /** Longest the controller waits between attempts to reconnect a dropped connection to this backend. Left unset, the controller's own default applies. */
  reconnectMaxBackoffSeconds?: number
  /** OCPP actions this backend may send to the charger even while it is not the authoritative one. Everything else it sends is dropped until authority moves to it. */
  alwaysAllowedActions?: string[]
  /** Websocket URL of the backend charge management system (CMS). Null for Synop's own backend, which the SynopLink reaches on its own network at an address Synop manages. */
  url?: string
  /** This backend's part in primary/fallback routing: 'PRIMARY' manages the site's chargers day to day, 'FALLBACK' takes over while the primary is unreachable. Follows the SynopLink's proxy mode, and is null while neither part applies. */
  role?: OcppProxyUpstreamRole
}
export type OcppProxyRoutingMode = 'STATIC' | 'PRIMARY_FALLBACK'
export type OcppProxyFailoverTrigger = 'NETWORK_STATUS_EVENT'
export type OcppProxyEngageModel = {
  /** How long the site must have been unable to reach the primary backend before the SynopLink takes over managing its chargers, so that a brief interruption does not move the site. */
  delaySeconds?: number
}
export type OcppProxySwapBackStrategy = 'FIXED_DELAY' | 'REPLAY_COMPLETE'
export type OcppProxySwapBackModel = {
  /** What the proxy waits for before handing authority back: 'FIXED_DELAY' waits for the primary's connection to hold for 'delaySeconds', 'REPLAY_COMPLETE' waits until the traffic the primary missed has been replayed to it. */
  strategy?: OcppProxySwapBackStrategy
  /** How long the primary's connection must hold before it becomes authoritative again. Applies to the 'FIXED_DELAY' strategy. */
  delaySeconds?: number
}
export type OcppProxyBufferModel = {
  /** OCPP actions from the charger that are held and replayed to the primary backend once it is reachable again. The single entry '*' means every action the charger sends, minus the excluded ones -- so a backend is sent what it missed without each message it cares about having to be named. A list of action names instead holds exactly those and nothing else. */
  actions?: string[]
  /** OCPP actions the '*' wildcard does not hold. Heartbeats and boot notifications are excluded unless a configuration says otherwise, because both state something untrue when they arrive late: a heartbeat reports the charger alive at a moment that has passed, and a boot notification says it restarted at the moment the backend became reachable again. Applies only alongside the wildcard, so it is reported empty for a configuration naming actions -- an action absent from that list is already not held -- and supplying it beside one is rejected. */
  excludeActions?: string[]
  /** How many held messages a single charger may accumulate before the oldest are dropped. */
  maxMessagesPerCharger?: number
}
export type OcppProxyBackfillAuthScheme = 'HMAC_SHA256' | 'BEARER' | 'NONE'
export type OcppProxyCommandBackfillModel = {
  /** HTTP endpoint the SynopLink posts the recorded commands to. Left unset, the commands are still recorded but not delivered -- the shape for a site whose endpoint isn't settled yet, so the record exists from the first outage rather than from the day delivery is configured. */
  endpointUrl?: string
  /** How the SynopLink authenticates to that endpoint: 'HMAC_SHA256' signs each request body, 'BEARER' sends a static token, 'NONE' sends neither and suits a receiver that authenticates by network position. */
  authScheme?: OcppProxyBackfillAuthScheme
  /** Name of the entry in the SynopLink's own deployment configuration holding the signing key or token. This is a name, not a credential: the credential itself is never sent to or stored by this API. */
  secretRef?: string
  /** How many recorded commands the SynopLink keeps awaiting delivery before the oldest are dropped. */
  maxEvents?: number
  /** How many recorded commands are delivered per request. */
  maxEventsPerBatch?: number
}
export type OcppProxyFailoverModel = {
  /** The signal that moves authority to the fallback backend. 'NETWORK_STATUS_EVENT' follows the SynopLink's own view of its connection to Synop. */
  trigger?: OcppProxyFailoverTrigger
  /** When the SynopLink takes authority from the primary backend. */
  engage?: OcppProxyEngageModel
  /** When the primary backend gets authority back. */
  swapBack?: OcppProxySwapBackModel
  /** Which charger traffic is held for the primary backend. */
  buffer?: OcppProxyBufferModel
  /** Where the commands sent during an outage are reported. Left unset, the SynopLink records nothing. */
  commandBackfill?: OcppProxyCommandBackfillModel
}
export type OcppProxyConfigModel = {
  /** Backend charge management systems (CMS) the local controller's OCPP proxy can route charger sessions to, including Synop's own, which is present on every configured SynopLink. Empty when the OCPP proxy has not been configured. */
  upstreams: OcppProxyUpstreamModel[]
  /** Which backend answers the charger, keyed by OCPP action name. The reserved key 'default' covers every action not listed explicitly. The charger's message is always sent to every enabled backend; this only decides whose reply it receives. Reported as the table in effect, so a configuration written without one reads back with the entry that was derived for it. Empty when the OCPP proxy has not been configured. */
  responseRouting: {
    [key: string]: string
  }
  /** How charger traffic is spread across the backends. 'STATIC' sends every message to every enabled backend and answers the charger from the one named by the routing table. 'PRIMARY_FALLBACK' designates a primary and a fallback backend, and only the authoritative one may command chargers. Reported as the mode actually in effect, so a configuration that leaves it unset reads as 'STATIC'. Null when the OCPP proxy has not been configured. */
  routingMode?: OcppProxyRoutingMode | null
  /** Settings governing the handover between the primary and fallback backends. Null when none are configured, in which case the SynopLink's own defaults apply. Reported with those defaults filled in, so this describes what the SynopLink will do rather than only what was explicitly asked for. */
  failover?: OcppProxyFailoverModel | null
  /** Whether this configuration has been confirmed applied by the SynopLink. Expect 'pending' after a change until the SynopLink reports the new configuration back. Null when the OCPP proxy has not been configured, when the SynopLink's reported state could not be read, or when the SynopLink has never reported its OCPP proxy configuration back -- the configuration returned alongside it is still authoritative. */
  configurationStatus?: ('pending' | 'applied') | null
}
export type ConnectivityPolicy = 'ACTIVE_WHEN_OFFLINE' | 'ACTIVE_WHEN_ONLINE' | 'ALWAYS_ACTIVE'
export type InputSource = 'CLOUD' | 'LINK'
export type PlanLoopMode = 'OFF' | 'EMIT' | 'ENACT'
export type OptimizerConfigModel = {
  /** When this service actively controls the site: only while the site is offline, only while it is online, or at all times. 'ACTIVE_WHEN_OFFLINE' is the fallback arrangement — another system controls the site while its internet connection is up, and Synop's on-site control takes over only once that connection is lost. A service standing down under this policy does nothing for the site until it takes over. */
  connectivityPolicy?: ConnectivityPolicy
  /** How long the site must stay offline before this service reacts to the loss of connectivity, so that brief interruptions do not change how the site is controlled. */
  offlineDebounceSeconds?: number
  /** How long the site must stay online before this service reacts to the return of connectivity, so that an unstable connection does not repeatedly hand control back and forth. */
  onlineDebounceSeconds?: number
  /** Whether this configuration has been confirmed applied by the SynopLink.
    
    - 'applied' — the SynopLink reports running this configuration.
    - 'pending' — the SynopLink reports a configuration that differs from this one. Expect this after a change until the SynopLink reports it back.
    - 'unavailable' — the SynopLink could not be reached to find out how this service is configured, so the values shown are what it runs when nothing is set rather than anything observed from this device. Try again shortly.
    - null — Synop holds no configuration for this service, so the settings shown are the standard ones it runs without any. Note that this service reads its configuration only when it starts: one whose configuration was just removed goes on applying what it last read until it next starts, and this endpoint cannot tell you whether it has, because Synop no longer holds anything to compare against. Null is also returned when the configuration shown is the one Synop holds and is authoritative, but the SynopLink could not be reached to confirm whether it has taken it up yet, or when the SynopLink has never reported how this service is configured, so there is nothing to confirm it against. */
  configurationStatus?: ('pending' | 'applied' | 'unavailable') | null
  /** Which road this SynopLink's optimizer reads the site's inputs down: 'CLOUD' for Synop's APIs, 'LINK' for the data held on the device itself. Null leaves the setting to the component's own configuration.
    
    Note that the optimizer reads this when it starts: it decides from this setting what to subscribe to on the device, so a change is picked up at the next restart rather than immediately. */
  inputSource?: InputSource | null
  /** How much of the optimizer's planning runs on this SynopLink:
    
    - 'OFF' — no plan is computed.
    - 'EMIT' — a plan is computed and recorded, but nothing is sent to the site's equipment.
    - 'ENACT' — the plan is written through to the site's equipment, so the device commands its own chargers and batteries.
    - null — the setting is left to the component's own configuration.
    
    The optimizer picks this up without a restart, at the first planning run that starts after the change. */
  planLoopMode?: PlanLoopMode | null
}
export type SitePowerManagerConfigModel = {
  /** When this service actively controls the site: only while the site is offline, only while it is online, or at all times. 'ACTIVE_WHEN_OFFLINE' is the fallback arrangement — another system controls the site while its internet connection is up, and Synop's on-site control takes over only once that connection is lost. A service standing down under this policy does nothing for the site until it takes over. */
  connectivityPolicy?: ConnectivityPolicy
  /** How long the site must stay offline before this service reacts to the loss of connectivity, so that brief interruptions do not change how the site is controlled. */
  offlineDebounceSeconds?: number
  /** How long the site must stay online before this service reacts to the return of connectivity, so that an unstable connection does not repeatedly hand control back and forth. */
  onlineDebounceSeconds?: number
  /** Whether this configuration has been confirmed applied by the SynopLink.
    
    - 'applied' — the SynopLink reports running this configuration.
    - 'pending' — the SynopLink reports a configuration that differs from this one. Expect this after a change until the SynopLink reports it back.
    - 'unavailable' — the SynopLink could not be reached to find out how this service is configured, so the values shown are what it runs when nothing is set rather than anything observed from this device. Try again shortly.
    - null — Synop holds no configuration for this service, so the settings shown are the standard ones it runs without any. Note that this service reads its configuration only when it starts: one whose configuration was just removed goes on applying what it last read until it next starts, and this endpoint cannot tell you whether it has, because Synop no longer holds anything to compare against. Null is also returned when the configuration shown is the one Synop holds and is authoritative, but the SynopLink could not be reached to confirm whether it has taken it up yet, or when the SynopLink has never reported how this service is configured, so there is nothing to confirm it against. */
  configurationStatus?: ('pending' | 'applied' | 'unavailable') | null
  /** How long the power limits this service writes to the site's chargers when it hands management back stay in force before they lapse. It bounds how long a site can be held to the last limits Synop set after the system that normally manages it has taken it back, so those limits expire on their own rather than waiting to be replaced. Defaults to 120 seconds. */
  handBackCapSeconds?: number
}
export type OcppUplinkMode = 'FORWARD' | 'DISCARD_WHEN_ONLINE' | 'DISCARD_ALL'
export type RelayConfigModel = {
  /** Whether charger (OCPP) telemetry from this site is sent to Synop. 'FORWARD', the default, sends it as it is produced. 'DISCARD_WHEN_ONLINE' suppresses it while the site has connectivity, for sites whose chargers are operated by a third-party charging management system that owns that data. Charger telemetry produced while the site is offline is still recorded and delivered once connectivity returns, so periods when the site managed its own chargers remain auditable. 'DISCARD_ALL' suppresses it unconditionally, online or offline, for sites whose chargers are operated by a third-party charging management system under data-ownership terms that allow no charger data to leave the site at all. It sends Synop no charger telemetry at all, including the offline record 'DISCARD_WHEN_ONLINE' keeps, so a site set to it gives up the audit trail covering the periods it managed its own chargers. It governs the telemetry stream only: which of the site's equipment records are mirrored to Synop is the blocked-records setting's to decide, separately. Telemetry from other equipment at the site is unaffected in every mode. */
  ocppUplinkMode?: OcppUplinkMode | string
  /** Which of the site's live equipment records are kept at the site instead of being mirrored to Synop, given as name patterns matched against a whole record name — 'connector-*' or 'transactions-*'. Empty by default, which mirrors all of them. A record a pattern matches goes on working at the site exactly as before: equipment and services there still read and update it, and settings sent from Synop still reach it. Only the copy Synop holds stops being updated. This suits a site whose chargers are operated by a third-party charging management system that owns their data, and it covers the records Synop keeps at rest rather than the telemetry stream, which the charger telemetry setting covers.
    
    Each entry is one pattern, so none of them may be blank or contain spaces. Order is kept as sent, and a repeated pattern is kept rather than merged away. */
  uplinkBlockedShadows?: string[]
  /** Whether this configuration has been confirmed applied by the SynopLink.
    
    - 'applied' — the SynopLink reports running this configuration.
    - 'pending' — the SynopLink reports a configuration that differs from this one. Expect this after a change until the SynopLink reports it back, which for data delivery means after it next restarts.
    - 'unavailable' — the SynopLink could not be reached to find out how data delivery is configured, so the values shown are what it runs when nothing is set rather than anything observed from this device. Try again shortly.
    - null — Synop holds no configuration for data delivery, so the settings shown are the standard ones it runs without any. Note that data delivery reads its configuration only when it starts: one whose configuration was just removed goes on applying what it last read until it next starts, and this endpoint cannot tell you whether it has, because Synop no longer holds anything to compare against. Null is also returned when the configuration shown is the one Synop holds and is authoritative, but the SynopLink could not be reached to confirm whether it has taken it up yet, or when the SynopLink has never reported how data delivery is configured, so there is nothing to confirm it against. */
  configurationStatus?: ('pending' | 'applied' | 'unavailable') | null
}
export type ActiveMode = 'off' | 'record' | 'enact'
export type FeatureGateOverride = {
  /** The answer for every site this SynopLink plans that 'sites' does not name. Null leaves them resolving the way they otherwise would. */
  default?: boolean | null
  /** The answer for individual sites, keyed by site id. Takes precedence over 'default'. */
  sites?: {
    [key: string]: boolean
  }
}
export type DefaultPowerPlannerConfigModel = {
  /** When this service actively controls the site: only while the site is offline, only while it is online, or at all times. 'ACTIVE_WHEN_OFFLINE' is the fallback arrangement — another system controls the site while its internet connection is up, and Synop's on-site control takes over only once that connection is lost. A service standing down under this policy does nothing for the site until it takes over. */
  connectivityPolicy?: ConnectivityPolicy
  /** How long the site must stay offline before this service reacts to the loss of connectivity, so that brief interruptions do not change how the site is controlled. */
  offlineDebounceSeconds?: number
  /** How long the site must stay online before this service reacts to the return of connectivity, so that an unstable connection does not repeatedly hand control back and forth. */
  onlineDebounceSeconds?: number
  /** How much of the site's default charging plan the SynopLink produces on its own. 'off', the default, plans nothing and leaves the site's charging under whatever already controls it. 'record' plans each site and keeps the result without sending it to any charger, which is how a site is compared against the way it is planned today before the SynopLink takes over. 'enact' sends the plans it produces to the site's chargers. */
  activeMode?: ActiveMode
  /** Feature switches answered on the SynopLink itself rather than by Synop, keyed by switch name. A value of true or false answers that switch for every site the SynopLink plans; an object may instead carry a 'sites' map of site id to true/false together with a 'default' for the rest, which is what turns one site on ahead of the others. Empty by default, which leaves every switch resolving the way it otherwise would. A site is often unable to reach Synop, and a rollout nobody on site can stop is one nobody can stop when it goes wrong. */
  statsigGateOverrides?: {
    [key: string]: boolean | FeatureGateOverride
  }
  /** Whether this configuration has been confirmed applied by the SynopLink.
    
    - 'applied' — the SynopLink reports running this configuration.
    - 'pending' — the SynopLink reports a configuration that differs from this one. The SynopLink takes a change up at the start of its next planning tick without restarting anything, so expect this only briefly after a change, until it reports the change back.
    - 'unavailable' — the SynopLink could not be reached to find out how its charging plan is configured, so the values shown are what it runs when nothing is set rather than anything observed from this device. Try again shortly.
    - null — Synop holds no configuration for the charging plan, so the settings shown are the standard ones the SynopLink runs without any. Null is also returned when the configuration shown is the one Synop holds and is authoritative, but the SynopLink could not be reached to confirm whether it has taken it up yet, or when the SynopLink has never reported how its charging plan is configured, so there is nothing to confirm it against. */
  configurationStatus?: ('pending' | 'applied' | 'unavailable') | null
}
export type AstroConfigModel = {
  /** Whether the SynopLink's charge management system records the full text of the OCPP messages it exchanges with the site's chargers. True, the standard setting, records them in full, which is what makes a charger's behaviour diagnosable after the fact. False records that a message was handled without recording its contents, for a site whose chargers are operated by a third party and whose message contents are not Synop's to keep. Whether the site's charger telemetry is sent to Synop at all is a separate setting, on data delivery. */
  enableOcppLogging?: boolean
  /** Whether this configuration has been confirmed applied by the SynopLink.
    
    - 'applied' — the SynopLink reports running this configuration.
    - 'pending' — the SynopLink reports a configuration that differs from this one. Expect this after a change until the SynopLink reports it back, which for the charge management system means after it next restarts.
    - 'unavailable' — the SynopLink could not be reached to find out how its charge management system is configured, so the values shown are what it runs when nothing is set rather than anything observed from this device. Try again shortly.
    - null — Synop holds no configuration for the charge management system, so the setting shown is the standard one it runs without any. Note that it reads its configuration only when it starts: one whose configuration was just removed goes on applying what it last read until it next starts, and this endpoint cannot tell you whether it has, because Synop no longer holds anything to compare against. Null is also returned when the configuration shown is the one Synop holds and is authoritative, but the SynopLink could not be reached to confirm whether it has taken it up yet, or when the SynopLink has never reported how its charge management system is configured, so there is nothing to confirm it against. */
  configurationStatus?: ('pending' | 'applied' | 'unavailable') | null
}
export type ComponentConfigsModel = {
  /** The OCPP proxy component's backend configuration. */
  'ocpp-proxy': OcppProxyConfigModel
  /** The optimization service's connectivity policy. */
  optimizer: OptimizerConfigModel
  /** The power management service's connectivity policy. */
  'site-power-manager': SitePowerManagerConfigModel
  /** How the SynopLink delivers the site's telemetry to Synop. */
  relay: RelayConfigModel
  /** How much of the site's default charging plan the SynopLink produces on its own. */
  'default-power-planner': DefaultPowerPlannerConfigModel
  /** The charge management system's settings — what it records of the messages it exchanges with the site's chargers. */
  astro: AstroConfigModel
}
export type ComponentConfigResponse = {
  /** Per-component configuration, keyed by component type. */
  components: ComponentConfigsModel
}
export type OcppProxyUpstreamRequestModel = {
  /** Name identifying this backend. Referenced by the response routing table and used in the controller's logs. The name 'synop' is reserved for Synop's own backend. */
  name: string
  /** Whether the controller connects to this backend. Disabled backends are ignored entirely and cannot receive charger traffic. */
  enabled: boolean
  /** Which commands this backend may send to the charger: all of them, none of them, all except a blocked list, or only an allowed list. */
  outboundFilter: OcppProxyOutboundFilter
  /** OCPP actions this backend may not send to the charger. Applies only when the outbound filter is a blocked list. */
  blockedActions?: string[]
  /** The only OCPP actions this backend may send to the charger. Applies only when the outbound filter is an allowed list. */
  allowedActions?: string[]
  /** Longest the controller waits between attempts to reconnect a dropped connection to this backend. Left unset, the controller's own default applies. */
  reconnectMaxBackoffSeconds?: number
  /** OCPP actions this backend may send to the charger even while it is not the authoritative one. Everything else it sends is dropped until authority moves to it. */
  alwaysAllowedActions?: string[]
  /** Websocket URL of the backend charge management system (CMS) */
  url: string
}
export type UpdateOcppProxyConfigRequest = {
  /** The complete set of backend charge management systems (CMS) of the customer's own that the local controller's OCPP proxy may route charger sessions to. Backends omitted here are removed. One is supported; Synop's own backend is always present besides it and is not listed here. */
  upstreams: OcppProxyUpstreamRequestModel[]
  /** Which backend answers the charger, keyed by OCPP action name. Must include the reserved key 'default', covering every action not listed explicitly, and every value must name an enabled backend -- either the one supplied here or 'synop'. Left out, the charger is answered by the backend supplied here, or by Synop's own when none is. */
  responseRouting?: {
    [key: string]: string
  }
}
export type OcppProxyMode = 'OFF' | 'DUAL_UPSTREAM' | 'EXTERNAL_PRIMARY'
export type OcppProxyCommandReport = {
  /** HTTP endpoint the SynopLink posts the recorded commands to, in batches, once your backend is reachable again. */
  url: string
  /** How the SynopLink authenticates to that endpoint: 'HMAC_SHA256' signs each request body, 'BEARER' sends a static token, 'NONE' sends neither and suits a receiver that authenticates by network position. Stated explicitly rather than defaulted, because a SynopLink holding a credential it was never given records commands it can never deliver. */
  auth: OcppProxyBackfillAuthScheme
  /** Name of the entry in this SynopLink's own deployment configuration holding the signing key or token. Required unless 'auth' is 'NONE', and refused with it. This is a name, not a credential: the credential itself is never sent to or stored by this API. */
  secretName?: string
}
export type OcppProxyFallbackTimings = {
  /** How long the site must have been unable to reach your backend before the SynopLink takes over managing its chargers. */
  engageAfterOfflineSeconds?: number
  /** How long the site's connection to your backend must hold before the SynopLink hands management back to it and stands down. */
  handBackAfterOnlineSeconds?: number
  /** How long the charging limits the SynopLink sets when it hands the site back stay in force before they lapse. The time runs from the moment the SynopLink announces the hand-back, and your backend takes over the chargers 30 seconds into it, so at the default of 90 seconds Synop's limits end about a minute after your backend has the site back. Once they lapse, the chargers run on whatever limits your backend has set, or on each charger's own default if it has set none.
    
    Values down to 30 are accepted. At 30 the limits lapse exactly as your backend takes over, which leaves it very little time to put limits of its own in place first. The SynopLink writes its limits for 30 minutes at a time, so a value near 1800 shortens nothing: the limits would have ended by then anyway. */
  handBackProfileDurationSeconds?: number
  /** Where the SynopLink delivers the record of the commands it sent the site's chargers while your backend was unreachable. Left out, it records nothing, and an outage leaves no record to ask for afterwards. */
  commandReport?: OcppProxyCommandReport
}
export type OcppProxyModeSettingModel = {
  /** What this setting governs, named as a site operator would describe it rather than after the service that implements it. */
  name: string
  /** How far this one setting has reached the SynopLink.
    
    - 'applied' — the SynopLink confirms it, or the service in question does not report this setting back and there is nothing outstanding to confirm.
    - 'unconfirmed' — not confirmed by the SynopLink. It has never reported this setting back, or could not be reached, so whether the setting is in effect is not known. Rebooting does not change this.
    - 'pending' — the SynopLink reports a different value, so the setting is not in effect yet.
    - 'custom' — the value in effect differs from what the mode dictates. */
  status: 'applied' | 'unconfirmed' | 'pending' | 'custom'
  /** Present as 'restart' when this setting reaches the SynopLink only once it is rebooted. Nothing reboots automatically. Null for a setting that takes effect without one. */
  appliesOn?: 'restart'
}
export type OcppProxyModeModel = {
  /** What this SynopLink's OCPP proxy does.
    
    - 'OFF' — no proxy. The SynopLink accepts no charger connections, and the site's chargers must be pointed directly at a charge management system.
    - 'DUAL_UPSTREAM' — every backend stays connected and sees every charger message, with the per-backend command filters and the response routing table deciding who may do what. With only Synop's own backend defined this is a transparent proxy: the chargers are already on the SynopLink's port, ready for a backend of your own to be added later.
    - 'EXTERNAL_PRIMARY' — your backend manages the site's chargers while the site can reach it, and the SynopLink's own charge management and energy management take over while it cannot. What happens on the site's chargers stays at the site in this mode: connector status, charging sessions, meter readings and the tokens that authorized them are all kept there and never mirrored to Synop, and the SynopLink's logs are sanitized. Each charger's own record — its identity, the connectors it has, its OCPP version, its firmware status and its heartbeat — does reach Synop, because it is how the platform knows what equipment the site has, and the SynopLink cannot protect a charger from over-subscription during an outage if Synop never learns it is there.
    
    Null when this SynopLink's proxy is arranged in none of these modes: it was configured before the modes existed and its arrangement matches none of them, or a newer version of the API has set a mode this one does not know. 'status' is then 'custom' and 'message' says which; setting a mode takes the SynopLink over either way. */
  mode?: OcppProxyMode
  /** The backend that manages the site's chargers in mode 'EXTERNAL_PRIMARY'. Null in the other modes, which designate no authority, and null while 'mode' is. */
  primaryUpstream?: string
  /** The handover settings in effect: the timings, and where the commands sent during an outage are reported. Null outside mode 'EXTERNAL_PRIMARY', which is the only mode that hands the site over — the settings are kept while the SynopLink is in another mode and reported again when it returns to this one. */
  fallback?: OcppProxyFallbackTimings
  /** How far this mode has reached the SynopLink: the least finished of its settings, in the order below.
    
    - 'applied' — every setting the mode derives is in effect.
    - 'unconfirmed' — nothing is known to be missing, but at least one setting has not been confirmed by the SynopLink. Rebooting does not change this.
    - 'pending' — the SynopLink reports at least one setting that is not in effect yet. Settings marked ``appliesOn: restart`` stay pending until the SynopLink is rebooted.
    - 'custom' — at least one derived setting has since been changed away from what this mode dictates, or this SynopLink's proxy is arranged in none of these modes at all, in which case 'mode' is null and 'message' says so. Setting the mode takes it over. */
  status: 'applied' | 'unconfirmed' | 'pending' | 'custom'
  /** What to do next, present only while a setting that needs a reboot is still pending, or while 'mode' is null. An unconfirmed setting never asks for a reboot. Nothing on the SynopLink restarts on its own. */
  message?: string
  /** Consequences of this mode a site operator should know about. Empty when there are none. */
  warnings?: string[]
  /** Each of the things this mode decides, and how far it has reached the SynopLink. Empty while 'mode' is null, since there is then no mode that decided any of them. */
  settings?: OcppProxyModeSettingModel[]
}
export type UpdateOcppProxyModeRequest = {
  /** What this SynopLink's OCPP proxy does.
    
    - 'OFF' — no proxy. The SynopLink accepts no charger connections, and the site's chargers must be pointed directly at a charge management system.
    - 'DUAL_UPSTREAM' — every backend stays connected and sees every charger message, with the per-backend command filters and the response routing table deciding who may do what. With only Synop's own backend defined this is a transparent proxy: the chargers are already on the SynopLink's port, ready for a backend of your own to be added later.
    - 'EXTERNAL_PRIMARY' — your backend manages the site's chargers while the site can reach it, and the SynopLink's own charge management and energy management take over while it cannot. What happens on the site's chargers stays at the site in this mode: connector status, charging sessions, meter readings and the tokens that authorized them are all kept there and never mirrored to Synop, and the SynopLink's logs are sanitized. Each charger's own record — its identity, the connectors it has, its OCPP version, its firmware status and its heartbeat — does reach Synop, because it is how the platform knows what equipment the site has, and the SynopLink cannot protect a charger from over-subscription during an outage if Synop never learns it is there. */
  mode: OcppProxyMode
  /** Name of the backend that is to manage the site's chargers. Required in mode 'EXTERNAL_PRIMARY', which is the only mode that designates authority, and not accepted in the others. It must name a backend already defined and enabled on this SynopLink's OCPP proxy configuration; Synop's own backend becomes the fallback. */
  primaryUpstream?: string
  /** The handover settings. Accepted in mode 'EXTERNAL_PRIMARY' only, and replaced as a whole: a block sent without a command report leaves the SynopLink recording nothing. Left out, the settings this SynopLink already holds are kept, and the standard timings apply where it holds none. */
  fallback?: OcppProxyFallbackTimings
}
export type UpdateOptimizerConfigRequest = {
  /** When this service actively controls the site: only while the site is offline, only while it is online, or at all times. Defaults to always active. */
  connectivityPolicy?: ConnectivityPolicy
  /** How long the site must stay offline before this service reacts to the loss of connectivity. Defaults to 60 seconds. */
  offlineDebounceSeconds?: number
  /** How long the site must stay online before this service reacts to the return of connectivity. Defaults to 120 seconds. */
  onlineDebounceSeconds?: number
  /** Which road this SynopLink's optimizer reads the site's inputs down: 'CLOUD' for Synop's APIs, 'LINK' for the data held on the device itself. Null leaves the setting to the component's own configuration.
    
    Note that the optimizer reads this when it starts: it decides from this setting what to subscribe to on the device, so a change is picked up at the next restart rather than immediately. */
  inputSource?: InputSource | null
  /** How much of the optimizer's planning runs on this SynopLink:
    
    - 'OFF' — no plan is computed.
    - 'EMIT' — a plan is computed and recorded, but nothing is sent to the site's equipment.
    - 'ENACT' — the plan is written through to the site's equipment, so the device commands its own chargers and batteries.
    - null — the setting is left to the component's own configuration.
    
    The optimizer picks this up without a restart, at the first planning run that starts after the change. */
  planLoopMode?: PlanLoopMode | null
}
export type UpdateSitePowerManagerConfigRequest = {
  /** When this service actively controls the site: only while the site is offline, only while it is online, or at all times. Defaults to always active. */
  connectivityPolicy?: ConnectivityPolicy
  /** How long the site must stay offline before this service reacts to the loss of connectivity. Defaults to 60 seconds. */
  offlineDebounceSeconds?: number
  /** How long the site must stay online before this service reacts to the return of connectivity. Defaults to 120 seconds. */
  onlineDebounceSeconds?: number
  /** How long the power limits this service writes to the site's chargers when it hands management back stay in force before they lapse. It bounds how long a site can be held to the last limits Synop set after the system that normally manages it has taken it back, so those limits expire on their own rather than waiting to be replaced. Defaults to 120 seconds. */
  handBackCapSeconds?: number
}
export type UpdateRelayConfigRequest = {
  /** Whether charger (OCPP) telemetry from this site is sent to Synop. 'FORWARD', the default, sends it as it is produced. 'DISCARD_WHEN_ONLINE' suppresses it while the site has connectivity, for sites whose chargers are operated by a third-party charging management system that owns that data. Charger telemetry produced while the site is offline is still recorded and delivered once connectivity returns, so periods when the site managed its own chargers remain auditable. 'DISCARD_ALL' suppresses it unconditionally, online or offline, for sites whose chargers are operated by a third-party charging management system under data-ownership terms that allow no charger data to leave the site at all. It sends Synop no charger telemetry at all, including the offline record 'DISCARD_WHEN_ONLINE' keeps, so a site set to it gives up the audit trail covering the periods it managed its own chargers. It governs the telemetry stream only: which of the site's equipment records are mirrored to Synop is the blocked-records setting's to decide, separately. Telemetry from other equipment at the site is unaffected in every mode. */
  ocppUplinkMode?: OcppUplinkMode
  /** Which of the site's live equipment records are kept at the site instead of being mirrored to Synop, given as name patterns matched against a whole record name — 'connector-*' or 'transactions-*'. Empty by default, which mirrors all of them. A record a pattern matches goes on working at the site exactly as before: equipment and services there still read and update it, and settings sent from Synop still reach it. Only the copy Synop holds stops being updated. This suits a site whose chargers are operated by a third-party charging management system that owns their data, and it covers the records Synop keeps at rest rather than the telemetry stream, which the charger telemetry setting covers.
    
    Each entry is one pattern, so none of them may be blank or contain spaces. Order is kept as sent, and a repeated pattern is kept rather than merged away. */
  uplinkBlockedShadows?: string[]
}
export type UpdateDefaultPowerPlannerConfigRequest = {
  /** When this service actively controls the site: only while the site is offline, only while it is online, or at all times. Defaults to always active. */
  connectivityPolicy?: ConnectivityPolicy
  /** How long the site must stay offline before this service reacts to the loss of connectivity. Defaults to 60 seconds. */
  offlineDebounceSeconds?: number
  /** How long the site must stay online before this service reacts to the return of connectivity. Defaults to 120 seconds. */
  onlineDebounceSeconds?: number
  /** How much of the site's default charging plan the SynopLink produces on its own. 'off', the default, plans nothing and leaves the site's charging under whatever already controls it. 'record' plans each site and keeps the result without sending it to any charger, which is how a site is compared against the way it is planned today before the SynopLink takes over. 'enact' sends the plans it produces to the site's chargers. */
  activeMode?: ActiveMode
  /** Feature switches answered on the SynopLink itself rather than by Synop, keyed by switch name. A value of true or false answers that switch for every site the SynopLink plans; an object may instead carry a 'sites' map of site id to true/false together with a 'default' for the rest, which is what turns one site on ahead of the others. Empty by default, which leaves every switch resolving the way it otherwise would. A site is often unable to reach Synop, and a rollout nobody on site can stop is one nobody can stop when it goes wrong. */
  statsigGateOverrides?: {
    [key: string]: boolean | FeatureGateOverride
  }
}
export type UpdateAstroConfigRequest = {
  /** Whether the SynopLink's charge management system records the full text of the OCPP messages it exchanges with the site's chargers. True, the standard setting, records them in full, which is what makes a charger's behaviour diagnosable after the fact. False records that a message was handled without recording its contents, for a site whose chargers are operated by a third party and whose message contents are not Synop's to keep. Whether the site's charger telemetry is sent to Synop at all is a separate setting, on data delivery. */
  enableOcppLogging?: boolean
}
export type LoggingPosture = 'FULL' | 'SANITIZED'
export type ComponentLoggingPostureModel = {
  /** The SynopLink service this posture applies to, named as it appears in the SynopLink's own diagnostics. */
  component: string
  /** The posture this service has been asked to run. Null when none has been set for it. */
  desiredPosture?: LoggingPosture | null
  /** The posture this service reports it is running, or null if it does not report one. Only some of the SynopLink's services do. */
  reportedPosture?: LoggingPosture | null
  /** The posture this service is known to be running -- what it reports, not what it was asked for. Null when the service does not report its posture, which is not the same as running in 'FULL': it means this cannot be observed from here. */
  effectivePosture?: LoggingPosture | null
  /** Whether this service has been confirmed to be running the requested posture.
    
    - 'applied' — the service reports running it.
    - 'pending' — the service reports running a different posture. Expect this briefly after a change.
    - null — this service does not report its posture back, so whether it has taken the change up cannot be observed from here. Most of the SynopLink's services are in this position today; it is not a failure. Null is also returned when Synop holds no posture for this SynopLink, leaving nothing to compare against. */
  configurationStatus?: ('pending' | 'applied') | null
}
export type LoggingPostureModel = {
  /** How much detail this SynopLink's services put in the logs they upload to Synop. 'FULL', the default, uploads them as they are written. 'SANITIZED' withholds the identifiers that would tie a log line to a specific site, vehicle or charger, for sites whose operator does not want that detail leaving the premises. Logs are still produced and still uploaded in either posture; only their content differs, and nothing already uploaded is changed. A SynopLink with no posture set runs in 'FULL'. */
  posture?: LoggingPosture
  /** Whether the SynopLink as a whole has been confirmed to be running the posture shown.
    
    - 'applied' — every service that reports its posture reports this one.
    - 'pending' — at least one service still reports a different posture. Services that read their posture only when they start stay pending until they next restart.
    - 'unavailable' — Synop holds no posture for this SynopLink and the device could not be reached to find out what it is running, so the posture shown is the one a SynopLink runs when nothing is set rather than anything observed from this device. Try again shortly.
    - null — either Synop holds no posture for this SynopLink (so the posture shown is the standard one it runs without any), or the posture shown is the one Synop holds and is authoritative but no service on the device reports its posture back. */
  configurationStatus?: ('pending' | 'applied' | 'unavailable') | null
  /** The posture of each of this SynopLink's services, as far as it can be observed. Lists only the services this SynopLink is actually running; a service the device does not run is absent rather than reported as unset. */
  components?: ComponentLoggingPostureModel[]
}
export type UpdateLoggingPostureRequest = {
  /** How much detail this SynopLink's services put in the logs they upload to Synop. 'FULL', the default, uploads them as they are written. 'SANITIZED' withholds the identifiers that would tie a log line to a specific site, vehicle or charger, for sites whose operator does not want that detail leaving the premises. Logs are still produced and still uploaded in either posture; only their content differs, and nothing already uploaded is changed. A SynopLink with no posture set runs in 'FULL'. */
  posture: LoggingPosture
}
export type NetworkPortMode = 'DHCP' | 'STATIC'
export type EthernetPortModel = {
  /** Whether this port takes its address from the network it is plugged into (DHCP) or uses the addresses configured here (STATIC). */
  mode: NetworkPortMode
  /** Addresses to assign to this port, each with an explicit prefix length -- for example '192.168.66.1/24'. Required for a static port and rejected for a DHCP one. A port may hold several addresses, which is how one physical link serves equipment on more than one subnet. */
  addresses?: string[]
  /** Address of the router this port sends traffic through when the destination is outside its own subnets. Must sit inside one of this port's subnets, and only one of the two ports may declare one. Leave unset on a port serving local equipment only. */
  gateway?: string
  /** Addresses of the DNS servers this port should use. */
  nameservers?: string[]
  /** Largest packet size this port may send, in bytes. Left unset, the standard 1500 applies. Raise it only on a link whose equipment is known to support it. */
  mtu?: number
}
export type NetworkDriftModel = {
  /** What changed. 'custodial' is the device's own network software rewriting our configuration file while leaving the addressing alone, and is repaired automatically. 'intentional' means the addressing itself differs from what is configured here. 'hardware' means a port's hardware address changed, which points at a swapped or re-ordered board rather than a configuration change. */
  kind: 'custodial' | 'intentional' | 'hardware'
  /** When the device noticed the difference. */
  detectedAt: string
  /** Human-readable description of what differs. */
  detail: string
}
export type ObservedPortModel = {
  /** Name the device's operating system gives this port. */
  interface: string
  /** Hardware address of this port. Null when the device did not report one, which is unusual but does not hide the rest of what the port is carrying. */
  mac?: string
  /** Whether the port has a link, as the device reports it -- 'up', 'down', or 'unknown' when it cannot be determined. */
  operstate: string
  /** Addresses currently assigned to this port, each with its prefix length. An empty list means the port carries none; null means the device could not determine them. */
  addresses?: string[]
  /** Router this port currently sends outbound traffic through. */
  gateway?: string
  /** DNS servers this port is currently using. */
  nameservers?: string[]
}
export type OcppConnection = 'DIRECT' | 'OCPP_PROXY'
export type OcppAddressModel = {
  /** Ethernet port carrying this address. A charger dials the address of the port it is wired to. */
  networkPort: 'lan1' | 'lan2'
  /** Where this address comes from. 'observed' is what the Link reports the port carrying. 'configured' is the static addressing set on this resource, used when the Link reports no usable address on the port: it has not reported the port, reports no address on it, or reports only link-local or IPv6 ones. A configured address may not be in effect. */
  addressSource: 'observed' | 'configured'
  /** The websocket URL a charger is configured with. Replace '{chargePointId}' with the charger's own identity. */
  url: string
}
export type OcppEndpointTargetModel = {
  /** What a charger dialing these URLs connects to. 'DIRECT' is the Link's own charge management system. 'OCPP_PROXY' is the Link's OCPP proxy, which forwards each charger's messages to the backends its OCPP proxy configuration names. */
  connection: OcppConnection
  /** TCP port chargers connect to. */
  port: number
  /** Path of the websocket URL, holding the charger's identity. */
  path: string
  /** Every address a charger can reach the Link on, one URL each. The equipment port 'lan2' is listed first, then 'lan1', and each port's addresses keep the order the port lists them. Use the address of the port the charger is wired to. */
  addresses: OcppAddressModel[]
}
export type OcppEndpointModel = {
  /** What a charger dialing these URLs connects to. 'DIRECT' is the Link's own charge management system. 'OCPP_PROXY' is the Link's OCPP proxy, which forwards each charger's messages to the backends its OCPP proxy configuration names. */
  connection: OcppConnection
  /** TCP port chargers connect to. */
  port: number
  /** Path of the websocket URL, holding the charger's identity. */
  path: string
  /** Every address a charger can reach the Link on, one URL each. The equipment port 'lan2' is listed first, then 'lan1', and each port's addresses keep the order the port lists them. Use the address of the port the charger is wired to. */
  addresses: OcppAddressModel[]
  /** 'applied' when the Link confirms it accepts chargers as described. 'pending' after a change to whether the OCPP proxy runs, or to where it listens, that the Link has not yet taken up: the addresses above still work, and 'next' holds the ones that will once it does. A change made through the OCPP proxy mode or configuration is taken up while the Link runs, without a restart. Null when the Link's state could not be read, in which case this describes the OCPP proxy as configured. */
  status?: 'applied' | 'pending'
  /** Where chargers will connect once a pending change takes effect. Null unless the status is 'pending'. */
  next?: OcppEndpointTargetModel
}
export type NetworkConfigModel = {
  /** Whether Synop configures this SynopLink's ethernet addressing. False means the device keeps whatever addressing it already has and nothing is applied to it; the observed state below is what it is running. Configuring a port takes over management. */
  managed: boolean
  /** Identifier of the configuration currently stored, reissued on every write. Null when the SynopLink is unmanaged. */
  revision?: string
  /** Configured addressing, keyed by port ('lan1', 'lan2'). Null when the SynopLink is unmanaged. */
  ports?: {
    [key: string]: EthernetPortModel
  }
  /** Whether the stored configuration has been applied. Expect 'pending' after a change until the SynopLink confirms it. 'failed' means the SynopLink tried this configuration, could not reach the network with it, and returned to the previous one -- it will not retry until the configuration changes again. Null when the SynopLink is unmanaged, or when its reported state could not be read, in which case the configuration returned alongside it is still authoritative. */
  configurationStatus?: 'pending' | 'applied' | 'failed'
  /** Why the stored configuration could not be applied. Set only while the status is 'failed'. */
  lastError?: string
  /** When the configuration above was last written. Read alongside the status above to tell how long a 'pending' apply has been outstanding: an apply takes minutes, and a device that has rejected a revision or gone offline never confirms it. Null when the SynopLink is unmanaged. */
  requestedAt?: string
  /** When the SynopLink last applied a configuration. */
  appliedAt?: string
  /** How the SynopLink currently differs from its configuration, if at all. Independent of the status above: a configuration can be applied and the device altered afterwards. */
  drift?: NetworkDriftModel
  /** What each port currently carries, keyed by port ('lan1', 'lan2'), whether or not the SynopLink is managed. Null when the SynopLink has never reported its ports. */
  observed?: {
    [key: string]: ObservedPortModel
  }
  /** When the SynopLink last reported the state above. */
  observedAt?: string
  /** Where the site's chargers connect to reach the Link over OCPP, derived from the port addressing above and from the Link's OCPP proxy configuration: whether the proxy runs, and the port and path it listens on. The OCPP proxy mode sets whether it runs. Null when neither port has a known address, or when neither the stored configuration nor the Link can say which listener it accepts chargers on. */
  ocppEndpoint?: OcppEndpointModel
}
export type UpdateNetworkConfigRequest = {
  /** Addressing for both ethernet ports, keyed 'lan1' and 'lan2'. Both keys are required and no others are accepted. */
  ports: {
    [key: string]: EthernetPortModel
  }
}
export type NetworkScanTriggerResponse = {
  /** Identifier for the triggered scan. The device echoes it on the result, so it correlates a completed scan back to this request. */
  scanId: string
}
export type ScanType = 'target_triage' | 'subnet_discovery' | 'dhcp_listen'
export type NetworkScanRequest = {
  /** Which scans to run on the device: subnet discovery, DHCP listening, and/or triage of the configured target devices. */
  scanTypes: ScanType[]
  /** CIDR subnets to scan. When omitted, the device scans the subnets it is attached to. */
  subnets?: string[] | null
  /** How long, in seconds, to listen for DHCP traffic when a DHCP listen scan is requested. */
  dhcpWindowSeconds?: number | null
}
export type NetworkScanSummary = {
  /** Identifier of the scan. */
  scanId: string
  /** What initiated the scan: on_demand or scheduled. */
  trigger: string
  /** Lifecycle state: requested, completed, partial, failed, or expired. */
  status: string
  /** Scan parameters as issued to the device. */
  params?: {
    [key: string]: unknown
  } | null
  /** Identifier of the user or system that requested the scan. */
  requestedBy?: string | null
  /** When the scan was requested. */
  requestedAt: string
  /** When the scan reached a terminal state, if it has. */
  completedAt?: string | null
  /** Failure detail when the scan failed; null otherwise. */
  error?: string | null
}
export type PagedResponseNetworkScanSummary = {
  meta: PaginationMeta
  data: NetworkScanSummary[]
}
export type DeviceReachabilityItem = {
  /** Identifier of the monitored device. */
  entityId: string
  /** Current IP address of the device, if known. */
  host?: string | null
  /** TCP port the device is probed on, if known. */
  port?: number | null
  /** Network-layer reachability verdict from the latest probe (e.g. PORT_OPEN, HOST_UP_PORT_CLOSED, ARP_ONLY, NO_ARP). */
  status: string
  /** Whether the device answered an ARP request. */
  arp: boolean
  /** Whether the device answered an ICMP echo (ping). */
  icmp: boolean
  /** Whether a TCP connect to the device succeeded. */
  tcp: boolean
  /** Hardware (MAC) address observed for the device, when resolvable. */
  mac?: string | null
  /** Triage verdict composed from the network-layer status and the device's telemetry freshness: OK when the port is open and the device is sending data, PORT_OPEN_NO_DATA when the port is open but no recent telemetry has arrived, otherwise the network-layer status itself. */
  composedStatus: string
  /** Whether the device has produced telemetry recently enough to be considered live. Null when no telemetry has ever been seen. */
  telemetryFresh?: boolean | null
  /** When the device most recently produced telemetry, if ever. */
  lastTelemetryAt?: string | null
  /** SUBNET_DRIFT when the device's IP falls outside every subnet the most recent scan covered; null when within a scanned subnet or when drift cannot be determined. */
  drift?: string | null
  /** When this reachability probe was taken. */
  lastSeenAt: string
}
export type NetworkScanTarget = {
  /** Identifier of the probed device. */
  entityId: string
  /** IP address the probe was aimed at, if known for this device. */
  host?: string | null
  /** TCP port the probe targeted, if known for this device. */
  port?: number | null
  /** Network-layer reachability verdict the device reported (e.g. PORT_OPEN, HOST_UP_PORT_CLOSED, ARP_ONLY, NO_ARP). */
  status: string
  /** Whether the device answered an ARP request. */
  arp: boolean
  /** Whether the device answered an ICMP echo (ping). */
  icmp: boolean
  /** Whether a TCP connect to the device succeeded. */
  tcp: boolean
  /** Hardware (MAC) address observed for the device, when resolvable. */
  mac?: string | null
  /** Triage verdict composed from the network-layer status and the device's telemetry freshness: OK when the port is open and the device is sending data, PORT_OPEN_NO_DATA when the port is open but no recent telemetry has arrived, otherwise the network-layer status itself. */
  composedStatus: string
  /** Whether the device has produced telemetry recently enough to be considered live. Null when no telemetry has ever been seen. */
  telemetryFresh?: boolean | null
  /** When the device most recently produced telemetry, if ever. */
  lastTelemetryAt?: string | null
  /** SUBNET_DRIFT when the device's IP falls outside every subnet the scan covered; null when it is within a scanned subnet or cannot be determined. */
  drift?: string | null
}
export type NetworkScanHostEntry = {
  /** IP address the host responded on. */
  ip: string
  /** Hardware (MAC) address, if seen. */
  mac?: string | null
  /** Hardware vendor inferred from the MAC's OUI prefix, when known. */
  vendor?: string | null
  /** TCP/UDP ports observed open on the host. */
  openPorts?: number[] | null
  /** Discovery methods that observed this host (e.g. arp, icmp, tcp). */
  sources?: string[] | null
  /** The known connected device this host was reconciled to, if any. */
  connectedDeviceId?: string | null
}
export type NetworkScanDhcpClient = {
  /** Hardware (MAC) address of the client. */
  mac: string
  /** Inferred hardware vendor. */
  vendor?: string | null
  /** Number of DHCP DISCOVER messages seen. */
  discovers: number
}
export type NetworkScanDhcp = {
  /** How long DHCP traffic was listened for. */
  windowSeconds: number
  /** Whether a DHCP server was observed. */
  serverSeen: boolean
  /** DHCP clients observed during the listen window. */
  clients?: NetworkScanDhcpClient[]
  /** Hardware (MAC) addresses of broadcast or multicast traffic seen during the listen window that did not resolve to a DHCP client -- devices heard on the wire but not otherwise identified. */
  broadcastMacs?: string[]
}
export type NetworkScanDetail = {
  /** Identifier of the scan. */
  scanId: string
  /** What initiated the scan: on_demand or scheduled. */
  trigger: string
  /** Lifecycle state: requested, completed, partial, failed, or expired. A requested scan whose TTL has elapsed with no result reads as expired. */
  status: string
  /** Scan parameters as issued to the device. */
  params?: {
    [key: string]: unknown
  } | null
  /** Identifier of the user or system that requested the scan. */
  requestedBy?: string | null
  /** When the scan was requested. */
  requestedAt: string
  /** When the scan reached a terminal state, if it has. */
  completedAt?: string | null
  /** Failure detail when the scan failed; null otherwise. */
  error?: string | null
  /** CIDR subnets the scan covered, as requested for the scan. */
  subnetsScanned?: string[]
  /** Per-device triage results, with raw layers and composed status. */
  targets?: NetworkScanTarget[]
  /** Hosts discovered on the local network during the scan. */
  hosts?: NetworkScanHostEntry[]
  /** DHCP findings when a DHCP-listen scan was run; null otherwise. */
  dhcp?: NetworkScanDhcp | null
}
export type PagedResponseBatteryModel = {
  meta: PaginationMeta
  data: BatteryModel[]
}
export type LinkControlsPanel = {
  /** The panel's identifier on the Link. */
  panelId: string
  /** The Panel asset this panel is. Its name and rating are the asset's. Null for a panel not yet linked to an asset, and on a dry run that adds the panel. */
  panelAssetId?: string | null
  /** The panel's name. */
  name?: string | null
  /** True for the main panel, the one siteLimitAmps names. Exactly one panel is main when the Link has a main panel; none is otherwise. */
  isMain: boolean
  /** The current the Link keeps the panel under, in amps. */
  panelLimitAmps?: number | null
  /** The panel limit as power, in kW, at the Panel asset's voltage and phase and unity power factor. Null when the asset records no voltage or phase. Power boost cannot run the panel above it. */
  panelLimitKw?: number | null
  /** The panel's rating in amps, the Panel asset's rated amperage. The panel limit cannot exceed it. Null when it has not been recorded, in which case the limit can be lowered but not raised. */
  ratedAmps?: number | null
  /** The meter the Link reads the panel's load from. */
  meterId?: string | null
  /** The battery serving the panel, or null when it has none. */
  batteryId?: string | null
}
export type ManagedCharger = {
  /** The charger's identifier. */
  chargerId: string
  /** The panel the charger is on. */
  panelId: string
  /** The most power the Link lets the charger draw. */
  maxKw?: number | null
  /** The charger's rated power, when known. */
  ratedKw?: number | null
}
export type LinkControlsFallbacks = {
  /** Power each charger gets while the panel's meter is offline. */
  meterOfflineChargerKw?: number | null
  /** Power each charger gets while the battery is offline. Null when batteryOfflineSource names another source. */
  batteryOfflineChargerKw?: number | null
  /** powerBoostGridLimit when power boost is on at the Link: while the battery is offline the chargers share the power boost grid limit, and batteryOfflineChargerKw does not apply. */
  batteryOfflineSource?: 'powerBoostGridLimit' | null
}
export type SettingState = 'applied' | 'pending'
export type LinkControlsSetting = {
  /** The setting, e.g. siteLimitAmps, panels.<panelId>.panelLimitAmps or managedChargers.<chargerId>.maxKw. */
  path: string
  /** The saved value. */
  desired: unknown
  /** The value the Link reports running, or null when it reports none or its report could not be read. */
  applied?: unknown | null
  /** applied when the Link runs the saved value; pending while it has yet to take it up. Null when the Link's report could not be read. */
  status?: SettingState | null
  /** When this value was last saved (ISO 8601, UTC). */
  savedAt?: string | null
}
export type AvailableMeter = {
  /** The id to give as a panel's meterId. */
  meterId: string
  /** The meter's display name. */
  name?: string | null
}
export type AvailableBattery = {
  /** The id to give as a panel's batteryId. */
  batteryId: string
  /** The battery's name. */
  name?: string | null
}
export type LinkControlsResponse = {
  /** How the Link manages charging. Set by platform staff. */
  strategy?: string | null
  /** The overall limit on everything the Link controls, in amps: the main panel's limit. */
  siteLimitAmps?: number | null
  /** The power a new charging session starts at, in kW. */
  startupChargerKw?: number | null
  /** Every panel, including sub-panels. */
  panels?: LinkControlsPanel[]
  /** The chargers the Link controls. */
  managedChargers?: ManagedCharger[]
  /** What chargers get when the meter or battery goes offline. */
  fallbacks?: LinkControlsFallbacks
  /** applied when the Link runs every setting; pending while any is still to be taken up; unavailable when the Link's report could not be read. */
  status: 'applied' | 'pending' | 'unavailable'
  /** Each setting and its status. */
  settings?: LinkControlsSetting[]
  /** The meters the Link reads that a panel may use as meterId. */
  availableMeters?: AvailableMeter[]
  /** The batteries on the Link that a panel may use as batteryId. */
  availableBatteries?: AvailableBattery[]
  /** The lowest max kW of any charger the Link controls, which caps the offline limits and startup power. Null when no charger has one. */
  lowestChargerLimitKw?: number | null
}
export type LinkControlsChange = {
  /** The setting. */
  path: string
  /** Its value before the change. */
  from?: unknown | null
  /** Its value after the change. */
  to?: unknown | null
}
export type LinkControlsChangeResponse = {
  /** How the Link manages charging. Set by platform staff. */
  strategy?: string | null
  /** The overall limit on everything the Link controls, in amps: the main panel's limit. */
  siteLimitAmps?: number | null
  /** The power a new charging session starts at, in kW. */
  startupChargerKw?: number | null
  /** Every panel, including sub-panels. */
  panels?: LinkControlsPanel[]
  /** The chargers the Link controls. */
  managedChargers?: ManagedCharger[]
  /** What chargers get when the meter or battery goes offline. */
  fallbacks?: LinkControlsFallbacks
  /** applied when the Link runs every setting; pending while any is still to be taken up; unavailable when the Link's report could not be read. */
  status: 'applied' | 'pending' | 'unavailable'
  /** Each setting and its status. */
  settings?: LinkControlsSetting[]
  /** The meters the Link reads that a panel may use as meterId. */
  availableMeters?: AvailableMeter[]
  /** The batteries on the Link that a panel may use as batteryId. */
  availableBatteries?: AvailableBattery[]
  /** The lowest max kW of any charger the Link controls, which caps the offline limits and startup power. Null when no charger has one. */
  lowestChargerLimitKw?: number | null
  /** Each setting the change moved. */
  changes?: LinkControlsChange[]
  /** True when nothing was written because the call was a dry run. */
  dryRun: boolean
}
export type LinkControlsPanelChange = {
  /** The panel's limit, in amps. Must be above 15 A and no more than the panel's rating. On the main panel this is the site limit. */
  panelLimitAmps?: number | null
  /** The meter the Link reads the panel from, one the Link reads. */
  meterId?: string | null
  /** The panel's rating in amps, above 15 and not below the panel's limit. It can be changed at any time, and null clears it. It is the Panel asset's, so a panel with none refuses it. */
  ratedAmps?: number | null
  /** The battery serving the panel, one of the Link's own batteries and on no other panel. Null clears it. */
  batteryId?: string | null
  /** The new panel's name. Required when adding a panel and unique on the Link; refused for a panel the Link already has (PANEL_EXISTS). */
  name?: string | null
  /** True removes the sub-panel and its rating; the other fields are then ignored. */
  remove?: boolean
}
export type ManagedChargerChange = {
  /** Move the charger to this panel. */
  panelId?: string | null
  /** The most power the Link lets the charger draw, in kW. Above 0 and no more than the charger's rated power. */
  maxKw?: number | null
  /** True stops the Link controlling the charger; the other fields are then ignored. */
  remove?: boolean
}
export type LinkControlsFallbacksUpdate = {
  /** Power each charger gets while its panel's meter is offline, in kW. No more than any charger's max kW. */
  meterOfflineChargerKw?: number | null
  /** Power each charger gets while the battery is offline, in kW. No more than any charger's max kW. Refused where power boost is on. */
  batteryOfflineChargerKw?: number | null
}
export type LinkControlsUpdate = {
  /** The overall limit, in amps. Must be above 15 A and no more than the main panel's rating. */
  siteLimitAmps?: number | null
  /** The power a new session starts at, in kW. Above 0 and no more than any charger's max kW. */
  startupChargerKw?: number | null
  /** Changes keyed by panel id: a panel to change, add or remove. */
  panels?: {
    [key: string]: LinkControlsPanelChange
  } | null
  /** Changes keyed by charger id: a charger to add, change, move or stop controlling. */
  managedChargers?: {
    [key: string]: ManagedChargerChange
  } | null
  /** Changes to what chargers get when the meter or battery goes offline. */
  fallbacks?: LinkControlsFallbacksUpdate | null
}
export type LinkControlsPanelUpdate = {
  /** The panel's limit, in amps. Must be above 15 A and no more than the panel's rating. On the main panel this is the site limit. */
  panelLimitAmps?: number | null
  /** The meter the Link reads the panel from, one the Link reads. */
  meterId?: string | null
  /** The panel's rating in amps, above 15 and not below the panel's limit. It can be changed at any time, and null clears it. It is the Panel asset's, so a panel with none refuses it. */
  ratedAmps?: number | null
  /** The battery serving the panel, one of the Link's own batteries and on no other panel. Null clears it. */
  batteryId?: string | null
}
export type LinkControlsPanelPut = {
  /** The panel's name. Required, and unique on the Link. */
  name?: string | null
  /** The panel's limit, in amps. Required, above 15 A and no more than the panel's rating. */
  panelLimitAmps?: number | null
  /** The panel's rating in amps. Required for a customer. */
  ratedAmps?: number | null
  /** The meter the Link reads the panel from, one the Link reads. Required when the Link's strategy follows the panel's load. */
  meterId?: string | null
}
export type ManagedChargerPut = {
  /** The panel the charger is on. Required. */
  panelId?: string | null
  /** The most power the Link lets the charger draw, in kW. Required, above 0 and no more than the charger's rated power. */
  maxKw?: number | null
}
export type ManagedChargerUpdate = {
  /** Move the charger to this panel. */
  panelId?: string | null
  /** The most power the Link lets the charger draw, in kW. Above 0 and no more than the charger's rated power. */
  maxKw?: number | null
}
export type ImportProblemType =
  | 'invalid_document'
  | 'duplicate_charger'
  | 'already_imported'
  | 'charger_managed_elsewhere'
  | 'missing_max_kw'
  | 'not_applied'
  | 'not_reported'
  | 'unknown_key'
  | 'unmapped_panel'
  | 'ambiguous_panel'
export type ImportProblem = {
  /** The kind of problem. */
  type: ImportProblemType
  /** The setting the problem is about, as a setting path, or the location of an unrecognized key in the document. */
  path?: string | null
  /** What is wrong, in a sentence. */
  message: string
  /** For a setting not applied, the value that was written. */
  desired?: unknown | null
  /** For a setting not applied, the value the Link reports running, or null when it reports none. */
  reported?: unknown | null
}
export type LinkControlsStaffResponse = {
  /** The load management settings stored for the Link, without the power boost block. On a dry run, the settings that would be stored. */
  document: {
    [key: string]: unknown
  }
  /** Problems an import found. Always empty for a raw replacement. */
  problems?: ImportProblem[]
  /** Setting paths whose value changed. An import lists every path it recorded. */
  changedPaths?: string[]
  /** The Panel asset each panel is linked to, keyed by panel id. Null for a panel with no asset yet: one a dry run would create, or one an import cannot map. */
  panelAssets?: {
    [key: string]: string | null
  }
  /** True when nothing was written because the call was a dry run. */
  dryRun: boolean
}
export type LinkControlsImportRequest = {
  /** The Panel asset each listed panel is, keyed by panel id. A panel left out is mapped through its meter: the Panel asset that meter is bound to. Each asset must be a Panel asset on the Link. */
  panelAssets?: {
    [key: string]: string
  } | null
}
export type ProbeState = 'queued' | 'running' | 'done' | 'refused' | 'error' | 'lost'
export type ProbeQueuedResponse = {
  /** Identifier of the queued probe. Read the probe with it to follow its progress and collect its result. */
  probeId: string
  /** Where the probe stands: always queued. */
  state: ProbeState
}
export type ProbeReadItem = {
  /** Modbus function code of the read: 1 reads coils, 2 discrete inputs, 3 holding registers and 4 input registers. */
  fc: 1 | 2 | 3 | 4
  /** Address of the first register or bit to read. */
  addr: number
  /** How many registers or bits to read. Never more than the request's per-read maximum, and the read must end at or before address 65535. */
  count: number
}
export type ProbeScan = {
  /** Modbus function code used for every read in the range. */
  fc: 1 | 2 | 3 | 4
  /** First address of the range. */
  from: number
  /** Last address of the range, included. */
  to: number
}
export type ProbeScanItem = {
  /** The range to scan. */
  scan: ProbeScan
}
export type ProbeRequest = {
  /** Address of the device to probe: an IPv4 address or a hostname. It must be one of the addresses of a device registered on the Link. */
  host: string
  /** TCP port the device listens on. */
  port?: number
  /** Modbus unit identifiers to read from, each between 0 and 247 and none repeated. */
  unitIds: number[]
  /** How many times each read is repeated. */
  samples?: number
  /** Milliseconds to wait between repeats of one read. */
  intervalMs?: number
  /** Milliseconds to wait for the device to answer one read. */
  timeoutMs?: number
  /** Milliseconds the whole probe may take. When it lapses the probe stops after the read in flight and reports what it has. */
  budgetMs?: number
  /** The most registers or bits any single read may ask for. */
  perReadMax?: number
  /** Whether to first check that the device accepts a connection and which of the unit identifiers answer. */
  reachability?: boolean
  /** Probe a device that the Link is already polling. Only a signed-in platform user may set it. */
  force?: boolean
  /** The reads and address scans to run, in order. */
  items: (ProbeReadItem | ProbeScanItem)[]
}
export type ProbeReadItemModel = {
  /** Modbus function code of the read. */
  fc: number
  /** Address of the first register or bit. */
  addr: number
  /** How many registers or bits were asked for. */
  count: number
}
export type ProbeScanRange = {
  /** Modbus function code used for every read. */
  fc: number
  /** First address of the range. */
  from: number
  /** Last address of the range, included. */
  to: number
}
export type ProbeScanItemModel = {
  /** The range that was to be scanned. */
  scan: ProbeScanRange
}
export type ProbeRequestModel = {
  /** Address of the device that was probed. */
  host: string
  /** TCP port the device listens on. */
  port: number
  /** Unit identifiers that were read from. */
  unitIds: number[]
  /** How many times each read was repeated. */
  samples: number
  /** Milliseconds between repeats of one read. */
  intervalMs: number
  /** Milliseconds to wait for one read. */
  timeoutMs: number
  /** Milliseconds the whole probe could take. */
  budgetMs: number
  /** The most any single read could ask for. */
  perReadMax: number
  /** Whether the connection check was requested first. */
  reachability: boolean
  /** Whether the probe was allowed to target a polled device. */
  force: boolean
  /** The reads and address scans that were requested, in order. */
  items: (ProbeReadItemModel | ProbeScanItemModel)[]
}
export type ProbeSummaryModel = {
  /** Outcome of the connection check: ok, refused, timeout, error, or skipped when the check was not requested. */
  connect?: string | null
  /** For each requested unit identifier, whether the device answered (answers) or did not (no response). An error reply from the device counts as an answer. Empty or null when the connection check was not requested. */
  unitIds?: {
    [key: string]: string
  } | null
  /** Reads that returned a value. */
  ok?: number
  /** Reads the device answered with an error code. */
  exception?: number
  /** Reads the device did not answer. */
  timeout?: number
  /** Null when every item ran and fits. Otherwise the position, in the request's items, of the last item whose entries are reported; -1 when none fit. Later items were cut by the time budget or the result's size limit. */
  truncatedAfter?: number | null
  /** Why the probe was refused or ended in error. */
  reason?: string | null
}
export type ProbeReadEntry = {
  /** Function code of the read. */
  fc: number
  /** Address of the first register or bit. */
  addr: number
  /** How many registers or bits were read. */
  count: number
  /** Unit identifier the read was sent to. */
  unitId: number
  /** For each sample, the milliseconds from the probe's start until the read returned. */
  t: number[]
  /** For each sample, the values read: one per register or bit. */
  samples: number[][]
}
export type ProbeReadExceptionEntry = {
  /** Function code of the read. */
  fc: number
  /** Address of the first register or bit. */
  addr: number
  /** How many registers or bits were asked for. */
  count: number
  /** Unit identifier the read was sent to. */
  unitId: number
  /** The error code the device answered with. */
  exception: number
}
export type ProbeReadTimeoutEntry = {
  /** Function code of the read. */
  fc: number
  /** Address of the first register or bit. */
  addr: number
  /** How many registers or bits were asked for. */
  count: number
  /** Unit identifier the read was sent to. */
  unitId: number
  /** Always true: the device did not answer. */
  timeout: boolean
}
export type ProbeScanEntry = {
  /** The range that was scanned. */
  scan: ProbeScanRange
  /** Unit identifier the reads were sent to. */
  unitId: number
  /** The addresses that returned a value, each as the address and the value read. */
  answers: number[][]
  /** How many addresses the device answered with each error code, keyed by the code. */
  exceptions: {
    [key: string]: number
  }
  /** How many addresses the device did not answer. */
  timeouts: number
}
export type ProbeModel = {
  /** Identifier of the probe. */
  probeId: string
  /** The Link the probe ran behind. */
  synoplinkId: string
  /** The registered device the probe targeted. Null once that device has been deleted. */
  connectedDeviceId: string | null
  /** Identifier of the user who requested the probe. */
  requestedBy: string | null
  /** When the probe was requested. */
  requestedAt: string
  /** queued (waiting for the Link), running, done, refused (the Link declined it, see reason), error (it failed, see reason) or lost (no result arrived before its time budget lapsed). */
  state: ProbeState
  /** Why the probe was refused, failed or was lost. */
  reason: string | null
  /** The probe as it was requested. */
  request: ProbeRequestModel
  /** Counts of what the probe found. Null until a result is in. */
  summary: ProbeSummaryModel | null
  /** When the Link began running the probe. */
  startedAt: string | null
  /** When the Link finished running the probe. */
  finishedAt: string | null
  /** What each read and scan returned, in item order and then unit identifier order. Null until a finished result is in, and for a probe that was refused, failed or lost. */
  entries: (ProbeReadEntry | ProbeReadExceptionEntry | ProbeReadTimeoutEntry | ProbeScanEntry)[] | null
}
export const {
  useGetDerAlarmEventsQuery,
  useLazyGetDerAlarmEventsQuery,
  useCreateBatteryMutation,
  useGetBatteriesQuery,
  useLazyGetBatteriesQuery,
  useUpdateBatteryMutation,
  useGetBatteryQuery,
  useLazyGetBatteryQuery,
  useDeleteBatteryMutation,
  useGetBatterySnapshotQuery,
  useLazyGetBatterySnapshotQuery,
  useGetBatteryTransactionsQuery,
  useLazyGetBatteryTransactionsQuery,
  useGetBatteryUptimeQuery,
  useLazyGetBatteryUptimeQuery,
  useGetDersQuery,
  useLazyGetDersQuery,
  useGetDerCapabilitySetQuery,
  useLazyGetDerCapabilitySetQuery,
  useGetDerSnapshotQuery,
  useLazyGetDerSnapshotQuery,
  useGetDerSamplesQuery,
  useLazyGetDerSamplesQuery,
  useGetDerAggregatesQuery,
  useLazyGetDerAggregatesQuery,
  useGetDerDestinationQuery,
  useLazyGetDerDestinationQuery,
  useSetDerDestinationMutation,
  useListDestinationsQuery,
  useLazyListDestinationsQuery,
  useAssignDersMutation,
  useGetDerSnapshotsQuery,
  useLazyGetDerSnapshotsQuery,
  useListDeviceModelsQuery,
  useLazyListDeviceModelsQuery,
  useCreateGeneratorMutation,
  useGetGeneratorsQuery,
  useLazyGetGeneratorsQuery,
  useUpdateGeneratorMutation,
  useGetGeneratorQuery,
  useLazyGetGeneratorQuery,
  useDeleteGeneratorMutation,
  useCreateInverterMutation,
  useGetInvertersQuery,
  useLazyGetInvertersQuery,
  useUpdateInverterMutation,
  useGetInverterQuery,
  useLazyGetInverterQuery,
  useDeleteInverterMutation,
  useCreateFuelTankMutation,
  useGetFuelTanksQuery,
  useLazyGetFuelTanksQuery,
  useUpdateFuelTankMutation,
  useGetFuelTankQuery,
  useLazyGetFuelTankQuery,
  useDeleteFuelTankMutation,
  useCreateFuelTankReadingsMutation,
  useGetFuelTankSnapshotQuery,
  useLazyGetFuelTankSnapshotQuery,
  useGetFuelTankSamplesQuery,
  useLazyGetFuelTankSamplesQuery,
  useGetFuelTankAggregatesQuery,
  useLazyGetFuelTankAggregatesQuery,
  useCreateGridConnectionMutation,
  useGetGridConnectionsQuery,
  useLazyGetGridConnectionsQuery,
  useUpdateGridConnectionMutation,
  useGetGridConnectionQuery,
  useLazyGetGridConnectionQuery,
  useDeleteGridConnectionMutation,
  useCreateLoadMutation,
  useGetLoadsQuery,
  useLazyGetLoadsQuery,
  useUpdateLoadMutation,
  useGetLoadQuery,
  useLazyGetLoadQuery,
  useDeleteLoadMutation,
  useCreatePanelMutation,
  useGetPanelsQuery,
  useLazyGetPanelsQuery,
  useUpdatePanelMutation,
  useGetPanelQuery,
  useLazyGetPanelQuery,
  useDeletePanelMutation,
  useCreateSolarArrayMutation,
  useGetSolarArraysQuery,
  useLazyGetSolarArraysQuery,
  useUpdateSolarArrayMutation,
  useGetSolarArrayQuery,
  useLazyGetSolarArrayQuery,
  useDeleteSolarArrayMutation,
  useGetLatestCellularStatusQuery,
  useLazyGetLatestCellularStatusQuery,
  useGetCellularStatusQuery,
  useLazyGetCellularStatusQuery,
  useGetCellularStatusHistoryQuery,
  useLazyGetCellularStatusHistoryQuery,
  useCreateConnectedDeviceMutation,
  useListConnectedDevicesQuery,
  useLazyListConnectedDevicesQuery,
  useGetConnectedDeviceQuery,
  useLazyGetConnectedDeviceQuery,
  useUpdateConnectedDeviceMutation,
  useDeleteConnectedDeviceMutation,
  useGetLatestConnectivityQuery,
  useLazyGetLatestConnectivityQuery,
  useGetConnectivityIntervalsQuery,
  useLazyGetConnectivityIntervalsQuery,
  useListCurtailmentsQuery,
  useLazyListCurtailmentsQuery,
  useGetLatestDeviceHealthQuery,
  useLazyGetLatestDeviceHealthQuery,
  useGetDeviceHealthQuery,
  useLazyGetDeviceHealthQuery,
  useGetDeviceHealthHistoryQuery,
  useLazyGetDeviceHealthHistoryQuery,
  useSyncSimCardsMutation,
  useRetireSimCardMutation,
  useGetVpnStateSnapshotsQuery,
  useLazyGetVpnStateSnapshotsQuery,
  useListMakesQuery,
  useLazyListMakesQuery,
  useCreateMakeMutation,
  useGetMakeQuery,
  useLazyGetMakeQuery,
  useUpdateMakeMutation,
  useDeleteMakeMutation,
  useBulkUpsertMakesMutation,
  useListModelsQuery,
  useLazyListModelsQuery,
  useCreateModelMutation,
  useGetModelQuery,
  useLazyGetModelQuery,
  useUpdateModelMutation,
  useDeleteModelMutation,
  useBulkUpsertModelsMutation,
  useListAllCapabilitySetsQuery,
  useLazyListAllCapabilitySetsQuery,
  useListCapabilitySetsQuery,
  useLazyListCapabilitySetsQuery,
  useCreateCapabilitySetMutation,
  useGetCapabilitySetQuery,
  useLazyGetCapabilitySetQuery,
  useUpdateCapabilitySetMutation,
  useDeleteCapabilitySetMutation,
  useSubmitDerCommandMutation,
  useReadDerCommandCapabilitiesQuery,
  useLazyReadDerCommandCapabilitiesQuery,
  useReadDerCommandQuery,
  useLazyReadDerCommandQuery,
  useCreateCurtailmentOverrideMutation,
  useRevokeCurtailmentOverrideMutation,
  useGetMeterSnapshotQuery,
  useLazyGetMeterSnapshotQuery,
  useGetMeterSamplesQuery,
  useLazyGetMeterSamplesQuery,
  useCreateNoteMutation,
  useGetNotesQuery,
  useLazyGetNotesQuery,
  useGetNoteQuery,
  useLazyGetNoteQuery,
  useUpdateNoteMutation,
  useDeleteNoteMutation,
  useCreateEnergySystemMutation,
  useListEnergySystemsQuery,
  useLazyListEnergySystemsQuery,
  useGetSitePowerFlowSummaryQuery,
  useLazyGetSitePowerFlowSummaryQuery,
  useGetSitePowerFlowHistoryQuery,
  useLazyGetSitePowerFlowHistoryQuery,
  useListUnplacedAssetsQuery,
  useLazyListUnplacedAssetsQuery,
  useGetEnergySystemQuery,
  useLazyGetEnergySystemQuery,
  useUpdateEnergySystemMutation,
  useDeleteEnergySystemMutation,
  useAddEnergySystemComponentMutation,
  useReplaceEnergySystemComponentMutation,
  useDeleteEnergySystemComponentMutation,
  useApplyEnergySystemChangesMutation,
  useAddEnergySystemMeasurementPointMutation,
  useReplaceEnergySystemMeasurementPointMutation,
  useDeleteEnergySystemMeasurementPointMutation,
  useGetEnergySystemCoverageQuery,
  useLazyGetEnergySystemCoverageQuery,
  useGetEnergySystemLayoutQuery,
  useLazyGetEnergySystemLayoutQuery,
  useReplaceEnergySystemLayoutMutation,
  useResetEnergySystemLayoutMutation,
  useAddEnergySystemConnectionMutation,
  useDeleteEnergySystemConnectionMutation,
  useListEnergySystemArchetypesQuery,
  useLazyListEnergySystemArchetypesQuery,
  useListEmsPlacementsQuery,
  useLazyListEmsPlacementsQuery,
  useGetEmsPlacementQuery,
  useLazyGetEmsPlacementQuery,
  useSetEmsPlacementMutation,
  useSweepScopeMutation,
  useGetSynoplinksQuery,
  useLazyGetSynoplinksQuery,
  useCreateSynoplinkMutation,
  useGetSynoplinkQuery,
  useLazyGetSynoplinkQuery,
  useUpdateSynoplinkMutation,
  useGetConnectivityStatusQuery,
  useLazyGetConnectivityStatusQuery,
  useGetDevicesBySynoplinkQuery,
  useLazyGetDevicesBySynoplinkQuery,
  useGetComponentConfigQuery,
  useLazyGetComponentConfigQuery,
  useGetOcppProxyConfigQuery,
  useLazyGetOcppProxyConfigQuery,
  useReplaceOcppProxyConfigMutation,
  useDeleteOcppProxyConfigMutation,
  useGetOcppProxyModeQuery,
  useLazyGetOcppProxyModeQuery,
  useReplaceOcppProxyModeMutation,
  useReplaceOptimizerConfigMutation,
  useDeleteOptimizerConfigMutation,
  useReplaceSitePowerManagerConfigMutation,
  useDeleteSitePowerManagerConfigMutation,
  useReplaceRelayConfigMutation,
  useDeleteRelayConfigMutation,
  useReplaceDefaultPowerPlannerConfigMutation,
  useDeleteDefaultPowerPlannerConfigMutation,
  useReplaceAstroConfigMutation,
  useDeleteAstroConfigMutation,
  useGetLoggingPostureQuery,
  useLazyGetLoggingPostureQuery,
  useReplaceLoggingPostureMutation,
  useDeleteLoggingPostureMutation,
  useGetNetworkConfigQuery,
  useLazyGetNetworkConfigQuery,
  useReplaceNetworkConfigMutation,
  useDeleteNetworkConfigMutation,
  useTriggerNetworkScanMutation,
  useListNetworkScansQuery,
  useLazyListNetworkScansQuery,
  useGetDeviceReachabilityQuery,
  useLazyGetDeviceReachabilityQuery,
  useGetNetworkScanQuery,
  useLazyGetNetworkScanQuery,
  useGetNetworkScanReportQuery,
  useLazyGetNetworkScanReportQuery,
  useGetBatteriesV2Query,
  useLazyGetBatteriesV2Query,
  useGetLinkControlsQuery,
  useLazyGetLinkControlsQuery,
  useUpdateLinkControlsMutation,
  useUpdateLinkControlsPanelMutation,
  usePutLinkControlsPanelMutation,
  useDeleteLinkControlsPanelMutation,
  usePutManagedChargerMutation,
  useUpdateManagedChargerMutation,
  useDeleteManagedChargerMutation,
  useUpdateLinkControlsFallbacksMutation,
  useImportLinkControlsMutation,
  useReplaceRawLinkControlsMutation,
  useCreateProbeMutation,
  useGetProbeQuery,
  useLazyGetProbeQuery
} = injectedRtkApi
